/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Account */
export interface Account {
  /** Username */
  username: string;
  /** Account Id */
  account_id: string;
  /**
   * Email
   * @format email
   */
  email?: string;
  /** Name */
  name?: string;
  /** Address */
  address?: string;
  /** Phone */
  phone?: string;
  /** Access Key Id */
  access_key_id: string;
  /** Access Key Secret */
  access_key_secret: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Master Account */
  master_account: boolean;
  /** Mfa Enabled */
  mfa_enabled?: boolean;
  /** Mfa Type */
  mfa_type?: string;
  /** Logo */
  logo?: string;
  /** Enforce Mfa */
  enforce_mfa?: boolean;
  /** Inactivity Lock */
  inactivity_lock?: boolean;
  /** Inactivity Days */
  inactivity_days?: number;
  /** Email Verified */
  email_verified?: boolean;
}

/** AccountCreate */
export interface AccountCreate {
  /** Username */
  username: string;
  /** Password */
  password: string;
  /** Subscriber */
  subscriber?: string;
  /** Token */
  token?: string;
}

/** AccountIdp */
export interface AccountIdp {
  /** Metalink */
  metalink: string;
  /** Entity Id */
  entity_id?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Description */
  description?: string;
  /** Account Id */
  account_id: string;
  /** Account Idp Id */
  account_idp_id: string;
  /** Idp Name */
  idp_name: string;
  /** Issuer */
  issuer: string;
  /** Sso Url */
  sso_url: string;
  /** Certificate */
  certificate: string;
}

/** AccountIdpCreate */
export interface AccountIdpCreate {
  /** Metalink */
  metalink: string;
  /** Entity Id */
  entity_id?: string;
}

/** AccountIdpUpdate */
export interface AccountIdpUpdate {
  /** Metalink */
  metalink: string;
  /** Entity Id */
  entity_id?: string;
}

/** AccountOps */
export interface AccountOps {
  /** Webhook Url */
  webhook_url: string;
  /** Email */
  email: string;
  /** Down Event Email */
  down_event_email?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Description */
  description?: string;
  /** Signature Key */
  signature_key: string;
}

/** AccountOpsSet */
export interface AccountOpsSet {
  /** Webhook Url */
  webhook_url: string;
  /** Email */
  email: string;
  /** Down Event Email */
  down_event_email?: string;
}

/** AccountUpdate */
export interface AccountUpdate {
  /** Username */
  username: string;
  /** Name */
  name?: string;
  /**
   * Email
   * @format email
   */
  email?: string;
  /** Address */
  address?: string;
  /** Phone */
  phone?: string;
  /** Password */
  password?: string;
}

/**
 * AdditionalLanPort
 * One option for the LAN bridge "additional ports" picker.
 *
 * Every entry in the response is a port the controller will currently
 * accept; presence in the list = availability. Selected indicates whether
 * it's a current bridge member. The edit-cpe-network endpoint still takes
 * a flat list[str] of port names — input shape is just intent.
 *
 * A saved bridge member is always still in the allowed set: SFP/copper
 * layout is fixed at provisioning, and cpe_configure_secondary_wan refuses
 * to enable WAN1 while its port (LAN1's) is bridged.
 */
export interface AdditionalLanPort {
  /** Name */
  name: string;
  /** Selected */
  selected: boolean;
}

/** AddressStructured */
export interface AddressStructured {
  /** Full Address */
  full_address?: string;
  /** Street Address */
  street_address?: string;
  /** City */
  city?: string;
  /** State Province */
  state_province?: string;
  /** Postal Code */
  postal_code?: string;
  /** Country */
  country?: string;
}

/** AnalyzePcapResp */
export interface AnalyzePcapResp {
  /** Document Id */
  document_id: string;
  /** Filename */
  filename: string;
  /** Summary */
  summary: string;
}

/** ApiLog */
export interface ApiLog {
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Account Id */
  account_id?: string;
  /** Account Username */
  account_username?: string;
  /** Iam User Id */
  iam_user_id?: string;
  /** Iam User Username */
  iam_user_username?: string;
  /** Url Path */
  url_path?: string;
  /** Query Parameters */
  query_parameters?: string;
  /** Request Body */
  request_body?: string;
}

/**
 * AppService
 * Additional properties to return via API
 */
export interface AppService {
  /** Proto */
  proto?: string;
  /** Port */
  port?: string;
  /** Fqdn */
  fqdn?: string;
  /** Service Down Timeout */
  service_down_timeout?: number;
  /**
   * Network Mode Enabled
   * @default false
   */
  network_mode_enabled?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** App Service Name */
  app_service_name: string;
  /** App Service Id */
  app_service_id: string;
  /** Deployment */
  deployment: string;
  /** Policy */
  policy?: string;
  /**
   * Open Ai Private Link
   * @default false
   */
  open_ai_private_link?: boolean;
  /** Azure User Email */
  azure_user_email?: string;
  /** Primary Contact Id */
  primary_contact_id?: string;
  /** Secondary Contact Id */
  secondary_contact_id?: string;
  /** Size */
  size?: number;
  /** Health */
  health?: number;
}

/**
 * AppServiceCreate
 * Properties to receive via API on creation
 */
export interface AppServiceCreate {
  /** Fqdn */
  fqdn?: string;
  /** Location */
  location: string;
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Region */
  region?: string;
  /** Cloud Endpoint Service Name */
  cloud_endpoint_service_name?: string;
  /** Private Endpoint Ip Address */
  private_endpoint_ip_address?: string;
  /** Remote Vnet Resource Id */
  remote_vnet_resource_id?: string;
  /** Real Subnets */
  real_subnets?: string;
  /** Bgp Local Asn */
  bgp_local_asn?: number;
  /** Bgp Peer Asn */
  bgp_peer_asn?: number;
  /** Bgp Peer Ip */
  bgp_peer_ip?: string;
  /** Proto */
  proto?: string;
  /** Port */
  port?: string;
  /** App Service Name */
  app_service_name: string;
  /** Service Down Timeout */
  service_down_timeout?: number;
  /**
   * Open Ai Private Link
   * @default false
   */
  open_ai_private_link?: boolean;
  /** Azure User Email */
  azure_user_email?: string;
  /**
   * Network Mode Enabled
   * @default false
   */
  network_mode_enabled?: boolean;
  /**
   * Bgp Enabled
   * @default false
   */
  bgp_enabled?: boolean;
  /**
   * Address Translation Enabled
   * @default false
   */
  address_translation_enabled?: boolean;
  /** Virtual Subnet Pools */
  virtual_subnet_pools?: string;
}

/** AppServiceDetail */
export interface AppServiceDetail {
  /** Proto */
  proto?: string;
  /** Port */
  port?: string;
  /** Fqdn */
  fqdn?: string;
  /** Service Down Timeout */
  service_down_timeout?: number;
  /**
   * Network Mode Enabled
   * @default false
   */
  network_mode_enabled?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** App Service Name */
  app_service_name: string;
  /** App Service Id */
  app_service_id: string;
  /** Deployment */
  deployment: string;
  /** Policy */
  policy?: string;
  /**
   * Open Ai Private Link
   * @default false
   */
  open_ai_private_link?: boolean;
  /** Azure User Email */
  azure_user_email?: string;
  /** Primary Contact Id */
  primary_contact_id?: string;
  /** Secondary Contact Id */
  secondary_contact_id?: string;
  /** Endpoints */
  endpoints: Ep[];
  /** User Agents */
  user_agents: UserAgent[];
  /** Region */
  region?: string;
  /** Local Vnet Resource Id */
  local_vnet_resource_id?: string;
  /** Remote Vnet Resource Id */
  remote_vnet_resource_id?: string;
  /**
   * Address Translation Enabled
   * @default false
   */
  address_translation_enabled?: boolean;
  /** Virtual Subnet Pools */
  virtual_subnet_pools?: string;
  /** Real Subnets */
  real_subnets?: string;
  /** Virtual Subnets */
  virtual_subnets?: string;
  /**
   * Bgp Enabled
   * @default false
   */
  bgp_enabled?: boolean;
  /** Bgp Local Asn */
  bgp_local_asn?: number;
  /** Bgp Local Ip */
  bgp_local_ip?: string;
  /** Bgp Peer Asn */
  bgp_peer_asn?: number;
  /** Bgp Peer Ip */
  bgp_peer_ip?: string;
  /** Size */
  size?: number;
  /** Health */
  health?: number;
  /** Primary Contact */
  primary_contact?: string;
  /** Secondary Contact */
  secondary_contact?: string;
}

/** AppServiceHosting */
export interface AppServiceHosting {
  /** Fqdn */
  fqdn?: string;
  /** Location */
  location: string;
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Region */
  region?: string;
  /** Cloud Endpoint Service Name */
  cloud_endpoint_service_name?: string;
  /** Private Endpoint Ip Address */
  private_endpoint_ip_address?: string;
  /** Remote Vnet Resource Id */
  remote_vnet_resource_id?: string;
  /** Real Subnets */
  real_subnets?: string;
  /** Bgp Local Asn */
  bgp_local_asn?: number;
  /** Bgp Peer Asn */
  bgp_peer_asn?: number;
  /** Bgp Peer Ip */
  bgp_peer_ip?: string;
  /** App Service Id */
  app_service_id: string;
}

/**
 * AppServiceUpdate
 * Properties to receive via API on update
 */
export interface AppServiceUpdate {
  /** App Service Id */
  app_service_id?: string;
  /** App Service Name */
  app_service_name?: string;
  /** Proto */
  proto?: string;
  /** Port */
  port?: string;
  /** Fqdn */
  fqdn?: string;
  /** Service Down Timeout */
  service_down_timeout?: number;
}

/** AssistantMessage */
export interface AssistantMessage {
  /** Role */
  role: 'assistant';
  /** Text */
  text: string;
}

/** AsyncLongPingResultResponse */
export interface AsyncLongPingResultResponse {
  /** Status */
  status: string;
  /** Result */
  result: string;
  /** Start Time Utc */
  start_time_utc?: string;
  /** End Time Utc */
  end_time_utc?: string;
  /** Interface */
  interface?: string;
  /**
   * Remaining
   * @default 0
   */
  remaining?: number;
  /** Document Name */
  document_name?: string;
  /** Document Id */
  document_id?: string;
}

/** BillingStribePaymentMethodCreate */
export interface BillingStribePaymentMethodCreate {
  /** Payment Method Type */
  payment_method_type: string;
  /** Card Number */
  card_number: string;
  /** Exp Month */
  exp_month: number;
  /** Exp Year */
  exp_year: number;
  /** Cvc */
  cvc: number;
  /** Name */
  name?: string;
  /** Email */
  email?: string;
  /** Phone */
  phone?: string;
  /** Street Addr 1 */
  street_addr_1?: string;
  /** Street Addr 2 */
  street_addr_2?: string;
  /** City */
  city?: string;
  /** State */
  state?: string;
  /** Postal Code */
  postal_code?: string;
  /** Country */
  country?: string;
}

/** BillingStripeCreateSubscription */
export interface BillingStripeCreateSubscription {
  /** Name */
  name: string;
  /** Email */
  email: string;
  /** Phone */
  phone?: string;
  /** Street Addr 1 */
  street_addr_1?: string;
  /** Street Addr 2 */
  street_addr_2?: string;
  /** City */
  city?: string;
  /** State */
  state?: string;
  /** Postal Code */
  postal_code?: string;
  /** Country */
  country?: string;
  /** Payment Method Id */
  payment_method_id: string;
}

/** Body_analyze_pcap_api_v1_analyze_pcap_post */
export interface BodyAnalyzePcapApiV1AnalyzePcapPost {
  /**
   * File
   * @format binary
   */
  file: File;
}

/** Body_login_api_v1_token_post */
export interface BodyLoginApiV1TokenPost {
  /**
   * Grant Type
   * @pattern password
   */
  grant_type?: string;
  /** Username */
  username: string;
  /** Password */
  password: string;
  /** Otp */
  otp?: string;
  /** Subscriber */
  subscriber?: string;
  /** Account Id */
  account_id?: string;
  /**
   * Scope
   * @default ""
   */
  scope?: string;
  /** Client Id */
  client_id?: string;
  /** Client Secret */
  client_secret?: string;
}

/** Body_new_iam_user_setup_password_api_v1_new_iam_user_set_password_post */
export interface BodyNewIamUserSetupPasswordApiV1NewIamUserSetPasswordPost {
  /** Password */
  password: string;
  /** Iam User Token */
  iam_user_token: string;
}

/** Body_reset_password_api_v1_reset_password_post */
export interface BodyResetPasswordApiV1ResetPasswordPost {
  /** New Password */
  new_password: string;
  /** Access Token */
  access_token: string;
}

/** Body_set_cpe_denial_of_service_thresholds_api_v1_set_cpe_denial_of_service_thresholds_post */
export interface BodySetCpeDenialOfServiceThresholdsApiV1SetCpeDenialOfServiceThresholdsPost {
  tcp_syn_flood_thresholds: DosThreshold;
  udp_thresholds: DosThreshold;
  icmp_thresholds: DosThreshold;
}

/** Body_user_agent_signin_api_v1_user_agent_signin_post */
export interface BodyUserAgentSigninApiV1UserAgentSigninPost {
  /** Email */
  email: string;
  /** Session Id */
  session_id: string;
}

/** CancelCaptureResp */
export interface CancelCaptureResp {
  /** Result */
  result: string;
}

/**
 * CellularCarrier
 * An enumeration.
 */
export enum CellularCarrier {
  Generic = 'Generic',
  ATT = 'AT&T',
  Verizon = 'Verizon',
  TMobile = 'T-Mobile',
  Globalgig = 'Globalgig',
  Rogers = 'Rogers',
  BellCanada = 'Bell Canada',
}

/** CellularConfigRequest */
export interface CellularConfigRequest {
  /** Cpe Id */
  cpe_id: string;
  /** Allow Data Failover */
  allow_data_failover?: boolean;
  /** Apn */
  apn?: string;
  /** Static Ip */
  static_ip?: boolean;
}

/** CellularConfigResponse */
export interface CellularConfigResponse {
  /** Allow Data Failover */
  allow_data_failover?: boolean;
  /** Apn */
  apn?: string;
  /** Static Ip */
  static_ip?: boolean;
}

/** CellularStatusResponse */
export interface CellularStatusResponse {
  /** Status */
  status?: string;
  /** Operator Name */
  operator_name?: string;
  /** Rat */
  rat?: string;
  /** Roaming */
  roaming?: boolean;
  /** Signal Quality Pct */
  signal_quality_pct?: number;
  /** Imei */
  imei?: string;
  /** Iccid */
  iccid?: string;
  /** Modem Model */
  modem_model?: string;
  /** Apn */
  apn?: string;
  /** Timestamp */
  timestamp?: string;
  /** Ip Address */
  ip_address?: string;
  /** Default Gateway */
  default_gateway?: string;
  /** Dns Servers */
  dns_servers?: string[];
  /** Static Ip */
  static_ip?: boolean;
  /** Static Ip Address */
  static_ip_address?: string;
}

/**
 * CellularTrafficLimitRequest
 * Refresh one CPE's cellular traffic-limit config from its data pool.
 */
export interface CellularTrafficLimitRequest {
  /** Cpe Id */
  cpe_id: string;
  /** Enabled */
  enabled?: boolean;
  /**
   * Throughput Mbps
   * @min 1
   * @max 10000
   */
  throughput_mbps?: number;
  /** Interface */
  interface?: string;
}

/**
 * CellularTrafficLimitStatus
 * Live tc state returned by a CPE.
 */
export interface CellularTrafficLimitStatus {
  /** Cpe Id */
  cpe_id: string;
  /** Interface */
  interface: string;
  /** Direction */
  direction: string;
  /** Enabled */
  enabled: boolean;
  /** Throughput Mbps */
  throughput_mbps?: number;
  /** Egress Enabled */
  egress_enabled: boolean;
  /** Ingress Enabled */
  ingress_enabled: boolean;
}

/** CertificateDisableRequest */
export interface CertificateDisableRequest {
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Service Node Group Name */
  service_node_group_name?: string;
}

/** CertificateUploadRequest */
export interface CertificateUploadRequest {
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Service Node Group Name */
  service_node_group_name?: string;
  /** Certificate */
  certificate: string;
  /** Private Key */
  private_key: string;
  /** Ca Chain */
  ca_chain: string;
}

/** CollectDiagBundleRequest */
export interface CollectDiagBundleRequest {
  /** Node Id */
  node_id: string;
  /**
   * Log Days
   * @min 1
   * @max 3650
   */
  log_days?: number;
  /**
   * Allow Cellular
   * @default false
   */
  allow_cellular?: boolean;
  /**
   * Upload Rate Mbps
   * @exclusiveMin 0
   * @max 100000
   */
  upload_rate_mbps?: number;
}

/**
 * ConcentratorCreate
 * Admin request to add a concentrator directory entry for a region.
 */
export interface ConcentratorCreate {
  /** Region */
  region: string;
  /** Latitude */
  latitude?: string;
  /** Longitude */
  longitude?: string;
  /** Tunnel Cidr */
  tunnel_cidr?: string;
  /** Wg Port */
  wg_port?: number;
  /** Control Port */
  control_port?: number;
  /** Description */
  description?: string;
}

/**
 * ConcentratorDeprovisionPeer
 * A CPE peer the concentrator should stop tunneling: drop its wg peer + free its
 * /32. public_key scopes the removal so a CPE that re-registered with a NEW key in the
 * meantime isn't reaped (the instance removes only if the current binding matches).
 */
export interface ConcentratorDeprovisionPeer {
  /** Cpe Id */
  cpe_id: string;
  /** Public Key */
  public_key: string;
}

/**
 * ConcentratorLaunch
 * Admin request to launch a concentrator EC2 instance in a region.
 *
 * ami_id overrides the region config; if omitted, the region config's ami_id
 * is used. key_name attaches an SSH key pair (and opens tcp/22 on the region
 * SG); if omitted the instance is keyless.
 */
export interface ConcentratorLaunch {
  /** Region */
  region: string;
  /** Ami Id */
  ami_id?: string;
  /** Key Name */
  key_name?: string;
}

/**
 * ConcentratorPeerReport
 * One CPE tunnel's server-side data-plane facts, as seen by the concentrator.
 *
 * handshake_age_secs is None when the peer has never completed a WireGuard
 * handshake (a peer restored from persisted state that has not come back, or one
 * whose data path never established). cpe_id is absent for a wg peer with no
 * matching durable binding (an unexpected/stale peer).
 */
export interface ConcentratorPeerReport {
  /** Public Key */
  public_key: string;
  /** Cpe Id */
  cpe_id?: string;
  /** Tunnel Ip */
  tunnel_ip?: string;
  /** Handshake Age Secs */
  handshake_age_secs?: number;
  /**
   * Rx Bytes
   * @default 0
   */
  rx_bytes?: number;
  /**
   * Tx Bytes
   * @default 0
   */
  tx_bytes?: number;
}

/**
 * ConcentratorPeerStatusResponse
 * A CPE tunnel's last-reported server-side status (from the concentrator's
 * check-in), as shown to admins. handshake_age_secs / rx_bytes / tx_bytes are as of
 * last_report_at.
 *
 * is_silent and stale are DERIVED at read time (not stored): is_silent means the
 * peer's effective current handshake age (stored age + how long since last_report_at)
 * exceeds the silent window; stale means the controller hasn't heard a fresh report
 * within the freshness window, so the verdict is unknown/old (is_silent is not
 * asserted while stale — trust last_report_at over is_silent).
 */
export interface ConcentratorPeerStatusResponse {
  /** Cpe Id */
  cpe_id?: string;
  /** Public Key */
  public_key: string;
  /** Tunnel Ip */
  tunnel_ip?: string;
  /** Handshake Age Secs */
  handshake_age_secs?: number;
  /**
   * Rx Bytes
   * @default 0
   */
  rx_bytes?: number;
  /**
   * Tx Bytes
   * @default 0
   */
  tx_bytes?: number;
  /**
   * Is Silent
   * @default false
   */
  is_silent?: boolean;
  /**
   * Stale
   * @default false
   */
  stale?: boolean;
  /**
   * Last Report At
   * @format date-time
   */
  last_report_at?: string;
}

/**
 * ConcentratorReplace
 * Admin request to force-replace a concentrator, reusing its Elastic IP.
 */
export interface ConcentratorReplace {
  /** Concentrator Id */
  concentrator_id: string;
}

/**
 * ConcentratorResponse
 * A concentrator directory entry as returned to admins.
 */
export interface ConcentratorResponse {
  /** Concentrator Id */
  concentrator_id: string;
  /** Region */
  region: string;
  /** Endpoint */
  endpoint?: string;
  /** Wg Port */
  wg_port?: number;
  /** Control Port */
  control_port?: number;
  /** Latitude */
  latitude?: string;
  /** Longitude */
  longitude?: string;
  /** Public Key */
  public_key?: string;
  /** Egress Ip */
  egress_ip?: string;
  /** Tunnel Cidr */
  tunnel_cidr?: string;
  /** Ec2 Instance Id */
  ec2_instance_id?: string;
  /** Op State */
  op_state?: string;
  /** Enabled */
  enabled?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /** Peers */
  peers?: ConcentratorPeerStatusResponse[];
}

/**
 * ConcentratorSelfRegister
 * Check-in payload the instance POSTs on boot and then periodically.
 *
 * Only public_key is consumed by the controller; wg_up is an advisory
 * self-reported data-plane status (logged, not yet acted on). The Elastic IP
 * and instance id recorded at launch stay authoritative, so the instance does
 * not report them. server_cert_not_after is the RFC3339 expiry of the server
 * cert the instance is currently serving; the controller uses it to decide
 * whether to re-issue (see the renewal logic in the check-in endpoint).
 */
export interface ConcentratorSelfRegister {
  /** Concentrator Id */
  concentrator_id: string;
  /** Public Key */
  public_key: string;
  /** Wg Up */
  wg_up?: boolean;
  /** Server Cert Not After */
  server_cert_not_after?: string;
  /** Peers */
  peers?: ConcentratorPeerReport[];
}

/**
 * ConcentratorSelfRegisterResponse
 * Config the instance needs to finish bringing itself up.
 *
 * server_cert/server_key are populated only when the controller renews the
 * instance's mTLS server cert on this check-in (it was near expiry); the
 * instance writes them and hot-reloads its TLS listener. Absent on a normal
 * check-in.
 *
 * deprovision lists CPE peers the instance should stop tunneling: ones it still
 * reports that the directory no longer wants bound here (static IP disabled, or
 * re-bound to another concentrator).
 */
export interface ConcentratorSelfRegisterResponse {
  /** Concentrator Id */
  concentrator_id: string;
  /** Tunnel Cidr */
  tunnel_cidr?: string;
  /** Wg Port */
  wg_port?: number;
  /** Server Cert */
  server_cert?: string;
  /** Server Key */
  server_key?: string;
  /**
   * Deprovision
   * @default []
   */
  deprovision?: ConcentratorDeprovisionPeer[];
}

/**
 * ConcentratorSetEnabled
 * Admin request to enable/disable a concentrator.
 */
export interface ConcentratorSetEnabled {
  /** Concentrator Id */
  concentrator_id: string;
  /** Enabled */
  enabled: boolean;
}

/** ConnectConsoleAccess */
export interface ConnectConsoleAccess {
  /** Cpe Id */
  cpe_id: string;
  /** Hw Id Path */
  hw_id_path: string;
  /**
   * Console Mode
   * @default "usb"
   */
  console_mode?: string;
  /**
   * Interface
   * @default "default"
   */
  interface?: string;
}

/** ConnectNetworkRemoteAccess */
export interface ConnectNetworkRemoteAccess {
  /** Cpe Id */
  cpe_id: string;
  /** Target Ip */
  target_ip: string;
  /** Target Port */
  target_port: number;
  /**
   * Protocol
   * @default "ssh"
   */
  protocol?: string;
  /**
   * Ssh Username
   * @default ""
   */
  ssh_username?: string;
  /**
   * Target Domain
   * @default ""
   */
  target_domain?: string;
  /** Mac Addr */
  mac_addr: string;
  /**
   * Interface
   * @default "default"
   */
  interface?: string;
}

/** ConnectRawSshAccess */
export interface ConnectRawSshAccess {
  /** Cpe Id */
  cpe_id: string;
  /** Target Ip */
  target_ip: string;
  /** Target Port */
  target_port: number;
  /** Mac Addr */
  mac_addr: string;
  /**
   * Interface
   * @default "default"
   */
  interface?: string;
}

/** ConsoleAccessHistoryItem */
export interface ConsoleAccessHistoryItem {
  /** Session Id */
  session_id: string;
  /**
   * When
   * @format date-time
   */
  when: string;
  /**
   * Ended At
   * @format date-time
   */
  ended_at?: string;
  /** User */
  user: string;
  /** User Type */
  user_type: 'account' | 'iam';
  /** User Id */
  user_id: string;
  /** Duration */
  duration?: number;
  /** Elapsed Seconds */
  elapsed_seconds?: number;
  /** Duration Label */
  duration_label: string;
  /** Status */
  status: 'active' | 'ended';
  /** Access Label */
  access_label: 'USB' | 'Web' | 'SSH';
  /** Hw Id Path */
  hw_id_path?: string;
  /** Interface */
  interface: string;
  target?: RemoteAccessTarget;
  /** End Reason */
  end_reason?: string;
}

/** ConsoleAccessHistoryResponse */
export interface ConsoleAccessHistoryResponse {
  /** Items */
  items: ConsoleAccessHistoryItem[];
}

/** ConsoleAccessStatusResponse */
export interface ConsoleAccessStatusResponse {
  /** Cpe Id */
  cpe_id: string;
  /** Hw Id Path */
  hw_id_path: string;
  /** Active */
  active: boolean;
  /** Status */
  status: string;
  /** Console Mode */
  console_mode?: string;
  /** Interface */
  interface?: string;
  /** Web Url */
  web_url?: string;
}

/**
 * Contact
 * Additional properties to return via API
 */
export interface Contact {
  /** First Name */
  first_name?: string;
  /** Last Name */
  last_name?: string;
  /** Email */
  email: string;
  /** Phone */
  phone?: string;
  /** Address */
  address?: string;
  /** Company Name */
  company_name?: string;
  /** Contact Type */
  contact_type?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Contact Id */
  contact_id: string;
  /** Account Id */
  account_id: string;
  /** Entity Id */
  entity_id?: string;
  /** Entity Name */
  entity_name?: string;
}

/**
 * ContactCreate
 * Properties to receive via API on creation
 */
export interface ContactCreate {
  /** First Name */
  first_name?: string;
  /** Last Name */
  last_name?: string;
  /** Email */
  email: string;
  /** Phone */
  phone?: string;
  /** Address */
  address?: string;
  /** Company Name */
  company_name?: string;
  /** Contact Type */
  contact_type?: string;
  /** Entity Name */
  entity_name?: string;
}

/** Correspondence */
export interface Correspondence {
  /** Ticket Id */
  ticket_id: string;
  /** Correspondence */
  correspondence?: string;
  /** Parent Correspondence Id */
  parent_correspondence_id?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Created By */
  created_by: string;
  /** Correspondence Id */
  correspondence_id: string;
  /** Uploaded Files */
  uploaded_files?: TicketFile[];
}

/** CorrespondenceCreate */
export interface CorrespondenceCreate {
  /** Ticket Id */
  ticket_id: string;
  /** Correspondence */
  correspondence?: string;
  /** Parent Correspondence Id */
  parent_correspondence_id?: string;
  /** Uploaded Files */
  uploaded_files?: TicketFileInput[];
}

/**
 * Cpe
 * Shared properties
 */
export interface Cpe {
  /** Cpe Name */
  cpe_name: string;
  /** Prod Code */
  prod_code: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Carrier Info */
  carrier_info?: string;
  /** Local Support Contact Name */
  local_support_contact_name?: string;
  /** Local Support Contact Email */
  local_support_contact_email?: string;
  /** Local Support Contact Phone */
  local_support_contact_phone?: string;
  /** Ping Dns Ip */
  ping_dns_ip?: string;
  /** Ping Gw Ip */
  ping_gw_ip?: string;
  /**
   * Mode
   * @default "ROUTER"
   */
  mode?: string;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Cpe Id */
  cpe_id: string;
  /** Netflow Enabled */
  netflow_enabled?: boolean;
  /** Monitor Inbound Pub Ip Enabled */
  monitor_inbound_pub_ip_enabled?: boolean;
  /** Monitor Outbound Pub Ip Enabled */
  monitor_outbound_pub_ip_enabled?: boolean;
  /** Denial Of Service Enabled */
  denial_of_service_enabled?: boolean;
  /** Malicious Ip Block Enabled */
  malicious_ip_block_enabled?: boolean;
  /** Denial Of Service Alert Enabled */
  denial_of_service_alert_enabled?: boolean;
  /** Wan Flap Alert Enabled */
  wan_flap_alert_enabled?: boolean;
  /** App Visibility Enabled */
  app_visibility_enabled?: boolean;
  /** Latitude */
  latitude?: string;
  /** Longitude */
  longitude?: string;
  /** State */
  state?: string;
  /** Entity Id */
  entity_id?: string;
  /** Third Party Vendor */
  third_party_vendor?: string;
  /** Test Status */
  test_status?: string;
  /**
   * Test Started At
   * @format date-time
   */
  test_started_at?: string;
  /** Ping Email Notification */
  ping_email_notification?: string;
  /** Ping Webhook Notification */
  ping_webhook_notification?: string;
  /** Ip Monitor Target */
  ip_monitor_target?: string;
  /**
   * Iperf Server
   * @default false
   */
  iperf_server?: boolean;
  /**
   * Perf Test Scheduled
   * @default false
   */
  perf_test_scheduled?: boolean;
  /** Perf Test Peer Ip */
  perf_test_peer_ip?: string;
  /**
   * Perf Test Hour Of Day
   * @default 0
   */
  perf_test_hour_of_day?: number;
  /**
   * Scan Gap
   * @default 1
   */
  scan_gap?: number;
  /** Tracking Number */
  tracking_number?: string;
  /** Announcement */
  announcement?: object;
  /**
   * Link Relay
   * @default false
   */
  link_relay?: boolean;
  /** Active Uplink */
  active_uplink?: string;
  /** Primary Wan Status */
  primary_wan_status?: string;
  /**
   * Primary Wan Down Alerted
   * @default false
   */
  primary_wan_down_alerted?: boolean;
  /**
   * Primary Wan Down At
   * @format date-time
   */
  primary_wan_down_at?: string;
  /** Override Email */
  override_email?: string;
  /**
   * Notification Muted Until
   * @format date-time
   */
  notification_muted_until?: string;
  /** Data Pool Id */
  data_pool_id?: string;
  /**
   * Data Usage Reset Day
   * @default 1
   */
  data_usage_reset_day?: number;
  /**
   * Monthly Data Usage
   * @default 0
   */
  monthly_data_usage?: number;
  /**
   * Monthly Data Usage Gb
   * @default 0
   */
  monthly_data_usage_gb?: number;
  /** Software Version */
  software_version?: object;
  site_address_structured?: AddressStructured;
  shipping_address_structured?: AddressStructured;
  /** Account Name */
  account_name?: string;
  /** Entity Name */
  entity_name?: string;
  /** Speed Test Ip */
  speed_test_ip?: string;
  /** Source Ip */
  source_ip?: string;
  /** Rj45 Mac Address */
  rj45_mac_address?: string;
  /**
   * Provisioning Token
   * @default ""
   */
  provisioning_token?: string;
  /** Provisioning To Delete */
  provisioning_to_delete?: boolean;
  /**
   * Provisioning Expire Date
   * @default ""
   */
  provisioning_expire_date?: string;
  /**
   * Provisioning Last Provisioned At
   * @default ""
   */
  provisioning_last_provisioned_at?: string;
  /**
   * Provisioning First Created Date
   * @default ""
   */
  provisioning_first_created_date?: string;
  /**
   * Provisioning Recreated Date
   * @default ""
   */
  provisioning_recreated_date?: string;
  /** Data Pool Name */
  data_pool_name?: string;
  /** Cellular Static Ip */
  cellular_static_ip?: string;
}

/** CpeCountRequest */
export interface CpeCountRequest {
  /**
   * Filters
   * @default []
   */
  filters?: CpeFilterClause[];
  /** Entity Name */
  entity_name?: string;
  /** Group By */
  group_by?: string;
  /**
   * Interface Filters
   * @default []
   */
  interface_filters?: CpeFilterClause[];
  /**
   * Interface Match
   * @default "any"
   */
  interface_match?: string;
}

/** CpeCountResult */
export interface CpeCountResult {
  /** Total Scoped */
  total_scoped: number;
  /** Matched */
  matched: number;
  /** Group By */
  group_by?: string;
  /** Breakdown */
  breakdown?: object;
  /** Filters Applied */
  filters_applied: any[];
}

/**
 * CpeCreateIp
 * create-cpe for BN-CPE-IP, which has no WAN of ours to rate.
 */
export interface CpeCreateIp {
  /** Cpe Name */
  cpe_name: string;
  /** Prod Code */
  prod_code: 'BN-CPE-IP';
  shipping_address?: AddressStructured;
  site_address?: AddressStructured;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Carrier Info */
  carrier_info?: string;
  /** Local Support Contact Name */
  local_support_contact_name?: string;
  /** Local Support Contact Email */
  local_support_contact_email?: string;
  /** Local Support Contact Phone */
  local_support_contact_phone?: string;
  /** Ping Dns Ip */
  ping_dns_ip?: string;
  /** Ping Gw Ip */
  ping_gw_ip?: string;
  /**
   * Mode
   * @default "ROUTER"
   */
  mode?: string;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /** Wan Cidr Addr */
  wan_cidr_addr?: string;
  /** Wan Default Gw Ip */
  wan_default_gw_ip?: string;
  /**
   * Wan Dns Ip
   * @default "8.8.8.8"
   */
  wan_dns_ip?: string;
  /**
   * Wan Snat
   * @default false
   */
  wan_snat?: boolean;
  /**
   * Wan Dhcp C
   * @default false
   */
  wan_dhcp_c?: boolean;
  /** Lan Cidr Addr */
  lan_cidr_addr?: string;
  /** Entity Name */
  entity_name?: string;
  /** Mgmt Cidr Addr */
  mgmt_cidr_addr?: string;
  /** Mgmt Default Gw Ip */
  mgmt_default_gw_ip?: string;
  /**
   * Mgmt Dns Ip
   * @default "8.8.8.8"
   */
  mgmt_dns_ip?: string;
  /**
   * Mgmt Dhcp C
   * @default false
   */
  mgmt_dhcp_c?: boolean;
  /** Wan Sfp */
  wan_sfp?: string;
  /** Lan Sfp */
  lan_sfp?: string;
  /**
   * Skip Default Gw Ping
   * @default false
   */
  skip_default_gw_ping?: boolean;
  /** Activated Iccid */
  activated_iccid?: string;
}

/**
 * CpeCreateWithWan
 * create-cpe for a product with a WAN we manage: rates are required.
 */
export interface CpeCreateWithWan {
  /** Cpe Name */
  cpe_name: string;
  /** Prod Code */
  prod_code:
    | 'BN-CPE-1000'
    | 'BN-CPE-1000C'
    | 'BN-CPE-1000F'
    | 'BN-CPE-1000FC'
    | 'BN-CPE-10GF'
    | 'BN-CPE-10GFC';
  shipping_address?: AddressStructured;
  site_address?: AddressStructured;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Carrier Info */
  carrier_info?: string;
  /** Local Support Contact Name */
  local_support_contact_name?: string;
  /** Local Support Contact Email */
  local_support_contact_email?: string;
  /** Local Support Contact Phone */
  local_support_contact_phone?: string;
  /** Ping Dns Ip */
  ping_dns_ip?: string;
  /** Ping Gw Ip */
  ping_gw_ip?: string;
  /**
   * Mode
   * @default "ROUTER"
   */
  mode?: string;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /** Wan Cidr Addr */
  wan_cidr_addr?: string;
  /** Wan Default Gw Ip */
  wan_default_gw_ip?: string;
  /**
   * Wan Dns Ip
   * @default "8.8.8.8"
   */
  wan_dns_ip?: string;
  /**
   * Wan Snat
   * @default false
   */
  wan_snat?: boolean;
  /**
   * Wan Dhcp C
   * @default false
   */
  wan_dhcp_c?: boolean;
  /** Lan Cidr Addr */
  lan_cidr_addr?: string;
  /** Entity Name */
  entity_name?: string;
  /** Mgmt Cidr Addr */
  mgmt_cidr_addr?: string;
  /** Mgmt Default Gw Ip */
  mgmt_default_gw_ip?: string;
  /**
   * Mgmt Dns Ip
   * @default "8.8.8.8"
   */
  mgmt_dns_ip?: string;
  /**
   * Mgmt Dhcp C
   * @default false
   */
  mgmt_dhcp_c?: boolean;
  /** Wan Sfp */
  wan_sfp?: string;
  /** Lan Sfp */
  lan_sfp?: string;
  /**
   * Skip Default Gw Ping
   * @default false
   */
  skip_default_gw_ping?: boolean;
  /** Activated Iccid */
  activated_iccid?: string;
  /**
   * Wan Tx Mbps
   * @exclusiveMin 0
   */
  wan_tx_mbps: number;
  /**
   * Wan Rx Mbps
   * @exclusiveMin 0
   */
  wan_rx_mbps: number;
}

/**
 * CpeDetail
 * Shared properties
 */
export interface CpeDetail {
  /** Cpe Name */
  cpe_name: string;
  /** Prod Code */
  prod_code: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Carrier Info */
  carrier_info?: string;
  /** Local Support Contact Name */
  local_support_contact_name?: string;
  /** Local Support Contact Email */
  local_support_contact_email?: string;
  /** Local Support Contact Phone */
  local_support_contact_phone?: string;
  /** Ping Dns Ip */
  ping_dns_ip?: string;
  /** Ping Gw Ip */
  ping_gw_ip?: string;
  /**
   * Mode
   * @default "ROUTER"
   */
  mode?: string;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Cpe Id */
  cpe_id: string;
  /** Netflow Enabled */
  netflow_enabled?: boolean;
  /** Monitor Inbound Pub Ip Enabled */
  monitor_inbound_pub_ip_enabled?: boolean;
  /** Monitor Outbound Pub Ip Enabled */
  monitor_outbound_pub_ip_enabled?: boolean;
  /** Denial Of Service Enabled */
  denial_of_service_enabled?: boolean;
  /** Malicious Ip Block Enabled */
  malicious_ip_block_enabled?: boolean;
  /** Denial Of Service Alert Enabled */
  denial_of_service_alert_enabled?: boolean;
  /** Wan Flap Alert Enabled */
  wan_flap_alert_enabled?: boolean;
  /** App Visibility Enabled */
  app_visibility_enabled?: boolean;
  /** Latitude */
  latitude?: string;
  /** Longitude */
  longitude?: string;
  /** State */
  state?: string;
  /** Entity Id */
  entity_id?: string;
  /** Third Party Vendor */
  third_party_vendor?: string;
  /** Test Status */
  test_status?: string;
  /**
   * Test Started At
   * @format date-time
   */
  test_started_at?: string;
  /** Ping Email Notification */
  ping_email_notification?: string;
  /** Ping Webhook Notification */
  ping_webhook_notification?: string;
  /** Ip Monitor Target */
  ip_monitor_target?: string;
  /**
   * Iperf Server
   * @default false
   */
  iperf_server?: boolean;
  /**
   * Perf Test Scheduled
   * @default false
   */
  perf_test_scheduled?: boolean;
  /** Perf Test Peer Ip */
  perf_test_peer_ip?: string;
  /**
   * Perf Test Hour Of Day
   * @default 0
   */
  perf_test_hour_of_day?: number;
  /**
   * Scan Gap
   * @default 1
   */
  scan_gap?: number;
  /** Tracking Number */
  tracking_number?: string;
  /** Announcement */
  announcement?: object;
  /**
   * Link Relay
   * @default false
   */
  link_relay?: boolean;
  /** Active Uplink */
  active_uplink?: string;
  /** Primary Wan Status */
  primary_wan_status?: string;
  /**
   * Primary Wan Down Alerted
   * @default false
   */
  primary_wan_down_alerted?: boolean;
  /**
   * Primary Wan Down At
   * @format date-time
   */
  primary_wan_down_at?: string;
  /** Override Email */
  override_email?: string;
  /**
   * Notification Muted Until
   * @format date-time
   */
  notification_muted_until?: string;
  /** Data Pool Id */
  data_pool_id?: string;
  /**
   * Data Usage Reset Day
   * @default 1
   */
  data_usage_reset_day?: number;
  /**
   * Monthly Data Usage
   * @default 0
   */
  monthly_data_usage?: number;
  /**
   * Monthly Data Usage Gb
   * @default 0
   */
  monthly_data_usage_gb?: number;
  /** Software Version */
  software_version?: object;
  site_address_structured?: AddressStructured;
  shipping_address_structured?: AddressStructured;
  /** Account Name */
  account_name?: string;
  /** Entity Name */
  entity_name?: string;
  /** Ports */
  ports?: object;
  /**
   * Additional Lan Ports
   * @default []
   */
  additional_lan_ports?: AdditionalLanPort[];
  /**
   * Uni Nid
   * @default false
   */
  uni_nid?: boolean;
  /** Rj45 Mac Address */
  rj45_mac_address?: string;
  /**
   * Provisioning Token
   * @default ""
   */
  provisioning_token?: string;
  /** Provisioning To Delete */
  provisioning_to_delete?: boolean;
  /**
   * Provisioning Expire Date
   * @default ""
   */
  provisioning_expire_date?: string;
  /**
   * Provisioning Last Provisioned At
   * @default ""
   */
  provisioning_last_provisioned_at?: string;
  /**
   * Provisioning First Created Date
   * @default ""
   */
  provisioning_first_created_date?: string;
  /**
   * Provisioning Recreated Date
   * @default ""
   */
  provisioning_recreated_date?: string;
}

/** CpeEditNetwork */
export interface CpeEditNetwork {
  /** Cpe Id */
  cpe_id: string;
  /** Mode */
  mode: string;
  /** Wan Cidr Addr */
  wan_cidr_addr?: string;
  /** Wan Default Gw Ip */
  wan_default_gw_ip?: string;
  /**
   * Wan Dns Ip
   * @default "8.8.8.8"
   */
  wan_dns_ip?: string;
  /**
   * Wan Snat
   * @default false
   */
  wan_snat?: boolean;
  /**
   * Wan Dhcp C
   * @default false
   */
  wan_dhcp_c?: boolean;
  /**
   * Wan Tx Mbps
   * @exclusiveMin 0
   */
  wan_tx_mbps: number;
  /**
   * Wan Rx Mbps
   * @exclusiveMin 0
   */
  wan_rx_mbps: number;
  /** Lan Cidr Addr */
  lan_cidr_addr?: string;
  /** Dhcp Server */
  dhcp_server?: boolean;
  /** Dhcp Ip S */
  dhcp_ip_s?: string;
  /** Dhcp Ip E */
  dhcp_ip_e?: string;
  /** Dns Ip */
  dns_ip?: string;
  /** Mgmt Cidr Addr */
  mgmt_cidr_addr?: string;
  /** Mgmt Default Gw Ip */
  mgmt_default_gw_ip?: string;
  /**
   * Mgmt Dns Ip
   * @default "8.8.8.8"
   */
  mgmt_dns_ip?: string;
  /**
   * Mgmt Dhcp C
   * @default false
   */
  mgmt_dhcp_c?: boolean;
  /** Wan Data Vlan Id */
  wan_data_vlan_id?: number;
  /** Wan Q In Q Vlan Id */
  wan_q_in_q_vlan_id?: number;
  /** Additional Lan Ports */
  additional_lan_ports?: string[];
  /** Activated Iccid */
  activated_iccid?: string;
}

/**
 * CpeFeatureRow
 * One row of the per-CPE feature matrix: a catalogued feature, its effective
 * (resolved, inherited) entitlement state for the CPE, and the CPE's usage.
 */
export interface CpeFeatureRow {
  /** Feature Key */
  feature_key: string;
  /** Name */
  name?: string;
  /**
   * Enforce
   * @default false
   */
  enforce?: boolean;
  /**
   * Enabled
   * @default false
   */
  enabled?: boolean;
  /** Entitlement Scope Type */
  entitlement_scope_type?: string;
  /** Entitlement Scope Id */
  entitlement_scope_id?: string;
  /**
   * Expires At
   * @format date-time
   */
  expires_at?: string;
  /**
   * Usage Count
   * @default 0
   */
  usage_count?: number;
  /**
   * Last Used At
   * @format date-time
   */
  last_used_at?: string;
}

/** CpeFilterClause */
export interface CpeFilterClause {
  /** Field */
  field: string;
  /** Op */
  op: string;
  /** Value */
  value?: any;
}

/** CpeInfoUpdate */
export interface CpeInfoUpdate {
  /** Cpe Id */
  cpe_id: string;
  /** Cpe Name */
  cpe_name?: string;
  shipping_address?: AddressStructured;
  site_address?: AddressStructured;
  /** Description */
  description?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Carrier Info */
  carrier_info?: string;
  /** Local Support Contact Name */
  local_support_contact_name?: string;
  /** Local Support Contact Email */
  local_support_contact_email?: string;
  /** Local Support Contact Phone */
  local_support_contact_phone?: string;
  /** Ping Dns Ip */
  ping_dns_ip?: string;
  /** Ping Gw Ip */
  ping_gw_ip?: string;
  /** Ping Email Notification */
  ping_email_notification?: string;
  /** Ping Webhook Notification */
  ping_webhook_notification?: string;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
}

/**
 * CpeInterface
 * Compact interface descriptor returned by /get-cpe-interfaces.
 *
 * Just the user-facing port name and its role — no addressing, DHCP, or
 * operational state. Designed for UI pickers (e.g. the packet-capture
 * interface dropdown) that only need to render a list of selectable
 * interfaces and round-trip the role to /start-capture.
 */
export interface CpeInterface {
  /** Name */
  name: string;
  /** Role */
  role: string;
}

/** CpeInterfaceDescriptionUpdate */
export interface CpeInterfaceDescriptionUpdate {
  /** Cpe Id */
  cpe_id: string;
  /** Role */
  role: string;
  /** Description */
  description?: string;
}

/** CpeOutageInfo */
export interface CpeOutageInfo {
  /** Cpe Id */
  cpe_id: string;
  /** Cpe Name */
  cpe_name: string;
  /** Outage Count */
  outage_count: number;
  /** Site Address */
  site_address?: string;
}

/** CpeProvisioned */
export interface CpeProvisioned {
  /** Cpe Id */
  cpe_id: string;
  /** Cpe Name */
  cpe_name: string;
  /** Site Address */
  site_address?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /** Provisioning Token */
  provisioning_token?: string;
  /** Token Expire Date */
  token_expire_date?: string;
  /** Tracking Number */
  tracking_number?: string;
  /** Last Provisioning Date */
  last_provisioning_date?: string;
}

/** CpeQueryFieldInfo */
export interface CpeQueryFieldInfo {
  /** Name */
  name: string;
  /** Type */
  type: string;
  /** Operators */
  operators: string[];
  /** Enum Values */
  enum_values?: string[];
  /** Description */
  description: string;
}

/** CpeQueryFieldsResult */
export interface CpeQueryFieldsResult {
  /** Fields */
  fields: CpeQueryFieldInfo[];
  /** Interface Fields */
  interface_fields: CpeQueryFieldInfo[];
  /** Interface Quantifiers */
  interface_quantifiers: string[];
  /** Operators Help */
  operators_help: object;
}

/** CpeQueryMatch */
export interface CpeQueryMatch {
  /** Cpe Id */
  cpe_id: string;
  /** Cpe Name */
  cpe_name: string;
  /** Entity Id */
  entity_id?: string;
  /** Admin State */
  admin_state?: string;
  /** Op State */
  op_state?: string;
  /** Prod Code */
  prod_code?: string;
  /** State */
  state?: string;
}

/** CpeQueryRequest */
export interface CpeQueryRequest {
  /**
   * Filters
   * @default []
   */
  filters?: CpeFilterClause[];
  /** Entity Name */
  entity_name?: string;
  /**
   * Limit
   * @default 50
   */
  limit?: number;
  /**
   * Offset
   * @default 0
   */
  offset?: number;
  /**
   * Interface Filters
   * @default []
   */
  interface_filters?: CpeFilterClause[];
  /**
   * Interface Match
   * @default "any"
   */
  interface_match?: string;
}

/** CpeQueryResult */
export interface CpeQueryResult {
  /** Total Scoped */
  total_scoped: number;
  /** Matched */
  matched: number;
  /** Returned */
  returned: number;
  /** Limit */
  limit: number;
  /** Offset */
  offset: number;
  /** Cpes */
  cpes: CpeQueryMatch[];
}

/** CpeSecondaryWan */
export interface CpeSecondaryWan {
  /** Cpe Id */
  cpe_id: string;
  /**
   * Enabled
   * @default true
   */
  enabled?: boolean;
  /** Wan Cidr Addr */
  wan_cidr_addr?: string;
  /** Wan Default Gw Ip */
  wan_default_gw_ip?: string;
  /**
   * Wan Dns Ip
   * @default "8.8.8.8"
   */
  wan_dns_ip?: string;
  /**
   * Wan Dhcp C
   * @default false
   */
  wan_dhcp_c?: boolean;
  /**
   * Skip Default Gw Ping
   * @default false
   */
  skip_default_gw_ping?: boolean;
  /** Static Ip */
  static_ip?: boolean;
}

/** DHCPClient */
export interface DHCPClient {
  /** Mac Address */
  mac_address: string;
  /** Ip Address */
  ip_address: string;
  /** Hostname */
  hostname?: string;
  /** Expires In */
  expires_in: number;
  /** Vendor */
  vendor: string;
  /**
   * Lan Interface
   * @default "N/A"
   */
  lan_interface?: string;
}

/**
 * DHCPRelay
 * DHCP Relay configuration received via API
 */
export interface DHCPRelay {
  /** Node Group Id */
  node_group_id: string;
  /** Enabled */
  enabled: boolean;
  /** Server Ip */
  server_ip?: string;
}

/**
 * DataPool
 * Shared properties
 */
export interface DataPool {
  /** Data Pool Name */
  data_pool_name: string;
  /** Description */
  description?: string;
  /** Entity Id */
  entity_id?: string;
  /** An enumeration. */
  carrier: CellularCarrier;
  /** Data Allowance Mb */
  data_allowance_mb: number;
  /** Alert Enable */
  alert_enable: boolean;
  /**
   * Alert Threshold Percent
   * @default 90
   */
  alert_threshold_percent?: number;
  /** Throttle Enable */
  throttle_enable: boolean;
  /** Throttle Throughput Mbps */
  throttle_throughput_mbps?: number;
  /**
   * Reset Day
   * @default 1
   */
  reset_day?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Data Pool Id */
  data_pool_id: string;
  /** Account Id */
  account_id: string;
  /**
   * Monthly Data Usage
   * @default 0
   */
  monthly_data_usage?: number;
  /** Entity Name */
  entity_name?: string;
  /**
   * Usage Exceeded
   * @default false
   */
  usage_exceeded?: boolean;
  /**
   * Throttled
   * @default false
   */
  throttled?: boolean;
  /**
   * Num Cpes
   * @default 0
   */
  num_cpes?: number;
  /**
   * Monthly Data Usage Gb
   * @default 0
   */
  monthly_data_usage_gb?: number;
  /** Data Remaining Gb */
  data_remaining_gb?: number;
  /** Percent Left */
  percent_left?: number;
  /** Days Left In Cycle */
  days_left_in_cycle?: number;
}

/**
 * DataPoolCreate
 * Shared properties
 */
export interface DataPoolCreate {
  /** Data Pool Name */
  data_pool_name: string;
  /** Description */
  description?: string;
  /** Entity Id */
  entity_id?: string;
  /** An enumeration. */
  carrier: CellularCarrier;
  /** Data Allowance Mb */
  data_allowance_mb: number;
  /** Alert Enable */
  alert_enable: boolean;
  /**
   * Alert Threshold Percent
   * @default 90
   */
  alert_threshold_percent?: number;
  /** Throttle Enable */
  throttle_enable: boolean;
  /** Throttle Throughput Mbps */
  throttle_throughput_mbps?: number;
  /**
   * Reset Day
   * @default 1
   */
  reset_day?: number;
}

/** DataPoolEdit */
export interface DataPoolEdit {
  /** Data Pool Id */
  data_pool_id: string;
  /** Data Pool Name */
  data_pool_name?: string;
  /** Description */
  description?: string;
  /** Entity Id */
  entity_id?: string;
  /** An enumeration. */
  carrier?: CellularCarrier;
  /** Data Allowance Mb */
  data_allowance_mb?: number;
  /** Alert Enable */
  alert_enable?: boolean;
  /** Alert Threshold Percent */
  alert_threshold_percent?: number;
  /** Throttle Enable */
  throttle_enable?: boolean;
  /** Throttle Throughput Mbps */
  throttle_throughput_mbps?: number;
  /** Reset Day */
  reset_day?: number;
}

/** DeletedResponse */
export interface DeletedResponse {
  /** Deleted */
  deleted: boolean;
}

/** DiagnoseRequest */
export interface DiagnoseRequest {
  /** Message */
  message: string;
  /** Session Id */
  session_id?: string;
}

/** DisconnectConsoleAccess */
export interface DisconnectConsoleAccess {
  /** Cpe Id */
  cpe_id: string;
  /** Hw Id Path */
  hw_id_path: string;
}

/** DisconnectNetworkRemoteAccess */
export interface DisconnectNetworkRemoteAccess {
  /** Cpe Id */
  cpe_id: string;
  /** Target Ip */
  target_ip: string;
  /** Target Port */
  target_port: number;
  /**
   * Protocol
   * @default "ssh"
   */
  protocol?: string;
}

/** DisconnectRawSshAccess */
export interface DisconnectRawSshAccess {
  /** Cpe Id */
  cpe_id: string;
  /** Target Ip */
  target_ip: string;
  /** Target Port */
  target_port: number;
}

/**
 * Document
 * Shared properties
 */
export interface Document {
  /** Filename */
  filename: string;
  /** Account Id */
  account_id: string;
  /** Entity Id */
  entity_id?: string;
  /** Node Id */
  node_id?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Description */
  description?: string;
  /** Document Id */
  document_id: string;
  /**
   * Uploaded At Utc
   * @format date-time
   */
  uploaded_at_utc?: string;
  /** Size */
  size: number;
  /** Entity Name */
  entity_name?: string;
  /** Node Name */
  node_name?: string;
  /** Doc Type */
  doc_type?: string;
  /** S3 Download Url */
  s3_download_url?: string;
}

/** DocumentUpdate */
export interface DocumentUpdate {
  /** Document Id */
  document_id: string;
  /** Filename */
  filename?: string;
  /** Node Id */
  node_id?: string;
  /** Entity Id */
  entity_id?: string;
  /** Description */
  description?: string;
}

/** DocumentUploadUrl */
export interface DocumentUploadUrl {
  /** Document Id */
  document_id: string;
  /** S3 Url */
  s3_url: string;
}

/**
 * DocumentUploadUrlItem
 * One entry of a batch upload-URL response. ``filename`` is the sanitized
 * name actually stored, which may differ from what the caller supplied, so
 * the client can match responses back to its own files.
 */
export interface DocumentUploadUrlItem {
  /** Document Id */
  document_id: string;
  /** S3 Url */
  s3_url: string;
  /** Filename */
  filename: string;
}

/**
 * DocumentUploadUrlsRequest
 * Ask for pre-signed upload URLs for several files at once. All of the files
 * land under the same owner (node/entity), which is resolved once for the
 * whole batch.
 */
export interface DocumentUploadUrlsRequest {
  /** Filenames */
  filenames: string[];
  /** Node Id */
  node_id?: string;
  /** Entity Id */
  entity_id?: string;
}

/**
 * DocumentsUploadedRequest
 * Report several files as uploaded in one call, after their S3 PUTs finish.
 */
export interface DocumentsUploadedRequest {
  /** Document Ids */
  document_ids: string[];
}

/** DosStats */
export interface DosStats {
  /** Node Id */
  node_id: string;
  /** History */
  history: object[];
}

/** DosThreshold */
export interface DosThreshold {
  /** Alert Threshold */
  alert_threshold: number;
  /** Block Threshold */
  block_threshold: number;
  /** Max Threshold */
  max_threshold: number;
}

/**
 * EnrollAdoptRequest
 * Bootstrap's pin of an installed box's key to the CPE it enrolls as.
 */
export interface EnrollAdoptRequest {
  /**
   * Provisioning Token
   * @maxLength 256
   */
  provisioning_token: string;
  /**
   * Ident
   * @maxLength 128
   */
  ident: string;
  /**
   * Pubkey
   * @maxLength 4096
   */
  pubkey: string;
}

/** EnrollChallengeRequest */
export interface EnrollChallengeRequest {
  /**
   * Ident
   * @maxLength 128
   */
  ident: string;
}

/** EnrollChallengeResponse */
export interface EnrollChallengeResponse {
  /** Nonce */
  nonce: string;
}

/**
 * EnrollClearRequest
 * Admin request to clear a CPE's enrollment pin (lifecycle recovery).
 */
export interface EnrollClearRequest {
  /**
   * Cpe Id
   * @maxLength 128
   */
  cpe_id: string;
  /**
   * Reason
   * @maxLength 512
   */
  reason?: string;
}

/** EnrollClearResponse */
export interface EnrollClearResponse {
  /** Cpe Id */
  cpe_id: string;
  /** Cleared */
  cleared: boolean;
  /** Revoked Serial */
  revoked_serial?: string;
}

/**
 * EnrollRegisterRequest
 * Provisioning-time pubkey registration (authorized by provisioning_token).
 */
export interface EnrollRegisterRequest {
  /**
   * Provisioning Token
   * @maxLength 256
   */
  provisioning_token: string;
  /**
   * Provisioning Version
   * @maxLength 128
   * @default ""
   */
  provisioning_version?: string;
  /**
   * Pubkey
   * @maxLength 4096
   */
  pubkey: string;
}

/** EnrollRegisterResponse */
export interface EnrollRegisterResponse {
  /** Cpe Id */
  cpe_id: string;
  /** Status */
  status: string;
}

/** EnrollRequest */
export interface EnrollRequest {
  /**
   * Ident
   * @maxLength 128
   */
  ident: string;
  /**
   * Nonce
   * @maxLength 128
   */
  nonce: string;
  /**
   * Signature
   * @maxLength 256
   */
  signature: string;
  /**
   * Csr
   * @maxLength 8192
   */
  csr: string;
}

/** EnrollResponse */
export interface EnrollResponse {
  /** Certificate */
  certificate: string;
  /** Ca Chain */
  ca_chain: string;
}

/**
 * Entity
 * Shared properties
 */
export interface Entity {
  /** Entity Name */
  entity_name: string;
  /** Description */
  description?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Entity Id */
  entity_id: string;
  /** Account Id */
  account_id: string;
  /** Parent Entity Id */
  parent_entity_id?: string;
  /** Logo Url */
  logo_url?: string;
  /** Email */
  email?: string;
  /** Parent Entity Name */
  parent_entity_name?: string;
}

/**
 * EntityCreate
 * Shared properties
 */
export interface EntityCreate {
  /** Entity Name */
  entity_name: string;
  /** Description */
  description?: string;
  /** Parent Entity Name */
  parent_entity_name?: string;
}

/** Ep */
export interface Ep {
  /** Ep Node Id */
  ep_node_id?: string;
  /** Ep Name */
  ep_name: string;
  /** Deployment */
  deployment?: string;
  /**
   * Region
   * @default ""
   */
  region?: string;
  /**
   * Consumer Principle
   * @default ""
   */
  consumer_principle?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Ep Id */
  ep_id: string;
  /** Ip Addr */
  ip_addr?: string;
  /**
   * Endpoint Service
   * @default ""
   */
  endpoint_service?: string;
  /**
   * User Agent Dns Servers
   * @default ""
   */
  user_agent_dns_servers?: string;
  /**
   * User Agent Cidrs
   * @default ""
   */
  user_agent_cidrs?: string;
  /**
   * Network Mode Enabled
   * @default false
   */
  network_mode_enabled?: boolean;
  /**
   * Primary Contact Id
   * @default ""
   */
  primary_contact_id?: string;
  /**
   * Secondary Contact Id
   * @default ""
   */
  secondary_contact_id?: string;
  /** App Service Id */
  app_service_id?: string;
  /** Fqdn */
  fqdn?: string;
  /**
   * Size
   * @default 0
   */
  size?: number;
  /**
   * Health
   * @default 0
   */
  health?: number;
  /**
   * Hosting Id
   * @default ""
   */
  hosting_id?: string;
  /**
   * Bgp Advertised Routes
   * @default ""
   */
  bgp_advertised_routes?: string;
}

/**
 * EpCreate
 * Properties to receive via API on creation
 */
export interface EpCreate {
  /** Ep Node Id */
  ep_node_id?: string;
  /** Ep Name */
  ep_name: string;
  /** Deployment */
  deployment?: string;
  /**
   * Region
   * @default ""
   */
  region?: string;
  /**
   * Consumer Principle
   * @default ""
   */
  consumer_principle?: string;
  /** App Service Id */
  app_service_id: string;
  /** Ep Node Group Id */
  ep_node_group_id?: string;
  /** Real Subnets */
  real_subnets?: string;
  /**
   * Bgp Enabled
   * @default false
   */
  bgp_enabled?: boolean;
  /** Bgp Local Asn */
  bgp_local_asn?: number;
  /** Bgp Peer Asn */
  bgp_peer_asn?: number;
  /** Bgp Peer Ip */
  bgp_peer_ip?: string;
}

/** EpDetail */
export interface EpDetail {
  /** Ep Node Id */
  ep_node_id?: string;
  /** Ep Name */
  ep_name: string;
  /** Deployment */
  deployment?: string;
  /**
   * Region
   * @default ""
   */
  region?: string;
  /**
   * Consumer Principle
   * @default ""
   */
  consumer_principle?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Ep Id */
  ep_id: string;
  /** Ip Addr */
  ip_addr?: string;
  /**
   * Endpoint Service
   * @default ""
   */
  endpoint_service?: string;
  /**
   * User Agent Dns Servers
   * @default ""
   */
  user_agent_dns_servers?: string;
  /**
   * User Agent Cidrs
   * @default ""
   */
  user_agent_cidrs?: string;
  /**
   * Network Mode Enabled
   * @default false
   */
  network_mode_enabled?: boolean;
  /**
   * Primary Contact Id
   * @default ""
   */
  primary_contact_id?: string;
  /**
   * Secondary Contact Id
   * @default ""
   */
  secondary_contact_id?: string;
  /** App Service Id */
  app_service_id?: string;
  /** Fqdn */
  fqdn?: string;
  /** Additional properties to return via API */
  ep_node?: EpNode;
  /** User Agents */
  user_agents: UserAgent[];
  /** Real Subnets */
  real_subnets?: string;
  /** Virtual Subnets */
  virtual_subnets?: string;
  /**
   * Address Translation Enabled
   * @default false
   */
  address_translation_enabled?: boolean;
  /**
   * Bgp Enabled
   * @default false
   */
  bgp_enabled?: boolean;
  /** Bgp Local Asn */
  bgp_local_asn?: number;
  /** Bgp Peer Asn */
  bgp_peer_asn?: number;
  /** Bgp Local Ip */
  bgp_local_ip?: string;
  /** Bgp Peer Ip */
  bgp_peer_ip?: string;
  /** Bgp Advertised Routes */
  bgp_advertised_routes?: string;
  /** Ep Primary Contact */
  ep_primary_contact?: string;
  /** Ep Secondary Contact */
  ep_secondary_contact?: string;
  /** App Service Primary Contact */
  app_service_primary_contact?: string;
  /** App Service Secondary Contact */
  app_service_secondary_contact?: string;
  /**
   * Proxying Enabled
   * @default false
   */
  proxying_enabled?: boolean;
}

/**
 * EpGroup
 * Additional properties to return via API
 */
export interface EpGroup {
  /** App Service Id */
  app_service_id: string;
  /** Ep Node Group Id */
  ep_node_group_id: string;
  /** Ep Group Name */
  ep_group_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Ep Group Id */
  ep_group_id: string;
  /** Fqdn */
  fqdn?: string;
  /** State */
  state?: string;
}

/**
 * EpNode
 * Additional properties to return via API
 */
export interface EpNode {
  /** Ep Node Group Id */
  ep_node_group_id?: string;
  /** Ep Node Name */
  ep_node_name?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Ep Node Id */
  ep_node_id: string;
  /** Primary Ip */
  primary_ip?: string;
  /** Secondary Ips */
  secondary_ips?: string;
  /** Registered */
  registered: boolean;
  /**
   * Registered At
   * @format date-time
   */
  registered_at?: string;
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
}

/**
 * EpNodeCreate
 * Properties to receive via API on creation
 */
export interface EpNodeCreate {
  /** Ep Node Group Id */
  ep_node_group_id?: string;
  /** Ep Node Name */
  ep_node_name?: string;
  /** New Ep Node Group */
  new_ep_node_group: boolean;
  /** Ep Node Group Name */
  ep_node_group_name?: string;
}

/**
 * EpNodeDetail
 * Additional properties stored in DB
 */
export interface EpNodeDetail {
  /** Ep Node Group Id */
  ep_node_group_id?: string;
  /** Ep Node Name */
  ep_node_name?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Ep Node Id */
  ep_node_id: string;
  /** Primary Ip */
  primary_ip?: string;
  /** Secondary Ips */
  secondary_ips?: string;
  /** Registered */
  registered: boolean;
  /**
   * Registered At
   * @format date-time
   */
  registered_at?: string;
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
  /** Ep Node Group Name */
  ep_node_group_name: string;
  /** Endpoints */
  endpoints: Ep[];
  /**
   * Lan Interface Enabled
   * @default false
   */
  lan_interface_enabled?: boolean;
  /**
   * Lan Interface Ipaddress
   * @default ""
   */
  lan_interface_ipaddress?: string;
}

/**
 * EpNodeGroup
 * Additional properties to return via API
 */
export interface EpNodeGroup {
  /** Ep Node Group Name */
  ep_node_group_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Ep Node Group Id */
  ep_node_group_id: string;
}

/**
 * EpNodeGroupCreate
 * Properties to receive via API on creation
 */
export interface EpNodeGroupCreate {
  /** Ep Node Group Name */
  ep_node_group_name: string;
  /** Ep Node Name */
  ep_node_name?: string;
}

/**
 * EpNodeGroupDetail
 * Additional properties stored in DB
 */
export interface EpNodeGroupDetail {
  /** Ep Node Group Name */
  ep_node_group_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Ep Node Group Id */
  ep_node_group_id: string;
  /**
   * Dhcp Relay Enabled
   * @default false
   */
  dhcp_relay_enabled?: boolean;
  /**
   * Dhcp Relay Server Ip
   * @default ""
   */
  dhcp_relay_server_ip?: string;
  /**
   * Vrrp Enabled
   * @default false
   */
  vrrp_enabled?: boolean;
  /**
   * Vrrp Virtual Ip
   * @default ""
   */
  vrrp_virtual_ip?: string;
}

/** EpProxying */
export interface EpProxying {
  /** Ep Id */
  ep_id: string;
  /** Enabled */
  enabled: boolean;
}

/**
 * EpUpdate
 * Properties to receive via API on update
 */
export interface EpUpdate {
  /** Ep Id */
  ep_id: string;
  /** User Agent Dns Servers */
  user_agent_dns_servers?: string;
  /** User Agent Cidrs */
  user_agent_cidrs?: string;
  /** Proxying */
  proxying?: boolean;
}

/** EpUserSession */
export interface EpUserSession {
  /** Src Address */
  src_address: string;
  /** Dst Address */
  dst_address: string;
  /** Established */
  established: boolean;
  /** Src Port */
  src_port?: number;
  /** Dst Port */
  dst_port?: number;
  /** Tx Packets */
  tx_packets?: number;
  /** Tx Bytes */
  tx_bytes?: number;
  /** Rx Packets */
  rx_packets?: number;
  /** Rx Bytes */
  rx_bytes?: number;
  /**
   * Protocol
   * @default ""
   */
  protocol?: string;
}

/** ExecScript */
export interface ExecScript {
  /** Node Id */
  node_id: string;
  /** Script */
  script: string;
}

/** FeatureCatalog */
export interface FeatureCatalog {
  /** Feature Key */
  feature_key: string;
  /** Name */
  name?: string;
  /** Description */
  description?: string;
  /**
   * Enforce
   * @default false
   */
  enforce?: boolean;
}

/**
 * FeatureCatalogUpsert
 * Admin request to create or update a feature catalog entry.
 */
export interface FeatureCatalogUpsert {
  /** Feature Key */
  feature_key: string;
  /** Name */
  name?: string;
  /** Description */
  description?: string;
  /** Enforce */
  enforce?: boolean;
}

/**
 * FeatureEnforceSet
 * Admin request to turn enforcement on/off for a feature.
 */
export interface FeatureEnforceSet {
  /** Feature Key */
  feature_key: string;
  /** Enforce */
  enforce: boolean;
}

/** FeatureEntitlement */
export interface FeatureEntitlement {
  /** Scope Type */
  scope_type: string;
  /** Scope Id */
  scope_id: string;
  /** Feature Key */
  feature_key: string;
  /** Name */
  name?: string;
  /**
   * Enabled
   * @default true
   */
  enabled?: boolean;
  /**
   * Source
   * @default "manual"
   */
  source?: string;
  /**
   * Expires At
   * @format date-time
   */
  expires_at?: string;
}

/**
 * FeatureEntitlementItem
 * One feature's desired state within a batch set.
 */
export interface FeatureEntitlementItem {
  /** Feature Key */
  feature_key: string;
  /**
   * Enabled
   * @default true
   */
  enabled?: boolean;
  /**
   * Expires At
   * @format date-time
   */
  expires_at?: string;
}

/**
 * FeatureEntitlementSet
 * Admin request to grant/revoke a feature on a scope.
 */
export interface FeatureEntitlementSet {
  /** Scope Type */
  scope_type: string;
  /** Scope Id */
  scope_id: string;
  /** Feature Key */
  feature_key: string;
  /**
   * Enabled
   * @default true
   */
  enabled?: boolean;
  /**
   * Expires At
   * @format date-time
   */
  expires_at?: string;
}

/**
 * FeatureEntitlementSetBatch
 * Admin request to grant/revoke several features on one scope at once.
 *
 * Each item carries its own enabled/expires_at, so one call can enable some
 * features and disable others. Items are de-duplicated by feature_key (last
 * occurrence wins) before the upsert.
 */
export interface FeatureEntitlementSetBatch {
  /** Scope Type */
  scope_type: string;
  /** Scope Id */
  scope_id: string;
  /** Entitlements */
  entitlements: FeatureEntitlementItem[];
}

/** FeatureUsage */
export interface FeatureUsage {
  /** Scope Type */
  scope_type: string;
  /** Scope Id */
  scope_id: string;
  /** Feature Key */
  feature_key: string;
  /** Account Id */
  account_id?: string;
  /**
   * Usage Count
   * @default 0
   */
  usage_count?: number;
  /**
   * Last Used At
   * @format date-time
   */
  last_used_at?: string;
}

/**
 * FeatureUsageRollup
 * Aggregated usage for one feature over a scope's subtree.
 */
export interface FeatureUsageRollup {
  /** Feature Key */
  feature_key: string;
  /**
   * Usage Count
   * @default 0
   */
  usage_count?: number;
  /**
   * Last Used At
   * @format date-time
   */
  last_used_at?: string;
}

/** FleetOutageSummary */
export interface FleetOutageSummary {
  /** Window Hours */
  window_hours: number;
  /** Filters */
  filters: object;
  /** Cpes Checked */
  cpes_checked: number;
  /** Cpes With Outage */
  cpes_with_outage: number;
  /** Total Outage Events */
  total_outage_events: number;
  /** Cpes Skipped No Address */
  cpes_skipped_no_address: number;
  /** Cpes */
  cpes: CpeOutageInfo[];
  /** Errors */
  errors: object[];
}

/** FleetStateBuild */
export interface FleetStateBuild {
  /** Version */
  version?: string;
  /** Commit */
  commit?: string;
  /** Count */
  count: number;
  /** Cpes */
  cpes: FleetStateCpe[];
}

/** FleetStateCpe */
export interface FleetStateCpe {
  /** Cpe Id */
  cpe_id: string;
  /** Cpe Name */
  cpe_name: string;
  /** Kernel */
  kernel?: string;
  /** Version */
  version?: string;
  /** Commit */
  commit?: string;
  /** Pin */
  pin?: string;
}

/** FleetStateResult */
export interface FleetStateResult {
  /** Checked */
  checked: number;
  /** Down */
  down: number;
  /** Pinned */
  pinned: number;
  /** Exposed */
  exposed: FleetStateCpe[];
  /** Not On Pinned Build */
  not_on_pinned_build: FleetStateCpe[];
  /** Qmifix Unreported */
  qmifix_unreported: number;
  /** Builds */
  builds: FleetStateBuild[];
}

/** GetAppNameByIP */
export interface GetAppNameByIP {
  /** Ip1 */
  ip1: string;
  /** Ip2 */
  ip2: string;
  /** Protocol */
  protocol: string;
  /** Ip1 Port */
  ip1_port: string;
  /** Ip2 Port */
  ip2_port: string;
  /** Force Match Port */
  force_match_port: boolean;
}

/** GetCaptureStatusResp */
export interface GetCaptureStatusResp {
  /** Result */
  result: string;
  /** Capturing */
  capturing?: boolean;
  /** File Size */
  file_size?: number;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** HealthResponse */
export interface HealthResponse {
  /** Status */
  status: string;
  /** Model */
  model: string;
  /** Provider */
  provider: string;
  /** Active Users */
  active_users: number;
  /** Total Sessions */
  total_sessions: number;
}

/** HistoryResponse */
export interface HistoryResponse {
  /** Session Id */
  session_id: string;
  /** History */
  history: (
    | UserMessage
    | AssistantMessage
    | ToolCallMessage
    | ToolResultMessage
    | (UserMessage & AssistantMessage & ToolCallMessage & ToolResultMessage)
  )[];
}

/** Hosting */
export interface Hosting {
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** App Service Id */
  app_service_id?: string;
  /** Hosting Id */
  hosting_id?: string;
  /** Hosting Type */
  hosting_type?: string;
  /** Region */
  region?: string;
  /** Service Provider */
  service_provider?: string;
  /** Cloud Endpoint Service Name */
  cloud_endpoint_service_name?: string;
  /** Service Node Group Name */
  service_node_group_name?: string;
  /** Fqdn */
  fqdn?: string;
  /** Priority Id */
  priority_id?: number;
  /** Size */
  size?: number;
  /** Health */
  health?: number;
}

/**
 * HostingType
 * An enumeration.
 */
export enum HostingType {
  Cloud = 'cloud',
  Onprem = 'onprem',
}

/** IPAppName */
export interface IPAppName {
  /** App Name */
  app_name: string;
  /** Ip Cidr */
  ip_cidr: string;
  /** Tcp Ports */
  tcp_ports: string;
  /** Udp Ports */
  udp_ports: string;
  /** Domain */
  domain: string;
}

/**
 * IamRole
 * An enumeration.
 */
export enum IamRole {
  Readonly = 'readonly',
  Admin = 'admin',
}

/** IamUser */
export interface IamUser {
  /** Username */
  username: string;
  /** An enumeration. */
  role: IamRole;
  /** Name */
  name?: string;
  /**
   * Email
   * @format email
   */
  email?: string;
  /** Address */
  address?: string;
  /** Phone */
  phone?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Iam User Id */
  iam_user_id: string;
  /** Account Id */
  account_id: string;
  /** Mfa Enabled */
  mfa_enabled?: boolean;
  /** Mfa Type */
  mfa_type?: string;
  /**
   * Last Login Time
   * @format date-time
   */
  last_login_time?: string;
  /** Entity Id */
  entity_id?: string;
  /** Logo */
  logo?: string;
  /** Entity Name */
  entity_name?: string;
  /**
   * Inactivity Locked
   * @default false
   */
  inactivity_locked?: boolean;
}

/** IamUserCreate */
export interface IamUserCreate {
  /** Username */
  username: string;
  /** An enumeration. */
  role: IamRole;
  /** Name */
  name?: string;
  /** Entity Name */
  entity_name?: string;
}

/** IamUserUpdate */
export interface IamUserUpdate {
  /** Name */
  name?: string;
  /**
   * Email
   * @format email
   */
  email?: string;
  /** Address */
  address?: string;
  /** Phone */
  phone?: string;
  /** Password */
  password?: string;
}

/** IperfServer */
export interface IperfServer {
  /** Cpe Id */
  cpe_id: string;
  /** Enable */
  enable: boolean;
}

/**
 * LANInterface
 * LAN Interface configuration received via API
 */
export interface LANInterface {
  /** Node Id */
  node_id: string;
  /** Enabled */
  enabled: boolean;
  /** Primary Ipv4 Address */
  primary_ipv4_address?: string;
  /** Secondary Ipv4 Addresses */
  secondary_ipv4_addresses?: string;
}

/**
 * Metro
 * Shared properties
 */
export interface Metro {
  /** Metro Name */
  metro_name: string;
  /** Prod Code */
  prod_code: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Wan Cir Mbps */
  wan_cir_mbps?: number;
  /** Wan Eir Mbps */
  wan_eir_mbps?: number;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Metro Id */
  metro_id: string;
  /** Entity Id */
  entity_id?: string;
  /** Latitude */
  latitude?: string;
  /** Longitude */
  longitude?: string;
  /** State */
  state?: string;
  /** Netflow Enabled */
  netflow_enabled: boolean;
  /** Monitor Inbound Pub Ip Enabled */
  monitor_inbound_pub_ip_enabled: boolean;
  /** Monitor Outbound Pub Ip Enabled */
  monitor_outbound_pub_ip_enabled: boolean;
  /** Denial Of Service Enabled */
  denial_of_service_enabled?: boolean;
  /** Malicious Ip Block Enabled */
  malicious_ip_block_enabled?: boolean;
  /** Denial Of Service Alert Enabled */
  denial_of_service_alert_enabled?: boolean;
  /** Oam Loopback Enabled */
  oam_loopback_enabled?: boolean;
  /** Oam Ccp Enabled */
  oam_ccp_enabled?: boolean;
  /** Oam Ccm Interval */
  oam_ccm_interval?: number;
  /** Oam Md Name */
  oam_md_name?: string;
  /** Oam Md Level */
  oam_md_level?: number;
  /** Oam Md Association */
  oam_md_association?: string;
  /** Oam Mep Id */
  oam_mep_id?: number;
  /** Oam Vlan Id */
  oam_vlan_id?: number;
  /** Tracking Number */
  tracking_number?: string;
  /** Announcement */
  announcement?: object;
  /** Account Name */
  account_name?: string;
  /** Entity Name */
  entity_name?: string;
}

/**
 * MetroCreate
 * Shared properties
 */
export interface MetroCreate {
  /** Metro Name */
  metro_name: string;
  /** Prod Code */
  prod_code: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Wan Cir Mbps */
  wan_cir_mbps?: number;
  /** Wan Eir Mbps */
  wan_eir_mbps?: number;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /** Wan Data Vlan Id */
  wan_data_vlan_id?: number;
  /** Wan Q In Q Vlan Id */
  wan_q_in_q_vlan_id?: number;
  /** Lan Data Vlan Id */
  lan_data_vlan_id?: number;
  /** Lan Q In Q Vlan Id */
  lan_q_in_q_vlan_id?: number;
  /**
   * Wan Mgmt Vlan Id
   * @default 100
   */
  wan_mgmt_vlan_id?: number;
  /** Entity Name */
  entity_name?: string;
  /** Wan Sfp */
  wan_sfp?: string;
  /** Lan Sfp */
  lan_sfp?: string;
}

/**
 * MetroDetail
 * Shared properties
 */
export interface MetroDetail {
  /** Metro Name */
  metro_name: string;
  /** Prod Code */
  prod_code: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Wan Cir Mbps */
  wan_cir_mbps?: number;
  /** Wan Eir Mbps */
  wan_eir_mbps?: number;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Metro Id */
  metro_id: string;
  /** Entity Id */
  entity_id?: string;
  /** Latitude */
  latitude?: string;
  /** Longitude */
  longitude?: string;
  /** State */
  state?: string;
  /** Netflow Enabled */
  netflow_enabled: boolean;
  /** Monitor Inbound Pub Ip Enabled */
  monitor_inbound_pub_ip_enabled: boolean;
  /** Monitor Outbound Pub Ip Enabled */
  monitor_outbound_pub_ip_enabled: boolean;
  /** Denial Of Service Enabled */
  denial_of_service_enabled?: boolean;
  /** Malicious Ip Block Enabled */
  malicious_ip_block_enabled?: boolean;
  /** Denial Of Service Alert Enabled */
  denial_of_service_alert_enabled?: boolean;
  /** Oam Loopback Enabled */
  oam_loopback_enabled?: boolean;
  /** Oam Ccp Enabled */
  oam_ccp_enabled?: boolean;
  /** Oam Ccm Interval */
  oam_ccm_interval?: number;
  /** Oam Md Name */
  oam_md_name?: string;
  /** Oam Md Level */
  oam_md_level?: number;
  /** Oam Md Association */
  oam_md_association?: string;
  /** Oam Mep Id */
  oam_mep_id?: number;
  /** Oam Vlan Id */
  oam_vlan_id?: number;
  /** Tracking Number */
  tracking_number?: string;
  /** Announcement */
  announcement?: object;
  /** Account Name */
  account_name?: string;
  /** Entity Name */
  entity_name?: string;
  /** Ports */
  ports?: object;
}

/** MetroInfoUpdate */
export interface MetroInfoUpdate {
  /** Metro Id */
  metro_id: string;
  /** Metro Name */
  metro_name?: string;
  /** Shipping Address */
  shipping_address?: string;
  /** Site Address */
  site_address?: string;
  /** Description */
  description?: string;
  /** Provider Service Id */
  provider_service_id?: string;
  /** Client Circuit Id */
  client_circuit_id?: string;
  /** Wan Cir Mbps */
  wan_cir_mbps?: number;
  /** Wan Eir Mbps */
  wan_eir_mbps?: number;
  /** Wan Data Vlan Id */
  wan_data_vlan_id?: number;
  /** Wan Q In Q Vlan Id */
  wan_q_in_q_vlan_id?: number;
  /** Lan Data Vlan Id */
  lan_data_vlan_id?: number;
  /** Lan Q In Q Vlan Id */
  lan_q_in_q_vlan_id?: number;
  /** Wan Mgmt Vlan Id */
  wan_mgmt_vlan_id?: number;
  /** Contact Name */
  contact_name?: string;
  /** Contact Email */
  contact_email?: string;
  /** Contact Phone */
  contact_phone?: string;
}

/** MetroLoopbackTest */
export interface MetroLoopbackTest {
  /** Metro Id */
  metro_id: string;
  /** Lpbk Src Mac Addr */
  lpbk_src_mac_addr: string;
}

/** MetroOamEdit */
export interface MetroOamEdit {
  /** Metro Id */
  metro_id: string;
  /** Loopback Enabled */
  loopback_enabled: boolean;
  /** Ccp Enabled */
  ccp_enabled: boolean;
  /** Ccm Interval */
  ccm_interval?: number;
  /** Md Name */
  md_name?: string;
  /** Md Level */
  md_level?: number;
  /** Md Association */
  md_association?: string;
  /** Mep Id */
  mep_id?: number;
  /** Vlan Id */
  vlan_id?: number;
}

/** MetroPerformanceTest */
export interface MetroPerformanceTest {
  /** Metro Id */
  metro_id: string;
  /** Peer Ip */
  peer_ip?: string;
  /** Peer Mac */
  peer_mac?: string;
  /** Vlan Id */
  vlan_id?: number;
}

/**
 * MfaType
 * An enumeration.
 */
export enum MfaType {
  Email = 'email',
}

/** NetworkDeviceOnDiagPort */
export interface NetworkDeviceOnDiagPort {
  /** Node Id */
  node_id: string;
  /** Ip Addr */
  ip_addr: string;
  /** Mac Addr */
  mac_addr: string;
  /** Vendor Name */
  vendor_name?: string;
  /** Device Name */
  device_name?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Description */
  description?: string;
  /** Network Device Id */
  network_device_id: string;
  /** Reachable */
  reachable?: boolean;
  /**
   * Reachable At
   * @format date-time
   */
  reachable_at?: string;
}

/** NetworkDeviceOnDiagPortAdd */
export interface NetworkDeviceOnDiagPortAdd {
  /** Node Id */
  node_id: string;
  /** Device Name */
  device_name: string;
  /** Ip Addr */
  ip_addr: string;
  /** Mac Addr */
  mac_addr?: string;
  /** Vendor Name */
  vendor_name?: string;
}

/** NetworkDeviceOnDiagPortEditName */
export interface NetworkDeviceOnDiagPortEditName {
  /** Node Id */
  node_id: string;
  /** Mac Addr */
  mac_addr: string;
  /** Device Name */
  device_name: string;
}

/** NetworkDeviceOnDiagPortWithSessions */
export interface NetworkDeviceOnDiagPortWithSessions {
  /** Node Id */
  node_id: string;
  /** Ip Addr */
  ip_addr: string;
  /** Mac Addr */
  mac_addr: string;
  /** Vendor Name */
  vendor_name?: string;
  /** Device Name */
  device_name?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Description */
  description?: string;
  /** Network Device Id */
  network_device_id: string;
  /** Reachable */
  reachable?: boolean;
  /**
   * Reachable At
   * @format date-time
   */
  reachable_at?: string;
  /**
   * Sessions
   * @default []
   */
  sessions?: object[];
}

/** NodeConnStatus */
export interface NodeConnStatus {
  /** Node Id */
  node_id: string;
  /** Percent */
  percent: string;
  /** Uptime */
  uptime: number;
  /** Downtime */
  downtime: number;
  /** Total */
  total: number;
  /** History */
  history: object[];
  /** Conn Status Start At */
  conn_status_start_at?: string;
}

/** PacketCapture */
export interface PacketCapture {
  /** Node Id */
  node_id: string;
  /** Interface */
  interface?: string;
  /**
   * Tcpdump Args
   * @maxLength 1000
   */
  tcpdump_args?: string;
  /**
   * Max Size Mb
   * @min 1
   * @max 1024
   * @default 1024
   */
  max_size_mb?: number;
  /**
   * Max Duration S
   * @min 1
   * @max 86400
   * @default 86400
   */
  max_duration_s?: number;
}

/**
 * PaymentProvider
 * An enumeration.
 */
export enum PaymentProvider {
  Aws = 'aws',
  Stripe = 'stripe',
}

/**
 * Pdu
 * Shared properties
 */
export interface Pdu {
  /** Node Id */
  node_id: string;
  /** Pdu Name */
  pdu_name: string;
  /** Vendor Name */
  vendor_name: string;
  /** Ip Addr */
  ip_addr: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Description */
  description?: string;
  /** Pdu Id */
  pdu_id: string;
  /** Model Name */
  model_name?: string;
  /** Serial Number */
  serial_number?: string;
  /** Bank Count */
  bank_count?: number;
  /** Outlet Count */
  outlet_count?: number;
  /** Reachable */
  reachable?: boolean;
  /**
   * Reachable At
   * @format date-time
   */
  reachable_at?: string;
  /** Outlets */
  outlets?: any[];
  /** Mac Addr */
  mac_addr?: string;
}

/**
 * PduCreate
 * Shared properties
 */
export interface PduCreate {
  /** Node Id */
  node_id: string;
  /** Pdu Name */
  pdu_name: string;
  /** Vendor Name */
  vendor_name: string;
  /** Ip Addr */
  ip_addr: string;
}

/** PduEditInfo */
export interface PduEditInfo {
  /** Pdu Id */
  pdu_id: string;
  /** Ip Addr */
  ip_addr?: string;
  /** Pdu Name */
  pdu_name?: string;
  /** Description */
  description?: string;
}

/**
 * PduOutletState
 * An enumeration.
 */
export enum PduOutletState {
  On = 'on',
  Off = 'off',
}

/** PerfTestSchedule */
export interface PerfTestSchedule {
  /** Cpe Id */
  cpe_id: string;
  /** Enable */
  enable: boolean;
  /** Peer Region */
  peer_region?: string;
  /** Hour Of Day */
  hour_of_day?: number;
}

/** QueryPcapResp */
export interface QueryPcapResp {
  /** Document Id */
  document_id: string;
  /** Result */
  result: string;
}

/** RemoteAccessTarget */
export interface RemoteAccessTarget {
  /** Ip */
  ip?: string;
  /** Port */
  port?: number;
  /** Protocol */
  protocol?: string;
  /** Mac Addr */
  mac_addr?: string;
  /** Domain */
  domain?: string;
}

/** S3UploadUrl */
export interface S3UploadUrl {
  /** S3 Url */
  s3_url: string;
  /** Pcap File Key */
  pcap_file_key: string;
  /** Pcap File Name */
  pcap_file_name: string;
}

/** ServiceNode */
export interface ServiceNode {
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Service Node Name */
  service_node_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Service Node Id */
  service_node_id: string;
  /** Public Ip */
  public_ip?: string;
  /** Private Ip */
  private_ip?: string;
  /** Registered */
  registered: boolean;
  /**
   * Registered At
   * @format date-time
   */
  registered_at?: string;
  /** Udp Tunnel Status */
  udp_tunnel_status?: string;
  /**
   * Udp Tunnel Status Change At
   * @format date-time
   */
  udp_tunnel_status_change_at?: string;
  /** Udp Tunnel Peer Ip */
  udp_tunnel_peer_ip?: string;
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
}

/** ServiceNodeCreate */
export interface ServiceNodeCreate {
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
  /** Hosted Region */
  hosted_region?: string;
  /** Hosted Vpc Cidr */
  hosted_vpc_cidr?: string;
  /** Hosted Peer Ip */
  hosted_peer_ip?: string;
  /** Hosted Peer Prefix */
  hosted_peer_prefix?: string;
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Service Node Name */
  service_node_name: string;
  /** New Service Node Group */
  new_service_node_group: boolean;
  /** Service Node Group Name */
  service_node_group_name?: string;
}

/** ServiceNodeDetail */
export interface ServiceNodeDetail {
  /** Service Node Group Id */
  service_node_group_id?: string;
  /** Service Node Name */
  service_node_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Service Node Id */
  service_node_id: string;
  /** Public Ip */
  public_ip?: string;
  /** Private Ip */
  private_ip?: string;
  /** Registered */
  registered: boolean;
  /**
   * Registered At
   * @format date-time
   */
  registered_at?: string;
  /** Udp Tunnel Status */
  udp_tunnel_status?: string;
  /**
   * Udp Tunnel Status Change At
   * @format date-time
   */
  udp_tunnel_status_change_at?: string;
  /** Udp Tunnel Peer Ip */
  udp_tunnel_peer_ip?: string;
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
  /** App Services */
  app_services: AppService[];
  /** Endpoints */
  endpoints: Ep[];
}

/** ServiceNodeGroup */
export interface ServiceNodeGroup {
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
  /** Hosted Region */
  hosted_region?: string;
  /** Hosted Vpc Cidr */
  hosted_vpc_cidr?: string;
  /** Hosted Peer Ip */
  hosted_peer_ip?: string;
  /** Hosted Peer Prefix */
  hosted_peer_prefix?: string;
  /** Service Node Group Name */
  service_node_group_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description?: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /** Account Id */
  account_id: string;
  /** Service Node Group Id */
  service_node_group_id: string;
  /** External Certificate */
  external_certificate?: boolean;
}

/** ServiceNodeGroupCreate */
export interface ServiceNodeGroupCreate {
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
  /** Hosted Region */
  hosted_region?: string;
  /** Hosted Vpc Cidr */
  hosted_vpc_cidr?: string;
  /** Hosted Peer Ip */
  hosted_peer_ip?: string;
  /** Hosted Peer Prefix */
  hosted_peer_prefix?: string;
  /** Service Node Group Name */
  service_node_group_name: string;
}

/** SessionInfo */
export interface SessionInfo {
  /** Session Id */
  session_id: string;
  /** Created At */
  created_at: string;
  /** Last Active */
  last_active: string;
  /** Turn Count */
  turn_count: number;
}

/** SessionsResponse */
export interface SessionsResponse {
  /** Sessions */
  sessions: SessionInfo[];
}

/** SetNodeFormFactor */
export interface SetNodeFormFactor {
  /** Form Factor */
  form_factor?: string;
  /** Shipping Addr */
  shipping_addr?: string;
  /** Hosted Region */
  hosted_region?: string;
  /** Hosted Vpc Cidr */
  hosted_vpc_cidr?: string;
  /** Hosted Peer Ip */
  hosted_peer_ip?: string;
  /** Hosted Peer Prefix */
  hosted_peer_prefix?: string;
  /** Node Id */
  node_id: string;
}

/** SkillInfo */
export interface SkillInfo {
  /** Name */
  name: string;
  /** Description */
  description: string;
}

/** SkillsResponse */
export interface SkillsResponse {
  /** Skills */
  skills: SkillInfo[];
}

/** SpeedtestCliStartResponse */
export interface SpeedtestCliStartResponse {
  /** Status */
  status: string;
  /** Sse Id */
  sse_id: string;
}

/** SpeedtestCliTestResult */
export interface SpeedtestCliTestResult {
  /** Download Speed Mbps */
  download_speed_mbps: number;
  /** Upload Speed Mbps */
  upload_speed_mbps: number;
  /** Ping Latency Ms */
  ping_latency_ms: number;
  /** Ping Jitter Ms */
  ping_jitter_ms: number;
  /** Result Url */
  result_url: string;
}

/** StartCaptureResp */
export interface StartCaptureResp {
  /** Result */
  result: string;
}

/** StopCaptureResp */
export interface StopCaptureResp {
  /** Result */
  result: string;
}

/** SwitchAccountRequest */
export interface SwitchAccountRequest {
  /** Account Id */
  account_id: string;
}

/** ThirdPartyIntegrationConfigure */
export interface ThirdPartyIntegrationConfigure {
  /** Cpe Id */
  cpe_id: string;
  /**
   * Vendor
   * @default "Granite Telecommunications"
   */
  vendor?: string;
  /** Config */
  config?: ThirdPartyIntegrationSetting[];
}

/** ThirdPartyIntegrationSetting */
export interface ThirdPartyIntegrationSetting {
  /** Key */
  key: string;
  /** Label */
  label?: string;
  /** Value */
  value?: string;
  /** Description */
  description?: string;
}

/** ThirdPartyIntegrationVendor */
export interface ThirdPartyIntegrationVendor {
  /** Vendor */
  vendor: string;
  /** Config */
  config: ThirdPartyIntegrationSetting[];
}

/** ThirdPartyVendorConfigConfigure */
export interface ThirdPartyVendorConfigConfigure {
  /** Entity Id */
  entity_id: string;
  /**
   * Vendor
   * @default "Granite Telecommunications"
   */
  vendor?: string;
  /** Config */
  config: ThirdPartyIntegrationSetting[];
}

/**
 * Ticket
 * Shared properties
 */
export interface Ticket {
  /** Title */
  title: string;
  /** Description */
  description?: string;
  /** An enumeration. */
  priority: TicketPriority;
  /** Device Id */
  device_id?: string;
  /** An enumeration. */
  category: TicketCategory;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Ticket Id */
  ticket_id: string;
  /** State */
  state: string;
  /** Created By */
  created_by?: string;
  /** Account Id */
  account_id?: string;
  /** Entity Id */
  entity_id?: string;
  /** Uploaded Files */
  uploaded_files?: TicketFile[];
}

/**
 * TicketCategory
 * An enumeration.
 */
export enum TicketCategory {
  ReportAProblem = 'Report a problem',
  RequestAFeature = 'Request a feature',
  Other = 'Other',
}

/**
 * TicketCreate
 * Shared properties
 */
export interface TicketCreate {
  /** Title */
  title: string;
  /** Description */
  description?: string;
  /** An enumeration. */
  priority: TicketPriority;
  /** Device Id */
  device_id?: string;
  /** An enumeration. */
  category: TicketCategory;
  /** Uploaded Files */
  uploaded_files?: TicketFileInput[];
}

/** TicketDeleteUpload */
export interface TicketDeleteUpload {
  /** Object Key */
  object_key: string;
}

/**
 * TicketDetail
 * Shared properties
 */
export interface TicketDetail {
  /** Title */
  title: string;
  /** Description */
  description?: string;
  /** An enumeration. */
  priority: TicketPriority;
  /** Device Id */
  device_id?: string;
  /** An enumeration. */
  category: TicketCategory;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at?: string;
  /** Ticket Id */
  ticket_id: string;
  /** State */
  state: string;
  /** Created By */
  created_by?: string;
  /** Account Id */
  account_id?: string;
  /** Entity Id */
  entity_id?: string;
  /** Uploaded Files */
  uploaded_files?: TicketFile[];
  /** Correspondence */
  correspondence: Correspondence[];
}

/** TicketFile */
export interface TicketFile {
  /** Filename */
  filename: string;
  /** Bucket */
  bucket: string;
  /** Object Key */
  object_key: string;
  /** Download Url */
  download_url?: string;
}

/**
 * TicketFileInput
 * A previously-uploaded attachment, as reported back by the UI when submitting
 * a ticket or a reply. ``presigned_url`` is accepted but never persisted -- it
 * expires within minutes, so only the permanent S3 location is kept.
 */
export interface TicketFileInput {
  /** Filename */
  filename: string;
  /** Bucket */
  bucket: string;
  /** Object Key */
  object_key: string;
  /** Presigned Url */
  presigned_url?: string;
}

/**
 * TicketPriority
 * An enumeration.
 */
export enum TicketPriority {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

/** TicketUploadUrl */
export interface TicketUploadUrl {
  /** Filename */
  filename: string;
  /** S3 Bucket */
  s3_bucket: string;
  /** Object Key */
  object_key: string;
  /** Presigned Url */
  presigned_url: string;
}

/** ToolCallMessage */
export interface ToolCallMessage {
  /** Role */
  role: 'tool_call';
  /** Name */
  name: string;
  /** Input */
  input: object;
}

/** ToolInfo */
export interface ToolInfo {
  /** Name */
  name: string;
  /** Description */
  description: string;
}

/** ToolResultMessage */
export interface ToolResultMessage {
  /** Role */
  role: 'tool_result';
  /** Content */
  content: string;
}

/** ToolsResponse */
export interface ToolsResponse {
  /** Tools */
  tools: ToolInfo[];
}

/** UsbConsoleSettings */
export interface UsbConsoleSettings {
  /** Cpe Id */
  cpe_id: string;
  /** Hw Id Path */
  hw_id_path: string;
  /**
   * Label
   * @default "Change me"
   */
  label?: string;
  /**
   * Description
   * @default ""
   */
  description?: string;
  /**
   * Baud Rate
   * @default 9600
   */
  baud_rate?: number;
  /**
   * Parity
   * @default "none"
   */
  parity?: string;
  /**
   * Bits
   * @default 8
   */
  bits?: number;
  /**
   * Stop Bits
   * @default 1
   */
  stop_bits?: number;
}

/** UsbConsoleSettingsResponse */
export interface UsbConsoleSettingsResponse {
  /** Label */
  label: string;
  /** Description */
  description: string;
  /** Baud Rate */
  baud_rate: number;
  /** Parity */
  parity: string;
  /** Bits */
  bits: number;
  /** Stop Bits */
  stop_bits: number;
}

/** UserAgent */
export interface UserAgent {
  /** Name */
  name?: string;
  /** Email */
  email: string;
  /** Description */
  description?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Admin State */
  admin_state?: string;
  /**
   * Admin State Change At
   * @format date-time
   */
  admin_state_change_at?: string;
  /**
   * Last Connect Time
   * @format date-time
   */
  last_connect_time?: string;
  /**
   * Last Disconnect Time
   * @format date-time
   */
  last_disconnect_time?: string;
  /** Connected */
  connected?: boolean;
  /** Op State */
  op_state?: string;
  /**
   * Op State Change At
   * @format date-time
   */
  op_state_change_at?: string;
  /**
   * Last Auth Time
   * @format date-time
   */
  last_auth_time?: string;
  /** Last Auth Status */
  last_auth_status?: boolean;
  /** User Agent Id */
  user_agent_id: string;
  /** App Service Id */
  app_service_id?: string;
}

/** UserAgentCreate */
export interface UserAgentCreate {
  /** Name */
  name?: string;
  /** Email */
  email: string;
  /** Description */
  description?: string;
  /** Ep Id */
  ep_id?: string;
}

/** UserMessage */
export interface UserMessage {
  /** Role */
  role: 'user';
  /** Text */
  text: string;
}

/**
 * VRRPConfig
 * VRRP configuration received via API
 */
export interface VRRPConfig {
  /** Node Group Id */
  node_group_id: string;
  /** Enabled */
  enabled: boolean;
  /** Virtual Ip */
  virtual_ip?: string;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number | (string & number))[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** Cpec */
type BaseNull = any;

type BaseNullProdCodeMapping<Key, Type> = {
  prod_code: Key;
} & Type;

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = '';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string' ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>(
    { body, secure, path, type, query, format, baseUrl, cancelToken, ...params }: FullRequestParams,
  ): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
        },
        signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
        body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Bumblebee Networks
 * @version 0.1.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags common, logging
   * @name CreateAccountApiV1CreateAccountPost
   * @summary Create Account
   * @request POST:/create-account
   */
  createAccountApiV1CreateAccountPost = (data: AccountCreate, params: RequestParams = {}) =>
    this.request<Account, HTTPValidationError>({
      path: `/create-account`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, sample, public
   * @name ListAccountApiV1ListAccountGet
   * @summary List Account
   * @request GET:/list-account
   * @secure
   */
  listAccountApiV1ListAccountGet = (
    query?: {
      /** Username */
      username?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<(Account | IamUser | (Account & IamUser))[], HTTPValidationError>({
      path: `/list-account`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, internal
   * @name DeleteAccountApiV1DeleteAccountPost
   * @summary Delete Account
   * @request POST:/delete-account
   * @secure
   */
  deleteAccountApiV1DeleteAccountPost = (
    query: {
      /** Username */
      username: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Account, HTTPValidationError>({
      path: `/delete-account`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, internal
   * @name RemoveAccountApiV1RemoveAccountPost
   * @summary Remove Account
   * @request POST:/remove-account
   * @secure
   */
  removeAccountApiV1RemoveAccountPost = (
    query: {
      /** Username */
      username: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-account`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, public
   * @name UpdateAccountApiV1UpdateAccountPost
   * @summary Update Account
   * @request POST:/update-account
   * @secure
   */
  updateAccountApiV1UpdateAccountPost = (data: AccountUpdate, params: RequestParams = {}) =>
    this.request<Account, HTTPValidationError>({
      path: `/update-account`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name GetAccountSummaryApiV1GetAccountSummaryGet
   * @summary Get Account Summary
   * @request GET:/get-account-summary
   * @secure
   */
  getAccountSummaryApiV1GetAccountSummaryGet = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/get-account-summary`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags internal, accountowner, logging, internal
   * @name CleanupAccountApiV1CleanupAccountPost
   * @summary Cleanup Account
   * @request POST:/cleanup-account
   * @secure
   */
  cleanupAccountApiV1CleanupAccountPost = (
    query: {
      /** Target Account Id */
      target_account_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/cleanup-account`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, public
   * @name AccountEnableMfaApiV1AccountEnableMfaPost
   * @summary Account Enable Mfa
   * @request POST:/account-enable-mfa
   * @secure
   */
  accountEnableMfaApiV1AccountEnableMfaPost = (
    query: {
      /** An enumeration. */
      type: MfaType;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/account-enable-mfa`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, public
   * @name AccountDisableMfaApiV1AccountDisableMfaPost
   * @summary Account Disable Mfa
   * @request POST:/account-disable-mfa
   * @secure
   */
  accountDisableMfaApiV1AccountDisableMfaPost = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/account-disable-mfa`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, public
   * @name AccountEnforceMfaApiV1AccountEnforceMfaPost
   * @summary Account Enforce Mfa
   * @request POST:/account-enforce-mfa
   * @secure
   */
  accountEnforceMfaApiV1AccountEnforceMfaPost = (
    query: {
      /** Enable */
      enable: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/account-enforce-mfa`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags internal, accountowner, logging, internal
   * @name AccountEnableTrialApiV1AccountEnableTrialPost
   * @summary Account Enable Trial
   * @request POST:/account-enable-trial
   * @secure
   */
  accountEnableTrialApiV1AccountEnableTrialPost = (
    query: {
      /** Target Account Id */
      target_account_id: string;
      /** Trial Period Days */
      trial_period_days: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/account-enable-trial`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags internal, accountowner, logging, internal
   * @name AccountDisableTrialApiV1AccountDisableTrialPost
   * @summary Account Disable Trial
   * @request POST:/account-disable-trial
   * @secure
   */
  accountDisableTrialApiV1AccountDisableTrialPost = (
    query: {
      /** Target Account Id */
      target_account_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/account-disable-trial`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name AccountGetLogoApiV1AccountGetLogoGet
   * @summary Account Get Logo
   * @request GET:/account-get-logo
   * @secure
   */
  accountGetLogoApiV1AccountGetLogoGet = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/account-get-logo`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, internal
   * @name AccountSetLogoApiV1AccountSetLogoPost
   * @summary Account Set Logo
   * @request POST:/account-set-logo
   * @secure
   */
  accountSetLogoApiV1AccountSetLogoPost = (
    query?: {
      /** Logo Url */
      logo_url?: string;
      /** Account Id */
      account_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/account-set-logo`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, public
   * @name AccountInactivityLockApiV1AccountInactivityLockPost
   * @summary Account Inactivity Lock
   * @request POST:/account-inactivity-lock
   * @secure
   */
  accountInactivityLockApiV1AccountInactivityLockPost = (
    query: {
      /** Enable */
      enable: boolean;
      /**
       * Inactivity Days
       * @default 90
       */
      inactivity_days?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/account-inactivity-lock`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, public
   * @name AccountUnlockInactiveIamUserApiV1AccountUnlockInactiveIamUserPost
   * @summary Account Unlock Inactive Iam User
   * @request POST:/account-unlock-inactive-iam-user
   * @secure
   */
  accountUnlockInactiveIamUserApiV1AccountUnlockInactiveIamUserPost = (
    query: {
      /** Iam User Id */
      iam_user_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/account-unlock-inactive-iam-user`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, internal
   * @name CreateAccountIdpApiV1CreateAccountIdpPost
   * @summary Create Account Idp
   * @request POST:/create-account-idp
   * @secure
   */
  createAccountIdpApiV1CreateAccountIdpPost = (
    data: AccountIdpCreate,
    params: RequestParams = {},
  ) =>
    this.request<AccountIdp, HTTPValidationError>({
      path: `/create-account-idp`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, internal
   * @name GetAccountIdpApiV1GetAccountIdpGet
   * @summary Get Account Idp
   * @request GET:/get-account-idp
   * @secure
   */
  getAccountIdpApiV1GetAccountIdpGet = (params: RequestParams = {}) =>
    this.request<AccountIdp[], any>({
      path: `/get-account-idp`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, internal
   * @name RemoveAccountIdpApiV1RemoveAccountIdpPost
   * @summary Remove Account Idp
   * @request POST:/remove-account-idp
   * @secure
   */
  removeAccountIdpApiV1RemoveAccountIdpPost = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/remove-account-idp`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, internal
   * @name UpdateAccountIdpApiV1UpdateAccountIdpPost
   * @summary Update Account Idp
   * @request POST:/update-account-idp
   * @secure
   */
  updateAccountIdpApiV1UpdateAccountIdpPost = (
    data: AccountIdpUpdate,
    params: RequestParams = {},
  ) =>
    this.request<AccountIdp, HTTPValidationError>({
      path: `/update-account-idp`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name SetAccountOpsApiV1SetAccountOpsPost
   * @summary Set Account Ops
   * @request POST:/set-account-ops
   * @secure
   */
  setAccountOpsApiV1SetAccountOpsPost = (data: AccountOpsSet, params: RequestParams = {}) =>
    this.request<AccountOps, HTTPValidationError>({
      path: `/set-account-ops`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, public
   * @name GetAccountOpsApiV1GetAccountOpsGet
   * @summary Get Account Ops
   * @request GET:/get-account-ops
   * @secure
   */
  getAccountOpsApiV1GetAccountOpsGet = (params: RequestParams = {}) =>
    this.request<AccountOps[], any>({
      path: `/get-account-ops`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name RemoveAccountOpsApiV1RemoveAccountOpsPost
   * @summary Remove Account Ops
   * @request POST:/remove-account-ops
   * @secure
   */
  removeAccountOpsApiV1RemoveAccountOpsPost = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/remove-account-ops`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Create a new app service. Args: account (models.Account): The account associated with the app service. asc (schemas.AppServiceCreate): The data required to create the app service. db (Session, optional): The database session. Raises: HTTPException: If the app service name is not valid, the protocol is not valid, or an app service with the same name already exists. Returns: models.AppService: The newly created app service.
   *
   * @tags provider, admin, logging, obsolete
   * @name CreateAppServiceApiV1CreateAppServicePost
   * @summary Create App Service
   * @request POST:/create-app-service
   * @secure
   */
  createAppServiceApiV1CreateAppServicePost = (
    data: AppServiceCreate,
    params: RequestParams = {},
  ) =>
    this.request<AppService, HTTPValidationError>({
      path: `/create-app-service`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Get an app with given app_name and owner_user_name.
   *
   * @tags provider, readonly, obsolete
   * @name ListAppServiceApiV1ListAppServiceGet
   * @summary List App Service
   * @request GET:/list-app-service
   * @secure
   */
  listAppServiceApiV1ListAppServiceGet = (
    query?: {
      /** App Service Name */
      app_service_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AppService[], HTTPValidationError>({
      path: `/list-app-service`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Remove an app service.
   *
   * @tags provider, admin, logging, obsolete
   * @name RemoveAppServiceApiV1RemoveAppServicePost
   * @summary Remove App Service
   * @request POST:/remove-app-service
   * @secure
   */
  removeAppServiceApiV1RemoveAppServicePost = (
    query: {
      /** App Service Id */
      app_service_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-app-service`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, readonly, obsolete
   * @name CheckAppServiceStatusApiV1CheckAppServiceStatusGet
   * @summary Check App Service Status
   * @request GET:/check-app-service-status
   * @secure
   */
  checkAppServiceStatusApiV1CheckAppServiceStatusGet = (
    query: {
      /** App Service Id */
      app_service_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/check-app-service-status`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Return a detailed view of AppService
   *
   * @tags provider, readonly, obsolete
   * @name GetAppServiceDetailApiV1GetAppServiceDetailGet
   * @summary Get App Service Detail
   * @request GET:/get-app-service-detail
   * @secure
   */
  getAppServiceDetailApiV1GetAppServiceDetailGet = (
    query: {
      /** App Service Id */
      app_service_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AppServiceDetail, HTTPValidationError>({
      path: `/get-app-service-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, readonly, obsolete
   * @name GetAppServiceEndpointsApiV1GetAppServiceEndpointsGet
   * @summary Get App Service Endpoints
   * @request GET:/get-app-service-endpoints
   * @secure
   */
  getAppServiceEndpointsApiV1GetAppServiceEndpointsGet = (
    query: {
      /** App Service Id */
      app_service_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Ep[], HTTPValidationError>({
      path: `/get-app-service-endpoints`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, readonly, obsolete
   * @name GetAppServiceNotificationsApiV1GetAppServiceNotificationsGet
   * @summary Get App Service Notifications
   * @request GET:/get-app-service-notifications
   * @secure
   */
  getAppServiceNotificationsApiV1GetAppServiceNotificationsGet = (
    query: {
      /** App Service Id */
      app_service_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Ep[], HTTPValidationError>({
      path: `/get-app-service-notifications`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, admin, logging, obsolete
   * @name SetAppServiceNameApiV1SetAppServiceNamePost
   * @summary Set the name of app service, overwrite any existing name
   * @request POST:/set-app-service-name
   * @secure
   */
  setAppServiceNameApiV1SetAppServiceNamePost = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** App Service Name */
      app_service_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-app-service-name`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, admin, logging, obsolete
   * @name SetAppServiceDescriptionApiV1SetAppServiceDescriptionPost
   * @summary Set the description of app service, overwrite any existing name
   * @request POST:/set-app-service-description
   * @secure
   */
  setAppServiceDescriptionApiV1SetAppServiceDescriptionPost = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** Description */
      description: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-app-service-description`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, readonly, obsolete
   * @name MeasureAppServiceLatencyApiV1MeasureAppServiceLatencyPost
   * @summary Measure the app service latency
   * @request POST:/measure-app-service-latency
   * @secure
   */
  measureAppServiceLatencyApiV1MeasureAppServiceLatencyPost = (
    query: {
      /** App Service Id */
      app_service_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/measure-app-service-latency`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, admin, logging, obsolete
   * @name AppServiceAddHostingApiV1AppServiceAddHostingPost
   * @summary Add a hosting to existing app service
   * @request POST:/app-service-add-hosting
   * @secure
   */
  appServiceAddHostingApiV1AppServiceAddHostingPost = (
    data: AppServiceHosting,
    params: RequestParams = {},
  ) =>
    this.request<AppService, HTTPValidationError>({
      path: `/app-service-add-hosting`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, admin, logging, obsolete
   * @name EditAppServiceApiV1EditAppServicePost
   * @summary Edit App Service
   * @request POST:/edit-app-service
   * @secure
   */
  editAppServiceApiV1EditAppServicePost = (data: AppServiceUpdate, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/edit-app-service`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, readonly, obsolete
   * @name AppServiceGetHostingApiV1AppServiceGetHostingGet
   * @summary App Service Get Hosting
   * @request GET:/app-service-get-hosting
   * @secure
   */
  appServiceGetHostingApiV1AppServiceGetHostingGet = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** An enumeration. */
      hosting_type?: HostingType;
    },
    params: RequestParams = {},
  ) =>
    this.request<Hosting[], HTTPValidationError>({
      path: `/app-service-get-hosting`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, admin, logging, obsolete
   * @name AppServiceRemoveHostingApiV1AppServiceRemoveHostingPost
   * @summary Remove a hosting from existing app service
   * @request POST:/app-service-remove-hosting
   * @secure
   */
  appServiceRemoveHostingApiV1AppServiceRemoveHostingPost = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** Hosting Id */
      hosting_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AppService, HTTPValidationError>({
      path: `/app-service-remove-hosting`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, admin, logging, obsolete
   * @name ResizeAppServiceApiV1ResizeAppServicePost
   * @summary Resize a cloud hosted app service (AWS or Azure)
   * @request POST:/resize-app-service
   * @secure
   */
  resizeAppServiceApiV1ResizeAppServicePost = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** Hosting Id */
      hosting_id: string;
      /** Direction */
      direction: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/resize-app-service`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, admin, logging, obsolete
   * @name AppServiceUpdateContactApiV1SetAppServiceContactPost
   * @summary App Service Update Contact
   * @request POST:/set-app-service-contact
   * @secure
   */
  appServiceUpdateContactApiV1SetAppServiceContactPost = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** Primary Contact Id */
      primary_contact_id?: string;
      /** Secondary Contact Id */
      secondary_contact_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-app-service-contact`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, readonly, obsolete
   * @name ListEpGroupApiV1ListEndpointGroupGet
   * @summary List Ep Group
   * @request GET:/list-endpoint-group
   * @secure
   */
  listEpGroupApiV1ListEndpointGroupGet = (
    query?: {
      /** Ep Group Name */
      ep_group_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpGroup[], HTTPValidationError>({
      path: `/list-endpoint-group`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Create an endpoint with given ep_name, owner_user_name and ep_type.
   *
   * @tags consumer, admin, logging, obsolete
   * @name CreateEpApiV1CreateEndpointPost
   * @summary Create Ep
   * @request POST:/create-endpoint
   * @secure
   */
  createEpApiV1CreateEndpointPost = (data: EpCreate, params: RequestParams = {}) =>
    this.request<Ep, HTTPValidationError>({
      path: `/create-endpoint`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, readonly, obsolete
   * @name ListEpApiV1ListEndpointGet
   * @summary List Ep
   * @request GET:/list-endpoint
   * @secure
   */
  listEpApiV1ListEndpointGet = (
    query?: {
      /** App Service Id */
      app_service_id?: string;
      /** Ep Node Id */
      ep_node_id?: string;
      /** Ep Name */
      ep_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Ep[], HTTPValidationError>({
      path: `/list-endpoint`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get an endpoint with given ep_name, owner_user_name and ep_type.
   *
   * @tags consumer, readonly, obsolete
   * @name ListEndpointDashboardApiV1ListEndpointDashboardGet
   * @summary List Endpoint Dashboard
   * @request GET:/list-endpoint-dashboard
   * @secure
   */
  listEndpointDashboardApiV1ListEndpointDashboardGet = (
    query?: {
      /** App Service Id */
      app_service_id?: string;
      /** Ep Node Id */
      ep_node_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Ep[], HTTPValidationError>({
      path: `/list-endpoint-dashboard`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name DeleteEpApiV1DeleteEndpointPost
   * @summary Delete Ep
   * @request POST:/delete-endpoint
   * @secure
   */
  deleteEpApiV1DeleteEndpointPost = (
    query: {
      /** Ep Name */
      ep_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Ep, HTTPValidationError>({
      path: `/delete-endpoint`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name RemoveEpApiV1RemoveEndpointPost
   * @summary Remove Ep
   * @request POST:/remove-endpoint
   * @secure
   */
  removeEpApiV1RemoveEndpointPost = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-endpoint`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, admin, logging, obsolete
   * @name ApproveEpApiV1ApproveEndpointPost
   * @summary Approve Ep
   * @request POST:/approve-endpoint
   * @secure
   */
  approveEpApiV1ApproveEndpointPost = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/approve-endpoint`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, admin, logging, obsolete
   * @name RejectEpApiV1RejectEndpointPost
   * @summary Reject Ep
   * @request POST:/reject-endpoint
   */
  rejectEpApiV1RejectEndpointPost = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/reject-endpoint`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, readonly, obsolete
   * @name GetEndpointDetailApiV1GetEndpointDetailGet
   * @summary Get Endpoint Detail
   * @request GET:/get-endpoint-detail
   * @secure
   */
  getEndpointDetailApiV1GetEndpointDetailGet = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpDetail, HTTPValidationError>({
      path: `/get-endpoint-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Measure endpoint latency. Returns a dictionary in the following form { "state":"UP" "details": None, "min": "MIN_LATENCY", "avg": "AVERAGE_LATENCY", "max": "MAX_LATENCY" } if state is DOWN, the key "details" will have troubleshooting tips.
   *
   * @tags consumer, readonly, obsolete
   * @name MeasureEpLatencyApiV1MeasureEndpointLatencyPost
   * @summary Measure Ep Latency
   * @request POST:/measure-endpoint-latency
   * @secure
   */
  measureEpLatencyApiV1MeasureEndpointLatencyPost = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/measure-endpoint-latency`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Reset an endpoint. Used for troubleshooting or recovery from failure.
   *
   * @tags consumer, admin, logging, obsolete
   * @name ResetEndpointApiV1ResetEndpointPost
   * @summary Reset Endpoint
   * @request POST:/reset-endpoint
   * @secure
   */
  resetEndpointApiV1ResetEndpointPost = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/reset-endpoint`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name SetEndpointNameApiV1SetEndpointNamePost
   * @summary Set the name of endpoint, overwrite any existing name
   * @request POST:/set-endpoint-name
   * @secure
   */
  setEndpointNameApiV1SetEndpointNamePost = (
    query: {
      /** Ep Id */
      ep_id: string;
      /** Ep Name */
      ep_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-endpoint-name`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name SetEndpointDescriptionApiV1SetEndpointDescriptionPost
   * @summary Update endpoint description, overwrite any existing ones
   * @request POST:/set-endpoint-description
   * @secure
   */
  setEndpointDescriptionApiV1SetEndpointDescriptionPost = (
    query: {
      /** Ep Id */
      ep_id: string;
      /** Description */
      description: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-endpoint-description`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, readonly, obsolete
   * @name GetEndpointSessionsApiV1GetEndpointSessionsGet
   * @summary List all sessions on an endpoint
   * @request GET:/get-endpoint-sessions
   * @secure
   */
  getEndpointSessionsApiV1GetEndpointSessionsGet = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpUserSession[], HTTPValidationError>({
      path: `/get-endpoint-sessions`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name EditEndpointApiV1EditEndpointPost
   * @summary Edit Endpoint
   * @request POST:/edit-endpoint
   * @secure
   */
  editEndpointApiV1EditEndpointPost = (data: EpUpdate, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/edit-endpoint`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name ResizeEndpointThroughputApiV1ResizeEndpointThroughputPost
   * @summary Resize Endpoint Throughput
   * @request POST:/resize-endpoint-throughput
   * @secure
   */
  resizeEndpointThroughputApiV1ResizeEndpointThroughputPost = (
    query: {
      /** Ep Id */
      ep_id: string;
      /** Direction */
      direction: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/resize-endpoint-throughput`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name EndpointUpdateContactApiV1SetEndpointContactPost
   * @summary Endpoint Update Contact
   * @request POST:/set-endpoint-contact
   * @secure
   */
  endpointUpdateContactApiV1SetEndpointContactPost = (
    query: {
      /** Ep Id */
      ep_id: string;
      /** Primary Contact Id */
      primary_contact_id?: string;
      /** Secondary Contact Id */
      secondary_contact_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-endpoint-contact`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name ConfigureEndpointProxyingApiV1ConfigureEndpointProxyingPost
   * @summary Configure Endpoint Proxying
   * @request POST:/configure-endpoint-proxying
   * @secure
   */
  configureEndpointProxyingApiV1ConfigureEndpointProxyingPost = (
    data: EpProxying,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-endpoint-proxying`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Create a service node group with given account_id.
   *
   * @tags provider, admin, logging, obsolete
   * @name CreateServiceNodeGroupApiV1CreateServiceNodeGroupPost
   * @summary Create Service Node Group
   * @request POST:/create-service-node-group
   * @secure
   */
  createServiceNodeGroupApiV1CreateServiceNodeGroupPost = (
    data: ServiceNodeGroupCreate,
    params: RequestParams = {},
  ) =>
    this.request<ServiceNodeGroup, HTTPValidationError>({
      path: `/create-service-node-group`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description List service node groups under an account.
   *
   * @tags provider, readonly, obsolete
   * @name ListServiceNodeGroupApiV1ListServiceNodeGroupGet
   * @summary List Service Node Group
   * @request GET:/list-service-node-group
   * @secure
   */
  listServiceNodeGroupApiV1ListServiceNodeGroupGet = (
    query?: {
      /** Service Node Group Name */
      service_node_group_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ServiceNodeGroup[], HTTPValidationError>({
      path: `/list-service-node-group`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Remove service node group
   *
   * @tags provider, admin, logging, obsolete
   * @name RemoveServiceNodeGroupApiV1RemoveServiceNodeGroupPost
   * @summary Remove Service Node Group
   * @request POST:/remove-service-node-group
   * @secure
   */
  removeServiceNodeGroupApiV1RemoveServiceNodeGroupPost = (
    query: {
      /** Service Node Group Id */
      service_node_group_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-service-node-group`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Create a service node with given account_id.
   *
   * @tags provider, admin, logging, obsolete
   * @name CreateServiceNodeApiV1CreateServiceNodePost
   * @summary Create Service Node
   * @request POST:/create-service-node
   * @secure
   */
  createServiceNodeApiV1CreateServiceNodePost = (
    data: ServiceNodeCreate,
    params: RequestParams = {},
  ) =>
    this.request<ServiceNode, HTTPValidationError>({
      path: `/create-service-node`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description List service nodes under an account.
   *
   * @tags provider, readonly, obsolete
   * @name ListServiceNodesApiV1ListServiceNodeGet
   * @summary List Service Nodes
   * @request GET:/list-service-node
   * @secure
   */
  listServiceNodesApiV1ListServiceNodeGet = (
    query?: {
      /** Service Node Group Id */
      service_node_group_id?: string;
      /** Service Node Name */
      service_node_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ServiceNode[], HTTPValidationError>({
      path: `/list-service-node`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Remove service node
   *
   * @tags provider, admin, logging, obsolete
   * @name RemoveServiceNodeApiV1RemoveServiceNodePost
   * @summary Remove Service Node
   * @request POST:/remove-service-node
   * @secure
   */
  removeServiceNodeApiV1RemoveServiceNodePost = (
    query: {
      /** Service Node Id */
      service_node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-service-node`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Prepare the OVA for a service node
   *
   * @tags provider, admin, logging, obsolete
   * @name PrepareSnOvaApiV1PrepareSnOvaGet
   * @summary Prepare Sn Ova
   * @request GET:/prepare-sn-ova
   * @secure
   */
  prepareSnOvaApiV1PrepareSnOvaGet = (
    query: {
      /** Service Node Id */
      service_node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/prepare-sn-ova`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get service node detail info
   *
   * @tags provider, readonly, obsolete
   * @name GetServiceNodeDetailApiV1GetServiceNodeDetailGet
   * @summary Get Service Node Detail
   * @request GET:/get-service-node-detail
   * @secure
   */
  getServiceNodeDetailApiV1GetServiceNodeDetailGet = (
    query: {
      /** Service Node Id */
      service_node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ServiceNodeDetail, HTTPValidationError>({
      path: `/get-service-node-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, admin, logging, obsolete
   * @name SetServiceNodeFormFactorApiV1SetServiceNodeFormFactorPost
   * @summary Set Service Node Form Factor
   * @request POST:/set-service-node-form-factor
   * @secure
   */
  setServiceNodeFormFactorApiV1SetServiceNodeFormFactorPost = (
    data: SetNodeFormFactor,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-service-node-form-factor`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Return the list of connected endpoints on an appservice gateway.
   *
   * @tags provider, readonly, obsolete
   * @name GetConnectedEndpointsApiV1GetConnectedEndpointsGet
   * @summary Get Connected Endpoints
   * @request GET:/get-connected-endpoints
   * @secure
   */
  getConnectedEndpointsApiV1GetConnectedEndpointsGet = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-connected-endpoints`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Upload certificate and key for a service node group
   *
   * @tags provider, admin, logging, obsolete
   * @name EnableExternalCertificateApiV1EnableExternalCertificatePost
   * @summary Enable External Certificate
   * @request POST:/enable-external-certificate
   * @secure
   */
  enableExternalCertificateApiV1EnableExternalCertificatePost = (
    data: CertificateUploadRequest,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/enable-external-certificate`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags provider, admin, logging, obsolete
   * @name DisableExternalCertificateApiV1DisableExternalCertificatePost
   * @summary Disable External Certificate
   * @request POST:/disable-external-certificate
   * @secure
   */
  disableExternalCertificateApiV1DisableExternalCertificatePost = (
    data: CertificateDisableRequest,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/disable-external-certificate`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, public
   * @name LoginApiV1TokenPost
   * @summary Login
   * @request POST:/token
   */
  loginApiV1TokenPost = (data: BodyLoginApiV1TokenPost, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/token`,
      method: 'POST',
      body: data,
      type: ContentType.UrlEncoded,
      format: 'json',
      ...params,
    });

  /**
   * @description Triggers forgot password mechanism for a user.
   *
   * @tags common, public
   * @name ForgotPasswordApiV1ForgotPasswordPost
   * @summary Trigger forgot password mechanism for a user
   * @request POST:/forgot-password
   */
  forgotPasswordApiV1ForgotPasswordPost = (
    query: {
      /** Email */
      email: string;
      /** Account Id */
      account_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/forgot-password`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, public
   * @name ResetPasswordTemplateApiV1ResetPasswordTemplateGet
   * @summary Reset password for an account
   * @request GET:/reset-password-template
   */
  resetPasswordTemplateApiV1ResetPasswordTemplateGet = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/reset-password-template`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, public
   * @name ResetPasswordApiV1ResetPasswordPost
   * @summary Reset password for an account
   * @request POST:/reset-password
   */
  resetPasswordApiV1ResetPasswordPost = (
    data: BodyResetPasswordApiV1ResetPasswordPost,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/reset-password`,
      method: 'POST',
      body: data,
      type: ContentType.UrlEncoded,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, public
   * @name VerifyEmailApiV1VerifyEmailGet
   * @summary Verify an account's email address from a signed link
   * @request GET:/verify-email
   */
  verifyEmailApiV1VerifyEmailGet = (params: RequestParams = {}) =>
    this.request<any, void>({
      path: `/verify-email`,
      method: 'GET',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, public
   * @name ResendVerificationApiV1ResendVerificationPost
   * @summary Resend the email-verification link for an account
   * @request POST:/resend-verification
   */
  resendVerificationApiV1ResendVerificationPost = (
    query: {
      /** Email */
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/resend-verification`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common
   * @name GetSwitchableAccountsApiV1SwitchableAccountsGet
   * @summary Get Switchable Accounts
   * @request GET:/switchable-accounts
   * @secure
   */
  getSwitchableAccountsApiV1SwitchableAccountsGet = (params: RequestParams = {}) =>
    this.request<any[], any>({
      path: `/switchable-accounts`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common
   * @name SwitchAccountApiV1SwitchAccountPost
   * @summary Switch Account
   * @request POST:/switch-account
   * @secure
   */
  switchAccountApiV1SwitchAccountPost = (data: SwitchAccountRequest, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/switch-account`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, public
   * @name AcsApiV1AcsPost
   * @summary Callback from Idp to process SAML response
   * @request POST:/acs
   */
  acsApiV1AcsPost = (params: RequestParams = {}) =>
    this.request<any, void>({
      path: `/acs`,
      method: 'POST',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, obsolete
   * @name GetNetStatsApiV1GetNetStatsGet
   * @summary Get Net Stats
   * @request GET:/get-net-stats
   * @secure
   */
  getNetStatsApiV1GetNetStatsGet = (
    query: {
      /** Ids */
      ids: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
      /** App Service Id */
      app_service_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-net-stats`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, sample, public
   * @name GetNodeMetricsApiV1GetNodeMetricsGet
   * @summary Get Node Metrics
   * @request GET:/get-node-metrics
   * @secure
   */
  getNodeMetricsApiV1GetNodeMetricsGet = (
    query: {
      /** Id */
      id: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-node-metrics`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, obsolete
   * @name GetTopTalkerEpApiV1GetTopTalkerEpGet
   * @summary Get Top Talker Ep
   * @request GET:/get-top-talker-ep
   * @secure
   */
  getTopTalkerEpApiV1GetTopTalkerEpGet = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-top-talker-ep`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, obsolete
   * @name GetEpSessionsApiV1GetEpSessionsGet
   * @summary Get Ep Sessions
   * @request GET:/get-ep-sessions
   * @secure
   */
  getEpSessionsApiV1GetEpSessionsGet = (
    query: {
      /** Ep Id */
      ep_id: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-ep-sessions`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Create or update a record mapping an IP CIDR block to an application name.
   *
   * @tags common, readonly, obsolete
   * @name InsertIpAppnameApiV1InsertIpAppnamePost
   * @summary Insert Ip Appname
   * @request POST:/insert-ip-appname
   * @secure
   */
  insertIpAppnameApiV1InsertIpAppnamePost = (data: IPAppName, params: RequestParams = {}) =>
    this.request<IPAppName, HTTPValidationError>({
      path: `/insert-ip-appname`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Delete a record mapping an IP CIDR block to an application name.
   *
   * @tags common, readonly, obsolete
   * @name RemoveIpAppnameApiV1RemoveIpAppnamePost
   * @summary Remove Ip Appname
   * @request POST:/remove-ip-appname
   * @secure
   */
  removeIpAppnameApiV1RemoveIpAppnamePost = (
    query: {
      /** App Name */
      app_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-ip-appname`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get a record mapping an IP CIDR block to an application name.
   *
   * @tags common, readonly, obsolete
   * @name GetCidrByAppnameApiV1GetCidrByAppnameGet
   * @summary Get Cidr By Appname
   * @request GET:/get-cidr-by-appname
   * @secure
   */
  getCidrByAppnameApiV1GetCidrByAppnameGet = (
    query: {
      /** App Name */
      app_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<IPAppName, HTTPValidationError>({
      path: `/get-cidr-by-appname`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get an application name based on IP address
   *
   * @tags common, readonly, obsolete
   * @name GetAppnameByIpApiV1GetAppnameByIpGet
   * @summary Get Appname By Ip
   * @request GET:/get-appname-by-ip
   * @secure
   */
  getAppnameByIpApiV1GetAppnameByIpGet = (data: GetAppNameByIP, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/get-appname-by-ip`,
      method: 'GET',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, obsolete
   * @name PerformFlowAnalysisApiV1PerformFlowAnalysisPost
   * @summary Perform Flow Analysis
   * @request POST:/perform-flow-analysis
   * @secure
   */
  performFlowAnalysisApiV1PerformFlowAnalysisPost = (data: object, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/perform-flow-analysis`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description The Web API to get the node connection up/down history and uptime percentage. uptime/downtime/percent are lifetime values (from the node's earliest event to now) and do not depend on window_hours. When window_hours is given, only the returned history is narrowed to the past window_hours (for "past X days", pass X * 24); this also ensures recent events are returned for very high-churn nodes. When omitted, the full history is returned.
   *
   * @tags common, readonly, tool, public
   * @name GetNodeConnStatusApiV1GetNodeConnStatusGet
   * @summary Get Node Conn Status
   * @request GET:/get-node-conn-status
   * @secure
   */
  getNodeConnStatusApiV1GetNodeConnStatusGet = (
    query: {
      /** Node Id */
      node_id: string;
      /**
       * Window Hours
       * Limit only the returned history to the past this-many hours (for 'past X days', pass X * 24). Max 17520 (~2y retention). uptime/downtime/percent are lifetime values and are unaffected. Omit to return the full history.
       * @min 1
       * @max 17520
       */
      window_hours?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<NodeConnStatus, HTTPValidationError>({
      path: `/get-node-conn-status`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Count how many CPEs experienced an outage (one or more connection 'down' events) within the past window_hours. Scoped to the CPEs the caller is allowed to view; optionally narrowed to an entity (entity_name) and/or a site location (state/province, city, country). For "past X days", pass window_hours = X * 24. Returns the number checked, the number with an outage, and the list of affected CPEs (with per-CPE down-event counts). This does the whole fleet server-side in a single call.
   *
   * @tags common, readonly, tool, public
   * @name GetFleetOutageSummaryApiV1GetFleetOutageSummaryGet
   * @summary Get Fleet Outage Summary
   * @request GET:/get-fleet-outage-summary
   * @secure
   */
  getFleetOutageSummaryApiV1GetFleetOutageSummaryGet = (
    query?: {
      /**
       * Window Hours
       * Look-back window in hours (for 'past X days', pass X * 24). Max 17520 (~2y retention).
       * @min 1
       * @max 17520
       * @default 24
       */
      window_hours?: number;
      /** Entity Name */
      entity_name?: string;
      /** State */
      state?: string;
      /** City */
      city?: string;
      /** Country */
      country?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<FleetOutageSummary, HTTPValidationError>({
      path: `/get-fleet-outage-summary`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description The Web API to get the node DOS stats
   *
   * @tags common, readonly, public
   * @name GetDosStatsApiV1GetDosStatsGet
   * @summary Get Dos Stats
   * @request GET:/get-dos-stats
   * @secure
   */
  getDosStatsApiV1GetDosStatsGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<DosStats, HTTPValidationError>({
      path: `/get-dos-stats`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description List AWS regions
   *
   * @tags common, internal
   * @name ListAwsRegionsApiV1ListAwsRegionsGet
   * @summary List Aws Regions
   * @request GET:/list-aws-regions
   */
  listAwsRegionsApiV1ListAwsRegionsGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/list-aws-regions`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * @description List Azure regions
   *
   * @tags common, internal
   * @name ListAzureRegionsApiV1ListAzureRegionsGet
   * @summary List Azure Regions
   * @request GET:/list-azure-regions
   */
  listAzureRegionsApiV1ListAzureRegionsGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/list-azure-regions`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * @description Generate a token for a CPE. This can be used to re-register the CPE with the controller in case its token expires, without reshipping the device. The generated (encrypted) payload mirrors the ``bootstrap.json`` produced at image-build time: identity, freshly minted Vault credentials, CA chain and the CPE's WAN/product/VLAN configuration. Interface OS names are deliberately omitted -- the device retains its existing interface mapping.
   *
   * @tags common, internal
   * @name GenerateNodeTokenApiV1GenerateNodeTokenPost
   * @summary Generate Node Token
   * @request POST:/generate-node-token
   * @secure
   */
  generateNodeTokenApiV1GenerateNodeTokenPost = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/generate-node-token`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get cloud init file for a node.
   *
   * @tags provider, admin, obsolete
   * @name GenerateNodeCloudInitDataApiV1GenerateNodeCloudInitDataPost
   * @summary Generate Node Cloud Init Data
   * @request POST:/generate-node-cloud-init-data
   * @secure
   */
  generateNodeCloudInitDataApiV1GenerateNodeCloudInitDataPost = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/generate-node-cloud-init-data`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description If the VGW is not ready, proceed with creating the VPC, CGW, VGW, site-to-site VPN and ec2 instance. If the VGW has been created but the EC2 instance has not, proceed with creating ec2 instance. Then it will Generate a site-to-site VPN configuration for the hosted service node.
   *
   * @tags provider, admin, obsolete
   * @name GenerateHsnVpnConfigApiV1GenerateHsnVpnConfigPost
   * @summary Generate Hsn Vpn Config
   * @request POST:/generate-hsn-vpn-config
   * @secure
   */
  generateHsnVpnConfigApiV1GenerateHsnVpnConfigPost = (
    data: SetNodeFormFactor,
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/generate-hsn-vpn-config`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Download site-to-site VPN cfg file
   *
   * @tags provider, admin, obsolete
   * @name DownloadHsnVpnConfigApiV1DownloadHsnVpnConfigFileNameGet
   * @summary Download Hsn Vpn Config
   * @request GET:/download-hsn-vpn-config/{file_name}
   */
  downloadHsnVpnConfigApiV1DownloadHsnVpnConfigFileNameGet = (
    fileName: string,
    params: RequestParams = {},
  ) =>
    this.request<void, HTTPValidationError>({
      path: `/download-hsn-vpn-config/${fileName}`,
      method: 'GET',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, internal
   * @name StartConsoleSessionApiV1StartConsoleSessionPost
   * @summary Start Console Session
   * @request POST:/start-console-session
   * @secure
   */
  startConsoleSessionApiV1StartConsoleSessionPost = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/start-console-session`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Run health check on a connected node.
   *
   * @tags common, readonly, tool, sample, public
   * @name RunHealthCheckApiV1RunHealthCheckGet
   * @summary Run Health Check
   * @request GET:/run-health-check
   * @secure
   */
  runHealthCheckApiV1RunHealthCheckGet = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/run-health-check`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Run diagnostics on a connected node.
   *
   * @tags internal, accountmaster
   * @name RunDiagApiV1RunDiagGet
   * @summary Run Diag
   * @request GET:/run-diag
   * @secure
   */
  runDiagApiV1RunDiagGet = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/run-diag`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Collect a diagnostic bundle on a CPE and upload it to S3. Returns at once; poll /diag-bundle-status for completion.
   *
   * @tags common, readonly, internal, logging
   * @name CollectDiagBundleApiV1CollectDiagBundlePost
   * @summary Collect Diag Bundle
   * @request POST:/collect-diag-bundle
   * @secure
   */
  collectDiagBundleApiV1CollectDiagBundlePost = (
    data: CollectDiagBundleRequest,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/collect-diag-bundle`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description State of a bundle: collecting, uploaded (with a short-lived download_url) or failed.
   *
   * @tags internal, accountmaster, admin
   * @name DiagBundleStatusApiV1DiagBundleStatusGet
   * @summary Diag Bundle Status
   * @request GET:/diag-bundle-status
   * @secure
   */
  diagBundleStatusApiV1DiagBundleStatusGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Bundle Id */
      bundle_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/diag-bundle-status`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Uploaded bundles for a CPE, newest first.
   *
   * @tags internal, accountmaster, admin
   * @name ListDiagBundlesApiV1ListDiagBundlesGet
   * @summary List Diag Bundles
   * @request GET:/list-diag-bundles
   * @secure
   */
  listDiagBundlesApiV1ListDiagBundlesGet = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/list-diag-bundles`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Delete an uploaded bundle.
   *
   * @tags internal, accountmaster, admin
   * @name DeleteDiagBundleApiV1DiagBundleDelete
   * @summary Delete Diag Bundle
   * @request DELETE:/diag-bundle
   * @secure
   */
  deleteDiagBundleApiV1DiagBundleDelete = (
    query: {
      /** Node Id */
      node_id: string;
      /** Bundle Id */
      bundle_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/diag-bundle`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description List nodes and their status.
   *
   * @tags internal, accountmaster
   * @name ListNodesApiV1ListNodesGet
   * @summary List Nodes
   * @request GET:/list-nodes
   * @secure
   */
  listNodesApiV1ListNodesGet = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/list-nodes`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Upgrade a node. Always queues a configure-upgrade config message and replaces any older one, before anything is asked of the node. If target_commit is provided, the node self-upgrades to that build when it receives the config — nothing more to do. If not, the queued message has an empty target, which clears the node's stored upgrade pin, and an immediate forced upgrade is sent. This is the only way to clear a pin, so the clear is committed whether or not the node is reachable. A 500 from the forced upgrade therefore means "the pin change stands, the upgrade did not start", not "nothing happened".
   *
   * @tags internal, accountmaster, logging
   * @name UpgradeNodeApiV1UpgradeNodePost
   * @summary Upgrade Node
   * @request POST:/upgrade-node
   * @secure
   */
  upgradeNodeApiV1UpgradeNodePost = (
    query: {
      /** Node Id */
      node_id: string;
      /**
       * Url
       * @default ""
       */
      url?: string;
      /**
       * Target Commit
       * @default ""
       */
      target_commit?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/upgrade-node`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Reset a node. A reset will recompute config  on the controller and push to node. If hard is True, it will also reboot the node.
   *
   * @tags common, logging, internal
   * @name ResetNodeApiV1ResetNodePost
   * @summary Reset Node
   * @request POST:/reset-node
   * @secure
   */
  resetNodeApiV1ResetNodePost = (
    query: {
      /** Node Id */
      node_id: string;
      /** Hard */
      hard: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/reset-node`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Enable SSH access on a node from diag server.
   *
   * @tags internal, accountmaster, logging
   * @name EnableRemoteAccessApiV1EnableRemoteAccessPost
   * @summary Enable Remote Access
   * @request POST:/enable-remote-access
   * @secure
   */
  enableRemoteAccessApiV1EnableRemoteAccessPost = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/enable-remote-access`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Disable remote access on a node.
   *
   * @tags internal, accountmaster, logging
   * @name DisableRemoteAccessApiV1DisableRemoteAccessPost
   * @summary Disable Remote Access
   * @request POST:/disable-remote-access
   * @secure
   */
  disableRemoteAccessApiV1DisableRemoteAccessPost = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/disable-remote-access`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Reset ports on a CPE or Metro device.
   *
   * @tags common, logging, internal
   * @name ResetInterfaceApiV1ResetInterfacePost
   * @summary Reset Interface
   * @request POST:/reset-interface
   * @secure
   */
  resetInterfaceApiV1ResetInterfacePost = (
    query: {
      /** Node Id */
      node_id: string;
      /** Interface */
      interface: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/reset-interface`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Trigger a node to re-collect and re-publish interface status. The node only sends interface status to the controller on real state transitions (link/IP/IMEI/ICCID change). When new fields are added to the canonical snapshot — e.g. ICCID — already-deployed CPEs whose interface state hasn't changed since the upgrade will not naturally re-publish, leaving the new field NULL on the controller. This endpoint asks the node to walk its InterfaceDB and force-push each interface through the queue path so the controller observes the new shape on the next status drain. The call returns as soon as the node acknowledges the request; the actual collection (live mmcli + pyroute2 reads) runs in the background on the node and the snapshots arrive via the normal interface-status stream.
   *
   * @tags common, logging, internal
   * @name RefreshInterfaceStatusApiV1RefreshInterfaceStatusPost
   * @summary Refresh Interface Status
   * @request POST:/refresh-interface-status
   * @secure
   */
  refreshInterfaceStatusApiV1RefreshInterfaceStatusPost = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/refresh-interface-status`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Run ping on a Node.
   *
   * @tags common, readonly, tool, public
   * @name RunPingApiV1RunPingGet
   * @summary Run Ping
   * @request GET:/run-ping
   * @secure
   */
  runPingApiV1RunPingGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Ip Address */
      ip_address: string;
      /**
       * Interface
       * @default ""
       */
      interface?: string;
      /**
       * Count
       * Number of ICMP echo requests to send. Bounds and the default come from the [diag] section of the controller config.
       */
      count?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/run-ping`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Start a long-running ping on a Node and return immediately.
   *
   * @tags common, readonly, tool, public
   * @name AsyncLongPingApiV1StartAsyncLongPingPost
   * @summary Async Long Ping
   * @request POST:/start-async-long-ping
   * @secure
   */
  asyncLongPingApiV1StartAsyncLongPingPost = (
    query: {
      /** Node Id */
      node_id: string;
      /** Ip Address */
      ip_address: string;
      /**
       * Interface
       * @default ""
       */
      interface?: string;
      /**
       * Duration Minutes
       * How many minutes to ping. Bounds come from the [diag] section of the controller config.
       */
      duration_minutes?: number | string | (number & string);
    },
    params: RequestParams = {},
  ) =>
    this.request<AsyncLongPingResultResponse, HTTPValidationError>({
      path: `/start-async-long-ping`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Stop a long ping, upload its report to the Document section, and return stats.
   *
   * @tags common, readonly, tool, public
   * @name StopAsyncLongPingApiV1StopAsyncLongPingPost
   * @summary Stop Async Long Ping
   * @request POST:/stop-async-long-ping
   * @secure
   */
  stopAsyncLongPingApiV1StopAsyncLongPingPost = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AsyncLongPingResultResponse, HTTPValidationError>({
      path: `/stop-async-long-ping`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get the result of a completed long ping and return its report document.
   *
   * @tags common, readonly, tool, public
   * @name GetAsyncLongPingResultApiV1GetAsyncLongPingResultGet
   * @summary Get Async Long Ping Result
   * @request GET:/get-async-long-ping-result
   * @secure
   */
  getAsyncLongPingResultApiV1GetAsyncLongPingResultGet = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AsyncLongPingResultResponse, HTTPValidationError>({
      path: `/get-async-long-ping-result`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Run traceroute on a Node.
   *
   * @tags common, readonly, tool, public
   * @name RunTracerouteApiV1RunTracerouteGet
   * @summary Run Traceroute
   * @request GET:/run-traceroute
   * @secure
   */
  runTracerouteApiV1RunTracerouteGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Ip Address */
      ip_address: string;
      /**
       * Interface
       * @default ""
       */
      interface?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/run-traceroute`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Run curl on a Node to test HTTP/HTTPS connectivity.
   *
   * @tags common, readonly, tool, public
   * @name RunCurlApiV1RunCurlGet
   * @summary Run Curl
   * @request GET:/run-curl
   * @secure
   */
  runCurlApiV1RunCurlGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Url */
      url: string;
      /**
       * Interface
       * @default ""
       */
      interface?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/run-curl`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Run a command on a Node.
   *
   * @tags internal, accountmaster, logging
   * @name RunCmdApiV1RunCmdPost
   * @summary Run Cmd
   * @request POST:/run-cmd
   * @secure
   */
  runCmdApiV1RunCmdPost = (
    query: {
      /** Node Id */
      node_id: string;
      /** Command */
      command: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/run-cmd`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Run a script on a Node.
   *
   * @tags internal, accountmaster, logging
   * @name RunScriptApiV1RunScriptPost
   * @summary Run Script
   * @request POST:/run-script
   * @secure
   */
  runScriptApiV1RunScriptPost = (data: ExecScript, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/run-script`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Return all DHCP clients leased an address by a CPE or node.
   *
   * @tags common, readonly, tool, public
   * @name GetDhcpClientsApiV1GetDhcpClientsGet
   * @summary Get Dhcp Clients
   * @request GET:/get-dhcp-clients
   * @secure
   */
  getDhcpClientsApiV1GetDhcpClientsGet = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<DHCPClient[], HTTPValidationError>({
      path: `/get-dhcp-clients`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Return interface configuration, state, counters, and cellular diagnostics collected by a CPE or node.
   *
   * @tags common, readonly, tool, public
   * @name GetNetworkStatsApiV1GetNetworkStatsGet
   * @summary Get Network Stats
   * @request GET:/get-network-stats
   * @secure
   */
  getNetworkStatsApiV1GetNetworkStatsGet = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object[], HTTPValidationError>({
      path: `/get-network-stats`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, obsolete
   * @name SubscribeApiV1SubscribePost
   * @summary Subscribe
   * @request POST:/subscribe
   */
  subscribeApiV1SubscribePost = (
    query?: {
      /** Provider */
      provider?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void | HTTPValidationError>({
      path: `/subscribe`,
      method: 'POST',
      query: query,
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name GetStripePublishableKeyApiV1GetStripePublishableKeyGet
   * @summary Get Stripe Publishable Key
   * @request GET:/get-stripe-publishable-key
   * @secure
   */
  getStripePublishableKeyApiV1GetStripePublishableKeyGet = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/get-stripe-publishable-key`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, internal
   * @name CreateStripePaymentApiV1CreateStripePaymentPost
   * @summary Create Stripe Payment
   * @request POST:/create-stripe-payment
   * @secure
   */
  createStripePaymentApiV1CreateStripePaymentPost = (
    data: BillingStribePaymentMethodCreate,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/create-stripe-payment`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name ReportUsageToStripeApiV1ReportUsageToStripePost
   * @summary Report Usage To Stripe
   * @request POST:/report-usage-to-stripe
   * @secure
   */
  reportUsageToStripeApiV1ReportUsageToStripePost = (
    query: {
      /** Product Name */
      product_name: string;
      /** Unit Count */
      unit_count: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/report-usage-to-stripe`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, internal
   * @name GetBillingsApiV1GetBillingsGet
   * @summary Get Billings
   * @request GET:/get-billings
   * @secure
   */
  getBillingsApiV1GetBillingsGet = (params: RequestParams = {}) =>
    this.request<any[], any>({
      path: `/get-billings`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, internal
   * @name SetPreferredBillingApiV1SetPreferredBillingPost
   * @summary Set Preferred Billing
   * @request POST:/set-preferred-billing
   * @secure
   */
  setPreferredBillingApiV1SetPreferredBillingPost = (
    query: {
      /** An enumeration. */
      provider: PaymentProvider;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-preferred-billing`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, internal
   * @name SetupBillingStripeSubscriptionApiV1SetupBillingStripeSubscriptionPost
   * @summary Setup Billing Stripe Subscription
   * @request POST:/setup-billing-stripe-subscription
   * @secure
   */
  setupBillingStripeSubscriptionApiV1SetupBillingStripeSubscriptionPost = (
    data: BillingStripeCreateSubscription,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/setup-billing-stripe-subscription`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, accountowner, logging, internal
   * @name RemoveBillingApiV1RemoveBillingPost
   * @summary Remove Billing
   * @request POST:/remove-billing
   * @secure
   */
  removeBillingApiV1RemoveBillingPost = (
    query: {
      /** An enumeration. */
      provider: PaymentProvider;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-billing`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name CreateUserAgentApiV1CreateUserAgentPost
   * @summary Create User Agent
   * @request POST:/create-user-agent
   * @secure
   */
  createUserAgentApiV1CreateUserAgentPost = (data: UserAgentCreate, params: RequestParams = {}) =>
    this.request<UserAgent, HTTPValidationError>({
      path: `/create-user-agent`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, readonly, obsolete
   * @name ListUserAgentApiV1ListUserAgentGet
   * @summary List User Agent
   * @request GET:/list-user-agent
   * @secure
   */
  listUserAgentApiV1ListUserAgentGet = (
    query?: {
      /** Email */
      email?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<UserAgent[], HTTPValidationError>({
      path: `/list-user-agent`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name RemoveUserAgentApiV1RemoveUserAgentPost
   * @summary Remove User Agent
   * @request POST:/remove-user-agent
   * @secure
   */
  removeUserAgentApiV1RemoveUserAgentPost = (
    query: {
      /** User Agent Id */
      user_agent_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-user-agent`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name LinkUserAgentToEpApiV1LinkUserAgentToEpPost
   * @summary Link User Agent To Ep
   * @request POST:/link-user-agent-to-ep
   * @secure
   */
  linkUserAgentToEpApiV1LinkUserAgentToEpPost = (
    query: {
      /** User Agent Id */
      user_agent_id: string;
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/link-user-agent-to-ep`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name UnlinkUserAgentFromEpApiV1UnlinkUserAgentFromEpPost
   * @summary Unlink User Agent From Ep
   * @request POST:/unlink-user-agent-from-ep
   * @secure
   */
  unlinkUserAgentFromEpApiV1UnlinkUserAgentFromEpPost = (
    query: {
      /** User Agent Id */
      user_agent_id: string;
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/unlink-user-agent-from-ep`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, obsolete
   * @name UserAgentGetOtpApiV1UserAgentGetOtpGet
   * @summary User Agent Get Otp
   * @request GET:/user-agent-get-otp
   */
  userAgentGetOtpApiV1UserAgentGetOtpGet = (
    query: {
      /** Email */
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/user-agent-get-otp`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, obsolete
   * @name UserAgentApiV1UserAgentGet
   * @summary User Agent
   * @request GET:/user-agent
   */
  userAgentApiV1UserAgentGet = (
    query: {
      /** Session Id */
      session_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/user-agent`,
      method: 'GET',
      query: query,
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, obsolete
   * @name UserAgentSigninApiV1UserAgentSigninPost
   * @summary User Agent Signin
   * @request POST:/user-agent-signin
   */
  userAgentSigninApiV1UserAgentSigninPost = (
    data: BodyUserAgentSigninApiV1UserAgentSigninPost,
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/user-agent-signin`,
      method: 'POST',
      body: data,
      type: ContentType.UrlEncoded,
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, obsolete
   * @name UserAgentConnectApiV1UserAgentConnectGet
   * @summary User Agent Connect
   * @request GET:/user-agent-connect
   */
  userAgentConnectApiV1UserAgentConnectGet = (
    query: {
      /** Email */
      email: string;
      /** Otp */
      otp: string;
      /** Session Id */
      session_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/user-agent-connect`,
      method: 'GET',
      query: query,
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, obsolete
   * @name UserAgentGetProfileApiV1UserAgentGetProfileGet
   * @summary User Agent Get Profile
   * @request GET:/user-agent-get-profile
   */
  userAgentGetProfileApiV1UserAgentGetProfileGet = (
    query: {
      /** Session Id */
      session_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/user-agent-get-profile`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, readonly, obsolete
   * @name UserAgentGetLinkedEpApiV1UserAgentGetLinkedEpGet
   * @summary User Agent Get Linked Ep
   * @request GET:/user-agent-get-linked-ep
   * @secure
   */
  userAgentGetLinkedEpApiV1UserAgentGetLinkedEpGet = (
    query: {
      /** User Agent Id */
      user_agent_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/user-agent-get-linked-ep`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, readonly, obsolete
   * @name UserAgentGetUnlinkedEpApiV1UserAgentGetUnlinkedEpGet
   * @summary User Agent Get Unlinked Ep
   * @request GET:/user-agent-get-unlinked-ep
   * @secure
   */
  userAgentGetUnlinkedEpApiV1UserAgentGetUnlinkedEpGet = (
    query?: {
      /** User Agent Id */
      user_agent_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/user-agent-get-unlinked-ep`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, obsolete
   * @name UserAgentVerifyProfileIdApiV1UserAgentVerifyProfileIdGet
   * @summary User Agent Verify Profile Id
   * @request GET:/user-agent-verify-profile-id
   */
  userAgentVerifyProfileIdApiV1UserAgentVerifyProfileIdGet = (
    query: {
      /** Email */
      email: string;
      /** Profile Id */
      profile_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/user-agent-verify-profile-id`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name ContactTypesApiV1ContactTypesGet
   * @summary Contact Types
   * @request GET:/contact-types
   */
  contactTypesApiV1ContactTypesGet = (params: RequestParams = {}) =>
    this.request<any[], any>({
      path: `/contact-types`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name CreateContactApiV1CreateContactPost
   * @summary Create Contact
   * @request POST:/create-contact
   * @secure
   */
  createContactApiV1CreateContactPost = (data: ContactCreate, params: RequestParams = {}) =>
    this.request<Contact, HTTPValidationError>({
      path: `/create-contact`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name GetContactApiV1GetContactGet
   * @summary Get Contact
   * @request GET:/get-contact
   * @secure
   */
  getContactApiV1GetContactGet = (
    query?: {
      /** Email */
      email?: string;
      /** Entity Id */
      entity_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Contact[], HTTPValidationError>({
      path: `/get-contact`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name GetContactByEpIdApiV1GetContactByEpIdGet
   * @summary Get Contact By Ep Id
   * @request GET:/get-contact-by-ep-id
   * @secure
   */
  getContactByEpIdApiV1GetContactByEpIdGet = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/get-contact-by-ep-id`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name RemoveContactApiV1RemoveContactPost
   * @summary Remove Contact
   * @request POST:/remove-contact
   * @secure
   */
  removeContactApiV1RemoveContactPost = (
    query: {
      /** Contact Id */
      contact_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-contact`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name UpdateContactApiV1UpdateContactPost
   * @summary Update Contact
   * @request POST:/update-contact
   * @secure
   */
  updateContactApiV1UpdateContactPost = (
    query: {
      /** Contact Id */
      contact_id: string;
      /** Last Name */
      last_name?: string;
      /** First Name */
      first_name?: string;
      /** Email */
      email?: string;
      /** Address */
      address?: string;
      /** Phone */
      phone?: string;
      /** Company Name */
      company_name?: string;
      /** Contact Type */
      contact_type?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/update-contact`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name ContactAssignEntityApiV1ContactAssignEntityPost
   * @summary Contact Assign Entity
   * @request POST:/contact-assign-entity
   * @secure
   */
  contactAssignEntityApiV1ContactAssignEntityPost = (
    query: {
      /** Contact Id */
      contact_id: string;
      /** Contact Types */
      contact_types: string;
      /** New Entity Name */
      new_entity_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/contact-assign-entity`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name ContactUnassignEntityApiV1ContactUnassignEntityPost
   * @summary Contact Unassign Entity
   * @request POST:/contact-unassign-entity
   * @secure
   */
  contactUnassignEntityApiV1ContactUnassignEntityPost = (
    query: {
      /** Contact Id */
      contact_id: string;
      /** Entity Name */
      entity_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/contact-unassign-entity`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name GetContactAssignedEntitiesApiV1GetContactAssignedEntitiesGet
   * @summary Get Contact Assigned Entities
   * @request GET:/get-contact-assigned-entities
   * @secure
   */
  getContactAssignedEntitiesApiV1GetContactAssignedEntitiesGet = (
    query: {
      /** Contact Id */
      contact_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Entity[], HTTPValidationError>({
      path: `/get-contact-assigned-entities`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name CreateIamUserApiV1CreateIamUserPost
   * @summary Create Iam User
   * @request POST:/create-iam-user
   * @secure
   */
  createIamUserApiV1CreateIamUserPost = (data: IamUserCreate, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/create-iam-user`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, sample, public
   * @name ListIamUserApiV1ListIamUserGet
   * @summary List Iam User
   * @request GET:/list-iam-user
   * @secure
   */
  listIamUserApiV1ListIamUserGet = (
    query?: {
      /** Username */
      username?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<IamUser[], HTTPValidationError>({
      path: `/list-iam-user`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name RemoveIamUserApiV1RemoveIamUserPost
   * @summary Remove Iam User
   * @request POST:/remove-iam-user
   * @secure
   */
  removeIamUserApiV1RemoveIamUserPost = (
    query: {
      /** Iam User Id */
      iam_user_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-iam-user`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, logging, public
   * @name UpdateIamUserApiV1UpdateIamUserPost
   * @summary Update Iam User
   * @request POST:/update-iam-user
   * @secure
   */
  updateIamUserApiV1UpdateIamUserPost = (data: IamUserUpdate, params: RequestParams = {}) =>
    this.request<IamUser, HTTPValidationError>({
      path: `/update-iam-user`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name IamUserGetLogoApiV1IamUserGetLogoGet
   * @summary Iam User Get Logo
   * @request GET:/iam-user-get-logo
   * @secure
   */
  iamUserGetLogoApiV1IamUserGetLogoGet = (
    query?: {
      /** Iam User Id */
      iam_user_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/iam-user-get-logo`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, internal
   * @name IamUserSetLogoApiV1IamUserSetLogoPost
   * @summary Iam User Set Logo
   * @request POST:/iam-user-set-logo
   * @secure
   */
  iamUserSetLogoApiV1IamUserSetLogoPost = (
    query?: {
      /** Logo Url */
      logo_url?: string;
      /** Iam User Id */
      iam_user_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/iam-user-set-logo`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, logging, public
   * @name IamUserEnableMfaApiV1IamUserEnableMfaPost
   * @summary Iam User Enable Mfa
   * @request POST:/iam-user-enable-mfa
   * @secure
   */
  iamUserEnableMfaApiV1IamUserEnableMfaPost = (
    query?: {
      /** An enumeration. */
      type?: MfaType;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/iam-user-enable-mfa`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, logging, public
   * @name IamUserDisableMfaApiV1IamUserDisableMfaPost
   * @summary Iam User Disable Mfa
   * @request POST:/iam-user-disable-mfa
   * @secure
   */
  iamUserDisableMfaApiV1IamUserDisableMfaPost = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/iam-user-disable-mfa`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Back the Edit IAM dialog, which saves an IAM user's name and role. Both fields are optional so the dialog can change either one, but the authorization below gates the IAM user being edited rather than the field being edited, so a name-only save is checked exactly like a role change. The name deliberately does not live on update-iam-user: that endpoint edits whoever is logged in, so accepting a role there would let a readonly IAM user promote itself.
   *
   * @tags common, admin, logging, obsolete
   * @name EditIamUserApiV1IamUserUpdateRolePost
   * @summary Edit Iam User
   * @request POST:/iam-user-update-role
   * @secure
   */
  editIamUserApiV1IamUserUpdateRolePost = (
    query?: {
      /** An enumeration. */
      new_role?: IamRole;
      /** Iam User Id */
      iam_user_id?: string;
      /** Name */
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/iam-user-update-role`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Back the Edit IAM dialog, which saves an IAM user's name and role. Both fields are optional so the dialog can change either one, but the authorization below gates the IAM user being edited rather than the field being edited, so a name-only save is checked exactly like a role change. The name deliberately does not live on update-iam-user: that endpoint edits whoever is logged in, so accepting a role there would let a readonly IAM user promote itself.
   *
   * @tags common, admin, logging, public
   * @name EditIamUserApiV1EditIamUserPost
   * @summary Edit Iam User
   * @request POST:/edit-iam-user
   * @secure
   */
  editIamUserApiV1EditIamUserPost = (
    query?: {
      /** An enumeration. */
      new_role?: IamRole;
      /** Iam User Id */
      iam_user_id?: string;
      /** Name */
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/edit-iam-user`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name NewIamUserSetupTemplateApiV1NewIamUserSetupTemplateGet
   * @summary New Iam User Setup Template
   * @request GET:/new-iam-user-setup-template
   */
  newIamUserSetupTemplateApiV1NewIamUserSetupTemplateGet = (
    query: {
      /** Iam User Token */
      iam_user_token: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/new-iam-user-setup-template`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, logging, public
   * @name NewIamUserSetupPasswordApiV1NewIamUserSetPasswordPost
   * @summary New Iam User Setup Password
   * @request POST:/new-iam-user-set-password
   */
  newIamUserSetupPasswordApiV1NewIamUserSetPasswordPost = (
    data: BodyNewIamUserSetupPasswordApiV1NewIamUserSetPasswordPost,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/new-iam-user-set-password`,
      method: 'POST',
      body: data,
      type: ContentType.UrlEncoded,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name IamUserAssignEntityApiV1IamUserAssignEntityPost
   * @summary Iam User Assign Entity
   * @request POST:/iam-user-assign-entity
   * @secure
   */
  iamUserAssignEntityApiV1IamUserAssignEntityPost = (
    query: {
      /** Iam User Id */
      iam_user_id: string;
      /** New Entity Name */
      new_entity_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/iam-user-assign-entity`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name CreateEpNodeGroupApiV1CreateEndpointNodeGroupPost
   * @summary Create Ep Node Group
   * @request POST:/create-endpoint-node-group
   * @secure
   */
  createEpNodeGroupApiV1CreateEndpointNodeGroupPost = (
    data: EpNodeGroupCreate,
    params: RequestParams = {},
  ) =>
    this.request<EpNodeGroup, HTTPValidationError>({
      path: `/create-endpoint-node-group`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, readonly, obsolete
   * @name ListEpNodeGroupApiV1ListEndpointNodeGroupGet
   * @summary List Ep Node Group
   * @request GET:/list-endpoint-node-group
   * @secure
   */
  listEpNodeGroupApiV1ListEndpointNodeGroupGet = (
    query?: {
      /** Ep Node Group Name */
      ep_node_group_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpNodeGroup[], HTTPValidationError>({
      path: `/list-endpoint-node-group`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, readonly, obsolete
   * @name GetEpNodeGroupDetailsApiV1GetEndpointNodeGroupDetailsGet
   * @summary Get Ep Node Group Details
   * @request GET:/get-endpoint-node-group-details
   * @secure
   */
  getEpNodeGroupDetailsApiV1GetEndpointNodeGroupDetailsGet = (
    query: {
      /** Ep Node Group Id */
      ep_node_group_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpNodeGroupDetail, HTTPValidationError>({
      path: `/get-endpoint-node-group-details`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name RemoveEpNodeGroupApiV1RemoveEndpointNodeGroupPost
   * @summary Remove Ep Node Group
   * @request POST:/remove-endpoint-node-group
   * @secure
   */
  removeEpNodeGroupApiV1RemoveEndpointNodeGroupPost = (
    query: {
      /** Ep Node Group Id */
      ep_node_group_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-endpoint-node-group`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name CreateEpNodeApiV1CreateEndpointNodePost
   * @summary Create Ep Node
   * @request POST:/create-endpoint-node
   * @secure
   */
  createEpNodeApiV1CreateEndpointNodePost = (data: EpNodeCreate, params: RequestParams = {}) =>
    this.request<EpNode, HTTPValidationError>({
      path: `/create-endpoint-node`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, readonly, obsolete
   * @name ListEpNodeApiV1ListEndpointNodeGet
   * @summary List Ep Node
   * @request GET:/list-endpoint-node
   * @secure
   */
  listEpNodeApiV1ListEndpointNodeGet = (
    query?: {
      /** Ep Node Group Id */
      ep_node_group_id?: string;
      /** Ep Node Name */
      ep_node_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpNode[], HTTPValidationError>({
      path: `/list-endpoint-node`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name RemoveEpNodeApiV1RemoveEndpointNodePost
   * @summary Remove Ep Node
   * @request POST:/remove-endpoint-node
   * @secure
   */
  removeEpNodeApiV1RemoveEndpointNodePost = (
    query: {
      /** Ep Node Group Id */
      ep_node_group_id: string;
      /** Ep Node Id */
      ep_node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-endpoint-node`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, readonly, obsolete
   * @name GetEndpointNodeDetailApiV1GetEndpointNodeDetailGet
   * @summary Get Endpoint Node Detail
   * @request GET:/get-endpoint-node-detail
   * @secure
   */
  getEndpointNodeDetailApiV1GetEndpointNodeDetailGet = (
    query: {
      /** Ep Node Id */
      ep_node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpNodeDetail, HTTPValidationError>({
      path: `/get-endpoint-node-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, obsolete
   * @name PrepareEpnOvaApiV1PrepareEpnOvaGet
   * @summary Prepare Epn Ova
   * @request GET:/prepare-epn-ova
   * @secure
   */
  prepareEpnOvaApiV1PrepareEpnOvaGet = (
    query: {
      /** Ep Node Id */
      ep_node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/prepare-epn-ova`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name AddEndpointNodeSecondaryIpsApiV1AddEndpointNodeSecondaryIpsPost
   * @summary Add Endpoint Node Secondary Ips
   * @request POST:/add-endpoint-node-secondary-ips
   * @secure
   */
  addEndpointNodeSecondaryIpsApiV1AddEndpointNodeSecondaryIpsPost = (
    query: {
      /** Ep Node Id */
      ep_node_id: string;
      /** Secondary Ips */
      secondary_ips: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/add-endpoint-node-secondary-ips`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name SetEndpointNodeFormFactorApiV1SetEndpointNodeFormFactorPost
   * @summary Set Endpoint Node Form Factor
   * @request POST:/set-endpoint-node-form-factor
   * @secure
   */
  setEndpointNodeFormFactorApiV1SetEndpointNodeFormFactorPost = (
    data: SetNodeFormFactor,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-endpoint-node-form-factor`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name ConfigureLanInterfaceApiV1ConfigureLanInterfacePost
   * @summary Configure Lan Interface
   * @request POST:/configure-lan-interface
   * @secure
   */
  configureLanInterfaceApiV1ConfigureLanInterfacePost = (
    data: LANInterface,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-lan-interface`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name ConfigureDhcpRelayApiV1ConfigureDhcpRelayPost
   * @summary Configure Dhcp Relay
   * @request POST:/configure-dhcp-relay
   * @secure
   */
  configureDhcpRelayApiV1ConfigureDhcpRelayPost = (data: DHCPRelay, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-dhcp-relay`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags consumer, admin, logging, obsolete
   * @name ConfigureVrrpApiV1ConfigureVrrpPost
   * @summary Configure Vrrp
   * @request POST:/configure-vrrp
   * @secure
   */
  configureVrrpApiV1ConfigureVrrpPost = (data: VRRPConfig, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-vrrp`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description List all catalogued features and their enforce state.
   *
   * @tags internal, accountmaster
   * @name ListFeatureCatalogApiV1ListFeatureCatalogGet
   * @summary List Feature Catalog
   * @request GET:/list-feature-catalog
   * @secure
   */
  listFeatureCatalogApiV1ListFeatureCatalogGet = (params: RequestParams = {}) =>
    this.request<FeatureCatalog[], any>({
      path: `/list-feature-catalog`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description List the valid entitlement scope types accepted by the entitlement endpoints.
   *
   * @tags internal, accountmaster
   * @name ListScopeTypesApiV1ListScopeTypesGet
   * @summary List Scope Types
   * @request GET:/list-scope-types
   * @secure
   */
  listScopeTypesApiV1ListScopeTypesGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/list-scope-types`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Create a feature catalog entry, or update the provided fields if it already exists. Omitted fields are left unchanged; enforce defaults to False on first creation (use set-feature-enforce to turn enforcement on).
   *
   * @tags internal, accountmaster, logging
   * @name UpsertFeatureCatalogApiV1UpsertFeatureCatalogPost
   * @summary Upsert Feature Catalog
   * @request POST:/upsert-feature-catalog
   * @secure
   */
  upsertFeatureCatalogApiV1UpsertFeatureCatalogPost = (
    data: FeatureCatalogUpsert,
    params: RequestParams = {},
  ) =>
    this.request<FeatureCatalog, HTTPValidationError>({
      path: `/upsert-feature-catalog`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Turn enforcement on/off for a feature. With enforce=True, guarded calls whose target scope has no active entitlement are blocked (402); with enforce=False the feature is tracked-only.
   *
   * @tags internal, accountmaster, logging
   * @name SetFeatureEnforceApiV1SetFeatureEnforcePost
   * @summary Set Feature Enforce
   * @request POST:/set-feature-enforce
   * @secure
   */
  setFeatureEnforceApiV1SetFeatureEnforcePost = (
    data: FeatureEnforceSet,
    params: RequestParams = {},
  ) =>
    this.request<FeatureCatalog, HTTPValidationError>({
      path: `/set-feature-enforce`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Grant or revoke a feature on a scope (cpe / entity / account). Upserts on (scope_type, scope_id, feature_key): set enabled=false to revoke without deleting the row. source is recorded as "manual". Note this does not verify that scope_id refers to an existing CPE/entity/account.
   *
   * @tags internal, accountmaster, logging
   * @name SetFeatureEntitlementApiV1SetFeatureEntitlementPost
   * @summary Set Feature Entitlement
   * @request POST:/set-feature-entitlement
   * @secure
   */
  setFeatureEntitlementApiV1SetFeatureEntitlementPost = (
    data: FeatureEntitlementSet,
    params: RequestParams = {},
  ) =>
    this.request<FeatureEntitlement, HTTPValidationError>({
      path: `/set-feature-entitlement`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Grant or revoke several features on one scope (cpe / entity / account) in a single upsert. Each item carries its own enabled/expires_at, so one call can enable some features and disable others. Idempotent on enabled: a feature already in the requested enabled state is not re-enabled, but supplying a new expires_at refreshes its expiry. Set enabled=false to revoke without deleting the rows. source is recorded as "manual". Like set-feature-entitlement, this does not verify that scope_id refers to an existing CPE/entity/account. Returns the current entitlement rows for the requested features.
   *
   * @tags internal, accountmaster, logging
   * @name SetFeatureEntitlementsApiV1SetFeatureEntitlementsPost
   * @summary Set Feature Entitlements
   * @request POST:/set-feature-entitlements
   * @secure
   */
  setFeatureEntitlementsApiV1SetFeatureEntitlementsPost = (
    data: FeatureEntitlementSetBatch,
    params: RequestParams = {},
  ) =>
    this.request<FeatureEntitlement[], HTTPValidationError>({
      path: `/set-feature-entitlements`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description List entitlements, optionally filtered by scope_type / scope_id / feature_key. Features are always returned in feature-catalog order (the order they are defined in the catalog). When a concrete scope is targeted (both scope_type and scope_id given), the result is padded to the full feature catalog: every catalogued feature that has no row at this scope is returned as disabled (enabled=False, source="default"), so the caller sees every feature, not only the ones explicitly set. This is the scope's *own* state — it does not resolve inherited entitlements from a parent entity/account (use get-cpe-feature-matrix for the effective, inherited view). With no scope (or only scope_type), returns just the raw rows that exist, still ordered by catalog position (rows for uncatalogued features last).
   *
   * @tags internal, accountmaster
   * @name ListFeatureEntitlementsApiV1ListFeatureEntitlementsGet
   * @summary List Feature Entitlements
   * @request GET:/list-feature-entitlements
   * @secure
   */
  listFeatureEntitlementsApiV1ListFeatureEntitlementsGet = (
    query?: {
      /** Scope Type */
      scope_type?: string;
      /** Scope Id */
      scope_id?: string;
      /** Feature Key */
      feature_key?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<FeatureEntitlement[], HTTPValidationError>({
      path: `/list-feature-entitlements`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Hard-delete an entitlement row for (scope_type, scope_id, feature_key). Returns {"deleted": N}. To revoke while keeping an audit trail, use set-feature-entitlement with enabled=false instead.
   *
   * @tags internal, accountmaster, logging
   * @name DeleteFeatureEntitlementApiV1DeleteFeatureEntitlementPost
   * @summary Delete Feature Entitlement
   * @request POST:/delete-feature-entitlement
   * @secure
   */
  deleteFeatureEntitlementApiV1DeleteFeatureEntitlementPost = (
    query: {
      /** Scope Type */
      scope_type: string;
      /** Scope Id */
      scope_id: string;
      /** Feature Key */
      feature_key: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/delete-feature-entitlement`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Read rolled-up feature usage, optionally filtered by scope_type / scope_id / feature_key / account_id.
   *
   * @tags internal, accountmaster
   * @name GetFeatureUsageApiV1GetFeatureUsageGet
   * @summary Get Feature Usage
   * @request GET:/get-feature-usage
   * @secure
   */
  getFeatureUsageApiV1GetFeatureUsageGet = (
    query?: {
      /** Scope Type */
      scope_type?: string;
      /** Scope Id */
      scope_id?: string;
      /** Feature Key */
      feature_key?: string;
      /** Account Id */
      account_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<FeatureUsage[], HTTPValidationError>({
      path: `/get-feature-usage`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Aggregate usage over a scope's subtree, grouped by feature_key: - cpe:     that CPE only - entity:  the entity + all descendant entities + all CPEs under them - account: everything owned by the account Optionally narrowed to a single feature_key.
   *
   * @tags internal, accountmaster
   * @name GetFeatureUsageRollupApiV1GetFeatureUsageRollupGet
   * @summary Get Feature Usage Rollup
   * @request GET:/get-feature-usage-rollup
   * @secure
   */
  getFeatureUsageRollupApiV1GetFeatureUsageRollupGet = (
    query: {
      /** Scope Type */
      scope_type: string;
      /** Scope Id */
      scope_id: string;
      /** Feature Key */
      feature_key?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<FeatureUsageRollup[], HTTPValidationError>({
      path: `/get-feature-usage-rollup`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Per-CPE feature table: every catalogued feature with its effective (resolved, inherited) enabled state for the CPE and the CPE's own usage. - enabled reflects the most-specific active entitlement along the CPE's chain (CPE -> its entity -> parent entities -> account), so a feature granted at the account or entity level shows as enabled here too. entitlement_scope_type/id say where that grant lives. - usage_count / last_used_at are the CPE-scope counter (0 / null if the feature was never used on this CPE).
   *
   * @tags internal, accountmaster
   * @name GetCpeFeatureMatrixApiV1GetCpeFeatureMatrixGet
   * @summary Get Cpe Feature Matrix
   * @request GET:/get-cpe-feature-matrix
   * @secure
   */
  getCpeFeatureMatrixApiV1GetCpeFeatureMatrixGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CpeFeatureRow[], HTTPValidationError>({
      path: `/get-cpe-feature-matrix`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name CpeProductsApiV1CpeProductsGet
   * @summary Cpe Products
   * @request GET:/cpe-products
   */
  cpeProductsApiV1CpeProductsGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/cpe-products`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name GetPeerIpApiV1GetPeerIpGet
   * @summary Get Peer Ip
   * @request GET:/get-peer-ip
   */
  getPeerIpApiV1GetPeerIpGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/get-peer-ip`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * @description Load regions from S3 bucket or local file and get all region keys. First tries to download from S3 and save to local file. If that fails, falls back to using the local file if it exists. Returns regions in alphabetical order with location names for display purposes.
   *
   * @tags common, readonly, internal
   * @name GetPeerRegionsApiV1GetPeerRegionsGet
   * @summary Get Peer Regions
   * @request GET:/get-peer-regions
   */
  getPeerRegionsApiV1GetPeerRegionsGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/get-peer-regions`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * @description Create a CPE with given parameters.
   *
   * @tags common, admin, logging, public
   * @name CreateCpeApiV1CreateCpePost
   * @summary Create Cpe
   * @request POST:/create-cpe
   * @secure
   */
  createCpeApiV1CreateCpePost = (
    data: BaseNull &
      (
        | BaseNullProdCodeMapping<'BN-CPE-1000', CpeCreateWithWan>
        | BaseNullProdCodeMapping<'BN-CPE-1000C', CpeCreateWithWan>
        | BaseNullProdCodeMapping<'BN-CPE-1000F', CpeCreateWithWan>
        | BaseNullProdCodeMapping<'BN-CPE-1000FC', CpeCreateWithWan>
        | BaseNullProdCodeMapping<'BN-CPE-10GF', CpeCreateWithWan>
        | BaseNullProdCodeMapping<'BN-CPE-10GFC', CpeCreateWithWan>
        | BaseNullProdCodeMapping<'BN-CPE-IP', CpeCreateIp>
      ),
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/create-cpe`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Return all CPEs in 'registered' admin_state for the authenticated account. These are the CPEs currently deployed and in operation. Master account sees all provisioned CPEs across all accounts.
   *
   * @tags common, readonly, tool, sample, public
   * @name GetCpeApiV1GetCpeGet
   * @summary Get Cpe
   * @request GET:/get-cpe
   * @secure
   */
  getCpeApiV1GetCpeGet = (
    query?: {
      /** Cpe Name */
      cpe_name?: string;
      /** Entity Name */
      entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe[], HTTPValidationError>({
      path: `/get-cpe`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Returns all CPEs with cellular interface
   *
   * @tags common, readonly, tool, public
   * @name GetCpeCellularApiV1GetCpeCellularGet
   * @summary Get Cpe Cellular
   * @request GET:/get-cpe-cellular
   * @secure
   */
  getCpeCellularApiV1GetCpeCellularGet = (
    query?: {
      /** Cpe Name */
      cpe_name?: string;
      /** Entity Name */
      entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe[], HTTPValidationError>({
      path: `/get-cpe-cellular`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Return all CPEs in 'provisioned' admin_state for the authenticated account. Master account sees all provisioned CPEs across all accounts.
   *
   * @tags common, readonly, public
   * @name GetProvisionedCpeApiV1GetProvisionedCpeGet
   * @summary Get Provisioned Cpe
   * @request GET:/get-provisioned-cpe
   * @secure
   */
  getProvisionedCpeApiV1GetProvisionedCpeGet = (params: RequestParams = {}) =>
    this.request<CpeProvisioned[], any>({
      path: `/get-provisioned-cpe`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Returns more detailed information of a particular CPE, for example information about interfaces on the CPE.
   *
   * @tags common, readonly, tool, public
   * @name GetCpeDetailApiV1GetCpeDetailGet
   * @summary Get Cpe Detail
   * @request GET:/get-cpe-detail
   * @secure
   */
  getCpeDetailApiV1GetCpeDetailGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CpeDetail, HTTPValidationError>({
      path: `/get-cpe-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, internal
   * @name GenerateProvisioningTokenApiV1GenerateProvisioningTokenPost
   * @summary Generate Provisioning Token
   * @request POST:/generate-provisioning-token
   * @secure
   */
  generateProvisioningTokenApiV1GenerateProvisioningTokenPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CpeDetail, HTTPValidationError>({
      path: `/generate-provisioning-token`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name RemoveCpeApiV1RemoveCpePost
   * @summary Remove Cpe
   * @request POST:/remove-cpe
   * @secure
   */
  removeCpeApiV1RemoveCpePost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-cpe`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name UpdateCpeInfoApiV1UpdateCpeInfoPost
   * @summary Update Cpe Info
   * @request POST:/update-cpe-info
   * @secure
   */
  updateCpeInfoApiV1UpdateCpeInfoPost = (data: CpeInfoUpdate, params: RequestParams = {}) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/update-cpe-info`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name ToggleCpeNetflowApiV1ToggleCpeNetflowPost
   * @summary Toggle Cpe Netflow
   * @request POST:/toggle-cpe-netflow
   * @secure
   */
  toggleCpeNetflowApiV1ToggleCpeNetflowPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-netflow`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name ToggleCpeAppVisibilityApiV1ToggleCpeAppVisibilityPost
   * @summary Toggle Cpe App Visibility
   * @request POST:/toggle-cpe-app-visibility
   * @secure
   */
  toggleCpeAppVisibilityApiV1ToggleCpeAppVisibilityPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-app-visibility`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Enable or disable (mute) WAN link-flap alert emails for a single CPE. Controller-side only: unlike the netflow/DoS toggles there is no node message, because flap alerting is decided entirely on the controller (core/wan_flap.py reads this flag before sending the email).
   *
   * @tags common, admin, logging, public
   * @name ToggleCpeWanFlapAlertApiV1ToggleCpeWanFlapAlertPost
   * @summary Toggle Cpe Wan Flap Alert
   * @request POST:/toggle-cpe-wan-flap-alert
   * @secure
   */
  toggleCpeWanFlapAlertApiV1ToggleCpeWanFlapAlertPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-wan-flap-alert`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name ToggleCpeMonitorInboundPubIpApiV1ToggleCpeMonitorInboundPubIpPost
   * @summary Toggle Cpe Monitor Inbound Pub Ip
   * @request POST:/toggle-cpe-monitor-inbound-pub-ip
   * @secure
   */
  toggleCpeMonitorInboundPubIpApiV1ToggleCpeMonitorInboundPubIpPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-monitor-inbound-pub-ip`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name ToggleCpeMonitorOutboundPubIpApiV1ToggleCpeMonitorOutboundPubIpPost
   * @summary Toggle Cpe Monitor Outbound Pub Ip
   * @request POST:/toggle-cpe-monitor-outbound-pub-ip
   * @secure
   */
  toggleCpeMonitorOutboundPubIpApiV1ToggleCpeMonitorOutboundPubIpPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-monitor-outbound-pub-ip`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name ToggleCpeGeoVisibilityApiV1ToggleCpeGeoVisibilityPost
   * @summary Toggle Cpe Geo Visibility
   * @request POST:/toggle-cpe-geo-visibility
   * @secure
   */
  toggleCpeGeoVisibilityApiV1ToggleCpeGeoVisibilityPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-geo-visibility`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name ToggleCpeDosApiV1ToggleCpeDenialOfServicePost
   * @summary Toggle Cpe Dos
   * @request POST:/toggle-cpe-denial-of-service
   * @secure
   */
  toggleCpeDosApiV1ToggleCpeDenialOfServicePost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-denial-of-service`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name SetCpeDenialOfServiceThresholdsApiV1SetCpeDenialOfServiceThresholdsPost
   * @summary Set Cpe Denial Of Service Thresholds
   * @request POST:/set-cpe-denial-of-service-thresholds
   * @secure
   */
  setCpeDenialOfServiceThresholdsApiV1SetCpeDenialOfServiceThresholdsPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    data: BodySetCpeDenialOfServiceThresholdsApiV1SetCpeDenialOfServiceThresholdsPost,
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/set-cpe-denial-of-service-thresholds`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Get denial of service thresholds for a specific CPE
   *
   * @tags common, admin, public
   * @name GetCpeDenialOfServiceThresholdsApiV1GetCpeDenialOfServiceThresholdsGet
   * @summary Get Cpe Denial Of Service Thresholds
   * @request GET:/get-cpe-denial-of-service-thresholds
   * @secure
   */
  getCpeDenialOfServiceThresholdsApiV1GetCpeDenialOfServiceThresholdsGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/get-cpe-denial-of-service-thresholds`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name ToggleCpeDosAlertApiV1ToggleCpeDenialOfServiceAlertPost
   * @summary Toggle Cpe Dos Alert
   * @request POST:/toggle-cpe-denial-of-service-alert
   * @secure
   */
  toggleCpeDosAlertApiV1ToggleCpeDenialOfServiceAlertPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-denial-of-service-alert`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name ToggleCpeMaliciousIpBlockApiV1ToggleCpeMaliciousIpBlockPost
   * @summary Toggle Cpe Malicious Ip Block
   * @request POST:/toggle-cpe-malicious-ip-block
   * @secure
   */
  toggleCpeMaliciousIpBlockApiV1ToggleCpeMaliciousIpBlockPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-malicious-ip-block`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name StartCpeTestApiV1StartCpeTestPost
   * @summary Start Cpe Test
   * @request POST:/start-cpe-test
   * @secure
   */
  startCpeTestApiV1StartCpeTestPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Peer Ip */
      peer_ip: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/start-cpe-test`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Start RFC2544 performance test with an iperf server
   *
   * @tags common, readonly, internal
   * @name StartCpePerformanceTestApiV1StartCpePerformanceTestPost
   * @summary Start Cpe Performance Test
   * @request POST:/start-cpe-performance-test
   * @secure
   */
  startCpePerformanceTestApiV1StartCpePerformanceTestPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Region */
      region: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/start-cpe-performance-test`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name GetCpeTestReportApiV1GetCpeTestReportGet
   * @summary Get Cpe Test Report
   * @request GET:/get-cpe-test-report
   * @secure
   */
  getCpeTestReportApiV1GetCpeTestReportGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-cpe-test-report`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name CpeAssignEntityApiV1CpeAssignEntityPost
   * @summary Cpe Assign Entity
   * @request POST:/cpe-assign-entity
   * @secure
   */
  cpeAssignEntityApiV1CpeAssignEntityPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** New Entity Name */
      new_entity_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/cpe-assign-entity`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Set the CPE's connection-status start time (the anchor from which uptime/downtime are computed) to the current UTC time. Write-once: this is rejected if the CPE already has a start time set.
   *
   * @tags common, admin, logging, public
   * @name ResetCpeConnStatusStartApiV1ResetCpeConnStatusStartPost
   * @summary Reset Cpe Conn Status Start
   * @request POST:/reset-cpe-conn-status-start
   * @secure
   */
  resetCpeConnStatusStartApiV1ResetCpeConnStatusStartPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/reset-cpe-conn-status-start`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name StartCpeIpServiceApiV1StartCpeIpServicePost
   * @summary Start Cpe Ip Service
   * @request POST:/start-cpe-ip-service
   * @secure
   */
  startCpeIpServiceApiV1StartCpeIpServicePost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/start-cpe-ip-service`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name StopCpeIpServiceApiV1StopCpeIpServicePost
   * @summary Stop Cpe Ip Service
   * @request POST:/stop-cpe-ip-service
   * @secure
   */
  stopCpeIpServiceApiV1StopCpeIpServicePost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/stop-cpe-ip-service`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name UpdateCpeIpMonitorTargetApiV1UpdateCpeIpMonitorTargetPost
   * @summary Update Cpe Ip Monitor Target
   * @request POST:/update_cpe_ip_monitor_target
   * @secure
   */
  updateCpeIpMonitorTargetApiV1UpdateCpeIpMonitorTargetPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Ip Monitor Target */
      ip_monitor_target?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/update_cpe_ip_monitor_target`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Update CPE Mode.
   *
   * @tags common, admin, logging, public
   * @name EditCpeNetworkApiV1EditCpeNetworkPost
   * @summary Edit Cpe Network
   * @request POST:/edit-cpe-network
   * @secure
   */
  editCpeNetworkApiV1EditCpeNetworkPost = (data: CpeEditNetwork, params: RequestParams = {}) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/edit-cpe-network`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Update the free-text ``description`` of a single CPE interface, identified by its ``role`` (InterfaceType value, e.g. "WAN0", "LAN0", "MGMT"). Returns the refreshed CPE detail so the caller sees the new description in the ``ports`` map.
   *
   * @tags common, admin, logging, public
   * @name EditCpeInterfaceDescriptionApiV1EditCpeInterfaceDescriptionPost
   * @summary Edit Cpe Interface Description
   * @request POST:/edit-cpe-interface-description
   * @secure
   */
  editCpeInterfaceDescriptionApiV1EditCpeInterfaceDescriptionPost = (
    data: CpeInterfaceDescriptionUpdate,
    params: RequestParams = {},
  ) =>
    this.request<CpeDetail, HTTPValidationError>({
      path: `/edit-cpe-interface-description`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Set a CPE's down-notification scan interval, and optionally mute op-state-change notifications to the customer. ``mute_notification`` is tri-state: ``None`` (default) leaves the existing mute untouched so callers that only change the interval are unaffected; ``True`` mutes customer notifications for ``mute_hours``; ``False`` clears the mute. While muted a flapping CPE no longer emails the customer, but support still receives every alert. The mute self-expires so notifications resume with no follow-up action.
   *
   * @tags common, admin, logging, public
   * @name SetCpeScanIntervalApiV1SetCpeScanIntervalPost
   * @summary Set Cpe Scan Interval
   * @request POST:/set-cpe-scan-interval
   * @secure
   */
  setCpeScanIntervalApiV1SetCpeScanIntervalPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Scan Interval */
      scan_interval: number;
      /** Override Email */
      override_email?: string;
      /** Mute Notification */
      mute_notification?: boolean;
      /**
       * Mute Hours
       * @default 24
       */
      mute_hours?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-cpe-scan-interval`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, public
   * @name GetCpeScanIntervalApiV1GetCpeScanIntervalGet
   * @summary Get Cpe Scan Interval
   * @request GET:/get-cpe-scan-interval
   * @secure
   */
  getCpeScanIntervalApiV1GetCpeScanIntervalGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/get-cpe-scan-interval`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name ConfigureIperfServerApiV1ConfigureIperfServerPost
   * @summary Configure Iperf Server
   * @request POST:/configure-iperf-server
   * @secure
   */
  configureIperfServerApiV1ConfigureIperfServerPost = (
    data: IperfServer,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-iperf-server`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name ConfigurePerfTestScheduleApiV1ConfigurePerfTestSchedulePost
   * @summary Configure Perf Test Schedule
   * @request POST:/configure-perf-test-schedule
   * @secure
   */
  configurePerfTestScheduleApiV1ConfigurePerfTestSchedulePost = (
    data: PerfTestSchedule,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-perf-test-schedule`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Return the user-facing LAN port names for a CPE — every LAN0..LAN7 that is currently configured in the per-CPE Interface_Table. Names come from the rows, so the answer is right whatever the product's naming: on dual-SFP CPEs (where the copper LAN jack is LAN3), on SFP-capable CPEs whose free cages are LAN4 / LAN5, on 10G CPEs bridging LAN6 / LAN7, and on CPEs that bridge multiple LAN ports (router or passthrough).
   *
   * @tags common, readonly, tool, public
   * @name GetLanInterfacesApiV1GetCpeLanInterfacesGet
   * @summary Get Lan Interfaces
   * @request GET:/get-cpe-lan-interfaces
   * @secure
   */
  getLanInterfacesApiV1GetCpeLanInterfacesGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string[], HTTPValidationError>({
      path: `/get-cpe-lan-interfaces`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Return all configured interfaces on the CPE as a flat list of ``{name, role}`` pairs. Same source of truth as ``/get-cpe-detail`` (under the ``ports`` key) but flattened to just the two fields a UI picker needs: * ``name`` — user-facing port label (e.g. ``"eth1"``) * ``role`` — :class:`InterfaceType` value (e.g. ``"LAN0"``, ``"WAN0"``) Sorted with the WAN family first (WAN0, WAN1, ..., then CELLULAR as the cellular uplink), then the LAN family (LAN0, LAN1, ...), then everything else by role name. This matches the order a UI picker wants to render the dropdown without re-sorting client-side. Designed for the packet-capture interface dropdown — clients pass the returned ``role`` straight through to ``/start-capture``. Pass ``hardware_only=true`` to exclude the MGMT role. MGMT is a logical management interface that sits behind the same NIC as another role on most products and isn't useful as a packet-capture target on its own; callers driving the capture UI typically want it suppressed.
   *
   * @tags common, readonly, tool, public
   * @name GetCpeInterfacesApiV1GetCpeInterfacesGet
   * @summary Get Cpe Interfaces
   * @request GET:/get-cpe-interfaces
   * @secure
   */
  getCpeInterfacesApiV1GetCpeInterfacesGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /**
       * Hardware Only
       * @default false
       */
      hardware_only?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<CpeInterface[], HTTPValidationError>({
      path: `/get-cpe-interfaces`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Start speedtest CLI (ookla or fastcom) on a CPE without needing an iperf server Args: cpe_id: CPE identifier test_type: Type of speed test ('ookla' or 'fast.com') ookla_enable_shortest_distance: If True, automatically select closest Ookla server (default: False) ookla_server_id: Specific Ookla server ID to use (optional, overrides auto-selection) ookla_interface: Network interface to bind for the test: "cellular", "wan0", or "wan1" (optional) async_session: Database session Note: For Ookla tests: - If ookla_server_id is provided, that specific server will be used - If ookla_enable_shortest_distance is True, the closest server will be auto-selected - If neither is provided, CPE will use default server selection - ookla_interface selects which WAN to test: cellular (wwan0), wan0 (mgmt), or wan1 (2nd WAN)
   *
   * @tags common, readonly, tool, sample, public
   * @name StartCpeSpeedtestCliEndpointApiV1StartCpeSpeedtestCliPost
   * @summary Start Cpe Speedtest Cli Endpoint
   * @request POST:/start-cpe-speedtest-cli
   * @secure
   */
  startCpeSpeedtestCliEndpointApiV1StartCpeSpeedtestCliPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Test Type */
      test_type: string;
      /**
       * Ookla Enable Shortest Distance
       * @default false
       */
      ookla_enable_shortest_distance?: boolean;
      /** Ookla Server Id */
      ookla_server_id?: string;
      /** Ookla Interface */
      ookla_interface?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<SpeedtestCliStartResponse, HTTPValidationError>({
      path: `/start-cpe-speedtest-cli`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get speedtest CLI results (ookla or fast.com) for a CPE and delete the file after retrieval
   *
   * @tags common, readonly, tool, sample, public
   * @name GetCpeSpeedtestCliTestResultApiV1GetCpeSpeedtestCliTestResultGet
   * @summary Get Cpe Speedtest Cli Test Result
   * @request GET:/get-cpe-speedtest-cli-test-result
   * @secure
   */
  getCpeSpeedtestCliTestResultApiV1GetCpeSpeedtestCliTestResultGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Test Type */
      test_type: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<SpeedtestCliTestResult, HTTPValidationError>({
      path: `/get-cpe-speedtest-cli-test-result`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name UpdateCpeShippingInfoApiV1UpdateCpeShippingInfoPost
   * @summary Update Cpe Shipping Info
   * @request POST:/update-cpe-shipping-info
   * @secure
   */
  updateCpeShippingInfoApiV1UpdateCpeShippingInfoPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Tracking Number */
      tracking_number: string;
      /** Imei */
      imei?: string;
      /** Iccid */
      iccid?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/update-cpe-shipping-info`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name CpeAddAnnouncementApiV1CpeAddAnnouncementPost
   * @summary Cpe Add Announcement
   * @request POST:/cpe-add-announcement
   * @secure
   */
  cpeAddAnnouncementApiV1CpeAddAnnouncementPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Start Time */
      start_time: string;
      /** Duration */
      duration: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/cpe-add-announcement`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Edit link relay setting for a CPE
   *
   * @tags common, admin, logging, public
   * @name EditLinkRelayApiV1EditLinkRelayPost
   * @summary Edit Link Relay
   * @request POST:/edit-link-relay
   * @secure
   */
  editLinkRelayApiV1EditLinkRelayPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/edit-link-relay`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get USB device information from a CPE node. Returns comprehensive USB topology information including: - Serial devices (ttyUSB) with full hardware details - USB hub port layout and connections Args: cpe_id: The CPE device ID ignore_errors: If True, returns empty result on error instead of raising HTTPException Returns: List of USB port entries, each containing: { "device_name": str,          # USB serial device name, empty if no device "hw_id_path": str,           # Hardware ID path "vendor_product_desc": str,  # Vendor/product description, empty if no device "layout": str                # Port layout description }
   *
   * @tags common, readonly, internal
   * @name GetCpeUsbDevicesApiV1GetCpeUsbDevicesGet
   * @summary Get Cpe Usb Devices
   * @request GET:/get-cpe-usb-devices
   * @secure
   */
  getCpeUsbDevicesApiV1GetCpeUsbDevicesGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /**
       * Ignore Errors
       * @default false
       */
      ignore_errors?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-cpe-usb-devices`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Save USB console settings for a CPE device. This endpoint allows configuring USB serial port settings for console access. It will update existing settings if they exist, or create new ones. Args: settings: USB console settings including: - cpe_id: CPE identifier - hw_id_path: Hardware ID path (e.g., "pci-0000:00:14.0-usb-0:2:1.0") - label: Optional label (default: "Change me") - description: Optional description - baud_rate: Serial port baud rate (default: 115200) - parity: Serial port parity - "none", "even", or "odd" (default: "none") - bits: Serial port data bits - 7 or 8 (default: 8) - stop_bits: Serial port stop bits - 1 or 2 (default: 1) Returns: dict: {"result": True} on success Raises: HTTPException: If CPE doesn't exist, user doesn't have access, or save fails
   *
   * @tags common, admin, logging, internal
   * @name SaveUsbConsoleSettingsEndpointApiV1SaveUsbConsoleSettingsPost
   * @summary Save Usb Console Settings Endpoint
   * @request POST:/save-usb-console-settings
   * @secure
   */
  saveUsbConsoleSettingsEndpointApiV1SaveUsbConsoleSettingsPost = (
    data: UsbConsoleSettings,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/save-usb-console-settings`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Get USB console settings for a specific hw_id_path on a CPE device. This endpoint retrieves saved USB serial port settings for console access. Master accounts can access settings for any CPE. Args: cpe_id: CPE identifier hw_id_path: Hardware ID path (e.g., "pci-0000:00:14.0-usb-0:2:1.0") Returns: UsbConsoleSettingsResponse: USB console settings including: - label: Label for the port (default: "Change me") - description: Description for the port - baud_rate: Serial port baud rate - parity: Serial port parity ("none", "even", or "odd") - bits: Serial port data bits (7 or 8) - stop_bits: Serial port stop bits (1 or 2) Raises: HTTPException: If CPE doesn't exist, user doesn't have access, or settings not found
   *
   * @tags common, readonly, internal
   * @name GetUsbConsoleSettingsEndpointApiV1GetUsbConsoleSettingsGet
   * @summary Get Usb Console Settings Endpoint
   * @request GET:/get-usb-console-settings
   * @secure
   */
  getUsbConsoleSettingsEndpointApiV1GetUsbConsoleSettingsGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Hw Id Path */
      hw_id_path: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<UsbConsoleSettingsResponse, HTTPValidationError>({
      path: `/get-usb-console-settings`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Return history for one USB port or Ethernet connection. USB requires hw_id_path. Ethernet requires target_ip, target_port, and protocol (ssh/http/https), and includes matching network web and raw SSH sessions.
   *
   * @tags common, readonly, internal
   * @name ViewConsoleAccessHistoryApiV1ViewConsoleAccessHistoryGet
   * @summary View Console Access History
   * @request GET:/view-console-access-history
   * @secure
   */
  viewConsoleAccessHistoryApiV1ViewConsoleAccessHistoryGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Access Type */
      access_type: 'usb' | 'eth';
      /** Hw Id Path */
      hw_id_path?: string;
      /** Target Ip */
      target_ip?: string;
      /** Target Port */
      target_port?: number;
      /** Protocol */
      protocol?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ConsoleAccessHistoryResponse, HTTPValidationError>({
      path: `/view-console-access-history`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Return the persisted active status for a USB or network console session.
   *
   * @tags common, readonly, internal
   * @name GetConsoleAccessStatusEndpointApiV1GetConsoleAccessStatusGet
   * @summary Get Console Access Status Endpoint
   * @request GET:/get-console-access-status
   * @secure
   */
  getConsoleAccessStatusEndpointApiV1GetConsoleAccessStatusGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Hw Id Path */
      hw_id_path: string;
      /** Console Mode */
      console_mode?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ConsoleAccessStatusResponse, HTTPValidationError>({
      path: `/get-console-access-status`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Connect to console access for a CPE device. This endpoint creates or updates a live console session for the specified CPE and USB port. Each hw_id_path can only have one active session at a time. If a session already exists, it will be updated with a new start timestamp. If not, a new session will be created using settings from the database. The function will automatically: - Create console access record if it doesn't exist - Launch EC2 jump box if needed (based on config) - Set up SSH reverse tunnel on the CPE - Store session information in the database Args: connect_params: Connection parameters including: - cpe_id: CPE identifier - hw_id_path: Hardware ID path (e.g., "pci-0000:00:14.0-usb-0:2:1.0") - console_mode: Console mode - "usb" - interface: Reverse tunnel uplink - "default", "wan0", "wan1", or "cellular" Returns: dict: {"result": True, "web_url": str} on success - result: True if connection was successful - web_url: Web console URL for the session (may be empty string) Raises: HTTPException: If CPE doesn't exist, user doesn't have access, or connection fails
   *
   * @tags common, admin, internal
   * @name ConnectConsoleAccessApiV1ConnectConsoleAccessPost
   * @summary Connect Console Access
   * @request POST:/connect-console-access
   * @secure
   */
  connectConsoleAccessApiV1ConnectConsoleAccessPost = (
    data: ConnectConsoleAccess,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/connect-console-access`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Disconnect console access for a CPE device. This endpoint removes an active console session for the specified CPE and USB port. It will: - Stop the SSH reverse tunnel on the CPE - Stop the USB console service on the CPE - Remove the session from the database - Terminate EC2 jump box if no more sessions remain Args: disconnect_params: Disconnection parameters including: - cpe_id: CPE identifier - hw_id_path: Hardware ID path (e.g., "pci-0000:00:14.0-usb-0:2:1.0") Returns: dict: {"result": True} on success Raises: HTTPException: If CPE doesn't exist, user doesn't have access, or disconnection fails
   *
   * @tags common, admin, internal
   * @name DisconnectConsoleAccessApiV1DisconnectConsoleAccessPost
   * @summary Disconnect Console Access
   * @request POST:/disconnect-console-access
   * @secure
   */
  disconnectConsoleAccessApiV1DisconnectConsoleAccessPost = (
    data: DisconnectConsoleAccess,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/disconnect-console-access`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Set up network remote access for a CPE device. Creates an SSH reverse tunnel from the CPE to a jump box, allowing web-based access to a target IP:port reachable from the CPE. Args: connect_params: Connection parameters including: - cpe_id: CPE identifier - target_ip: Target IP address reachable from the CPE - target_port: Target port (1-65535) - protocol: "ssh", "http", or "https" (default: "ssh") - ssh_username: SSH username (required when protocol="ssh") - interface: Reverse tunnel uplink - "default", "wan0", "wan1", or "cellular" Returns: dict: {"result": True, "web_url": str} on success
   *
   * @tags common, admin, internal
   * @name ConnectNetworkRemoteAccessApiV1ConnectNetworkRemoteAccessPost
   * @summary Connect Network Remote Access
   * @request POST:/connect-network-remote-access
   * @secure
   */
  connectNetworkRemoteAccessApiV1ConnectNetworkRemoteAccessPost = (
    data: ConnectNetworkRemoteAccess,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/connect-network-remote-access`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Disconnect network remote access for a CPE device. Tears down the SSH reverse tunnel, cleans up EC2 services, removes the session from the database, and terminates EC2 if no more sessions remain. Args: disconnect_params: Disconnection parameters including: - cpe_id: CPE identifier - target_ip: Target IP address - target_port: Target port - protocol: "ssh", "http", or "https" Returns: dict: {"result": True} on success
   *
   * @tags common, admin, internal
   * @name DisconnectNetworkRemoteAccessApiV1DisconnectNetworkRemoteAccessPost
   * @summary Disconnect Network Remote Access
   * @request POST:/disconnect-network-remote-access
   * @secure
   */
  disconnectNetworkRemoteAccessApiV1DisconnectNetworkRemoteAccessPost = (
    data: DisconnectNetworkRemoteAccess,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/disconnect-network-remote-access`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Configure or disable a secondary WAN (WAN1) interface on a CPE device. Set enabled=false to remove the secondary WAN configuration. Supports both DHCP and static IP configuration when enabling.
   *
   * @tags common, admin, logging, public
   * @name CpeConfigureSecondaryWanApiV1CpeConfigureSecondaryWanPost
   * @summary Cpe Configure Secondary Wan
   * @request POST:/cpe-configure-secondary-wan
   * @secure
   */
  cpeConfigureSecondaryWanApiV1CpeConfigureSecondaryWanPost = (
    data: CpeSecondaryWan,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/cpe-configure-secondary-wan`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Get the secondary WAN (WAN1) interface configuration for a CPE device.
   *
   * @tags common, readonly, public
   * @name GetSecondaryWanConfigApiV1CpeGetSecondaryWanConfigGet
   * @summary Get Secondary Wan Config
   * @request GET:/cpe-get-secondary-wan-config
   * @secure
   */
  getSecondaryWanConfigApiV1CpeGetSecondaryWanConfigGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/cpe-get-secondary-wan-config`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Called by the provisioning binary on CPE hardware. Authenticates via a per-CPE provisioning token, validates hardware, assigns OS interface names, and returns the full bootstrap payload.
   *
   * @tags common, internal
   * @name GetCpeDetailByTokenEndpointApiV1GetCpeDetailByTokenGet
   * @summary Get Cpe Detail By Token Endpoint
   * @request GET:/get-cpe-detail-by-token
   */
  getCpeDetailByTokenEndpointApiV1GetCpeDetailByTokenGet = (
    query: {
      /**
       * Provisioning Token
       * Provisioning token
       */
      provisioning_token: string;
      /**
       * Hardware Model
       * DMI product name of the hardware
       * @default ""
       */
      hardware_model?: string;
      /**
       * Interfaces
       * Comma-separated list of all network interfaces
       * @default ""
       */
      interfaces?: string;
      /**
       * Wan
       * Suggested RJ45 WAN interface (PCIe order [0])
       * @default ""
       */
      wan?: string;
      /**
       * Lan
       * Suggested RJ45 LAN interface (PCIe order [1])
       * @default ""
       */
      lan?: string;
      /**
       * Diag
       * Suggested RJ45 DIAG interface (PCIe order [3])
       * @default ""
       */
      diag?: string;
      /**
       * Sfp Wan
       * Suggested fiber WAN interface (PCIe order [0])
       * @default ""
       */
      sfp_wan?: string;
      /**
       * Sfp Lan
       * Suggested fiber LAN interface (PCIe order [1])
       * @default ""
       */
      sfp_lan?: string;
      /**
       * Wwan
       * Comma-separated WWAN/cellular interfaces (e.g. wwan0)
       * @default ""
       */
      wwan?: string;
      /**
       * Provisioning Version
       * Version string of the provisioning binary
       * @default ""
       */
      provisioning_version?: string;
      /**
       * Board Name
       * DMI board name of the hardware
       * @default ""
       */
      board_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/get-cpe-detail-by-token`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * @description Serve a software file to the provisioning binary. The ``provisioning_token`` must match the CPE's provisioning token. The ``filename`` must be a known SOFTWARE_KEY from ProvisioningConfig. The ``hardware_model`` and ``interfaces`` are validated to confirm the request comes from supported CPE hardware.
   *
   * @tags common, internal
   * @name GetProvisioningFileApiV1GetProvisioningFileGet
   * @summary Get Provisioning File
   * @request GET:/get-provisioning-file
   */
  getProvisioningFileApiV1GetProvisioningFileGet = (
    query: {
      /**
       * Provisioning Token
       * Provisioning token (authenticates the request)
       */
      provisioning_token: string;
      /**
       * Provisioning Version
       * Version string of the provisioning binary
       * @default ""
       */
      provisioning_version?: string;
      /**
       * Filename
       * Software key (e.g. setup.yml, nodeinit)
       */
      filename: string;
      /**
       * Hardware Model
       * DMI product name of the hardware
       */
      hardware_model: string;
      /**
       * Interfaces
       * Comma-separated list of all network interfaces
       */
      interfaces: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/get-provisioning-file`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * @description Serve the provisioning executable for self-upgrade. Requires a supported hardware model and more than 4 network interfaces. No authentication header — hardware validation IS the gate.
   *
   * @tags common, internal
   * @name UpgradeProvisioningExeApiV1UpgradeProvisioningExeGet
   * @summary Upgrade Provisioning Exe
   * @request GET:/upgrade-provisioning-exe
   */
  upgradeProvisioningExeApiV1UpgradeProvisioningExeGet = (
    query: {
      /**
       * Hardware Model
       * DMI product name of the hardware
       */
      hardware_model: string;
      /**
       * Interfaces
       * Comma-separated list of all network interfaces
       * @default ""
       */
      interfaces?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/upgrade-provisioning-exe`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * @description Return the MD5 checksum of the provisioning executable. Used by the binary to decide whether to download a new version.
   *
   * @tags common, internal
   * @name UpgradeProvisioningExeMd5ApiV1UpgradeProvisioningExeMd5Get
   * @summary Upgrade Provisioning Exe Md5
   * @request GET:/upgrade-provisioning-exe-md5
   */
  upgradeProvisioningExeMd5ApiV1UpgradeProvisioningExeMd5Get = (
    query: {
      /**
       * Hardware Model
       * DMI product name of the hardware
       */
      hardware_model: string;
      /**
       * Interfaces
       * Comma-separated list of all network interfaces
       * @default ""
       */
      interfaces?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/upgrade-provisioning-exe-md5`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * @description List every field that count-cpes and query-cpes can filter or group by, with each field's type, allowed operators, and (for enum fields) the exact set of valid values. `interface_fields` lists the fields usable in interface_filters (a CPE's per-port attributes, matched with an interface_match of any/all/none). Call this first when you are unsure which fields or values are available, so you can build a valid filter instead of guessing attribute names or enum spellings.
   *
   * @tags common, readonly, tool, public
   * @name DescribeCpeQueryFieldsApiV1DescribeCpeQueryFieldsGet
   * @summary Describe Cpe Query Fields
   * @request GET:/describe-cpe-query-fields
   * @secure
   */
  describeCpeQueryFieldsApiV1DescribeCpeQueryFieldsGet = (params: RequestParams = {}) =>
    this.request<CpeQueryFieldsResult, any>({
      path: `/describe-cpe-query-fields`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Count how many CPEs (visible to the caller) satisfy a set of conditions, evaluated server-side over the whole fleet in a single call. Use this for any "how many CPEs are/have <X>" question instead of listing every CPE and checking them one by one. `filters` is a list of `{field, op, value}` clauses combined with AND, e.g. to count registered cellular CPEs in California: {"filters": [ {"field": "admin_state", "op": "eq", "value": "registered"}, {"field": "has_cellular", "op": "eq", "value": true}, {"field": "state",        "op": "eq", "value": "California"} ]} An empty `filters` counts all visible CPEs. Optionally set `entity_name` to scope to one entity (and its children), and `group_by` to a field name to get a per-value breakdown (e.g. group_by "prod_code" for a count of each model). To match on interfaces (a CPE's ports), add `interface_filters` — clauses over interface fields — and `interface_match` ("any" (default), "all", or "none"). E.g. CPEs with at least one WAN interface that is operationally down: {"interface_filters": [ {"field": "role", "op": "contains", "value": "WAN"}, {"field": "operational_state", "op": "eq", "value": "DOWN"} ], "interface_match": "any"} Call describe-cpe-query-fields for the queryable fields (including interface fields), operators, and enum values. A malformed filter returns 400 with the reason.
   *
   * @tags common, readonly, tool, public
   * @name CountCpesApiV1CountCpesPost
   * @summary Count Cpes
   * @request POST:/count-cpes
   * @secure
   */
  countCpesApiV1CountCpesPost = (data: CpeCountRequest, params: RequestParams = {}) =>
    this.request<CpeCountResult, HTTPValidationError>({
      path: `/count-cpes`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Return the CPEs that satisfy a set of conditions (same `filters` format as count-cpes: `{field, op, value}` clauses combined with AND). Use this when you need the actual matching CPEs (names/ids) rather than only a count. Results are paged and capped at 200 per call (`limit`, default 50; `offset` to page). `matched` reports the full match count even when the page is smaller. If you only need the number, use count-cpes. Interface sub-queries (`interface_filters` + `interface_match`) work exactly as in count-cpes. Call describe-cpe-query-fields for the queryable fields and enum values.
   *
   * @tags common, readonly, tool, public
   * @name QueryCpesApiV1QueryCpesPost
   * @summary Query Cpes
   * @request POST:/query-cpes
   * @secure
   */
  queryCpesApiV1QueryCpesPost = (data: CpeQueryRequest, params: RequestParams = {}) =>
    this.request<CpeQueryResult, HTTPValidationError>({
      path: `/query-cpes`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description What the daily fleet-state mail would say right now. - `exposed`: cellular CPEs reporting no qmifix module loaded. An inbound datagram larger than the cellular bearer MTU can wedge their modem. - `not_on_pinned_build`: CPEs not running the build /upgrade-node pinned them to, right now - including upgrades still in flight, since this reports current state rather than what is worth emailing about. `pin` says what was asked for and when. - `qmifix_unreported`: cellular CPEs on software too old to report their qmifix state. - `builds`: the fleet by (release tag, commit), largest bucket first. A bucket holding more than half the fleet lists no CPEs - it is the build everything is on - and every other bucket names its members, which is what "who is behind" means in practice. Keyed on the commit as well as the tag because a build from a branch keeps the last release tag: after a commit-pinned upgrade the tag does not move and the commit does. Only CPEs that are registered and currently up are checked: a CPE that is down has its own alert, and its report is whatever it said before it left. `down` counts the registered CPEs left out for that reason. Master account only by tag, and scoped by account in the handler: the master account sees every CPE, any other caller sees only its own. Both, because ACCTMASTER binds account credentials but not IAM-user tokens.
   *
   * @tags internal, accountmaster
   * @name GetFleetStateApiV1GetFleetStateGet
   * @summary Get Fleet State
   * @request GET:/get-fleet-state
   * @secure
   */
  getFleetStateApiV1GetFleetStateGet = (params: RequestParams = {}) =>
    this.request<FleetStateResult, any>({
      path: `/get-fleet-state`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Pin the device's durable enrollment public key to its CPE (first-write-wins, §4). Authorized by the per-device provisioning_token. Idempotent for the same key; a different key against an already-pinned CPE is refused as an anomaly.
   *
   * @tags common, internal
   * @name EnrollRegisterPubkeyApiV1EnrollRegisterPubkeyPost
   * @summary Enroll Register Pubkey
   * @request POST:/enroll/register-pubkey
   */
  enrollRegisterPubkeyApiV1EnrollRegisterPubkeyPost = (
    data: EnrollRegisterRequest,
    params: RequestParams = {},
  ) =>
    this.request<EnrollRegisterResponse, HTTPValidationError>({
      path: `/enroll/register-pubkey`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Pin an installed box's existing enrollment key to the CPE whose node token it was given in the diag UI (#1516). Same pin and token checks as register-pubkey, so it only pins a CPE with no key yet; it skips the provisioning-version check, which only makes an old provisioning binary upgrade, because bootstrap is not that binary. The token's CPE must be the one the box enrolls as, so a mismatched token cannot pin the key elsewhere.
   *
   * @tags common, internal
   * @name EnrollAdoptApiV1EnrollAdoptPost
   * @summary Enroll Adopt
   * @request POST:/enroll/adopt
   */
  enrollAdoptApiV1EnrollAdoptPost = (data: EnrollAdoptRequest, params: RequestParams = {}) =>
    this.request<EnrollRegisterResponse, HTTPValidationError>({
      path: `/enroll/adopt`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Issue a single-use signing challenge (nonce) for an enrollable CPE.
   *
   * @tags common, internal
   * @name EnrollChallengeApiV1EnrollChallengePost
   * @summary Enroll Challenge
   * @request POST:/enroll/challenge
   */
  enrollChallengeApiV1EnrollChallengePost = (
    data: EnrollChallengeRequest,
    params: RequestParams = {},
  ) =>
    this.request<EnrollChallengeResponse, HTTPValidationError>({
      path: `/enroll/challenge`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Verify the device's signature over its challenge and have Vault sign the device's CSR. The device keeps its node-cert private key. The window advances to ISSUED; re-issue stays allowed until the device is confirmed on the control channel (ENROLLED, Phase 3).
   *
   * @tags common, internal
   * @name EnrollApiV1EnrollPost
   * @summary Enroll
   * @request POST:/enroll
   */
  enrollApiV1EnrollPost = (data: EnrollRequest, params: RequestParams = {}) =>
    this.request<EnrollResponse, HTTPValidationError>({
      path: `/enroll`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Admin recovery: clear a CPE's enrollment pin so a mis-pinned or stuck device can be re-provisioned or re-pinned — the supported alternative to manual DB surgery. The outstanding cert serial is recorded for future revocation. LIFECYCLE recovery only: until the connmgr revoked-serial deny-list is enforced, the outstanding cert stays valid until it expires, so this does NOT by itself evict a compromised device.
   *
   * @tags internal, accountmaster, logging
   * @name ClearEnrollPubkeyApiV1ClearEnrollPubkeyPost
   * @summary Clear Enroll Pubkey
   * @request POST:/clear-enroll-pubkey
   * @secure
   */
  clearEnrollPubkeyApiV1ClearEnrollPubkeyPost = (
    data: EnrollClearRequest,
    params: RequestParams = {},
  ) =>
    this.request<EnrollClearResponse, HTTPValidationError>({
      path: `/clear-enroll-pubkey`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Create a Entity with given parameters.
   *
   * @tags common, admin, logging, public
   * @name CreateEntityApiV1CreateEntityPost
   * @summary Create Entity
   * @request POST:/create-entity
   * @secure
   */
  createEntityApiV1CreateEntityPost = (data: EntityCreate, params: RequestParams = {}) =>
    this.request<Entity, HTTPValidationError>({
      path: `/create-entity`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description If logged in as account owner: - If entity_name is specified, we return the specific entity - If entity_name is None, we return all entities belong to this account If logged in as IAM user: - If IAM user does not belong to an entity, we treat it as account owner - If IAM user belong to an entity, - If entity_name is specified, - If this IAM user's entity has the same name as entity_name, we return entity, otherwise, we return empty list - If entity_name is not specified, we return this entity plus all its child entities
   *
   * @tags common, readonly, sample, public
   * @name GetEntityApiV1GetEntityGet
   * @summary Get Entity
   * @request GET:/get-entity
   * @secure
   */
  getEntityApiV1GetEntityGet = (
    query?: {
      /** Entity Name */
      entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Entity[], HTTPValidationError>({
      path: `/get-entity`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name GetEntityNamesApiV1GetEntityNamesGet
   * @summary Get Entity Names
   * @request GET:/get-entity-names
   * @secure
   */
  getEntityNamesApiV1GetEntityNamesGet = (
    query?: {
      /** Parent */
      parent?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<string[], HTTPValidationError>({
      path: `/get-entity-names`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name RemoveEntityApiV1RemoveEntityPost
   * @summary Remove Entity
   * @request POST:/remove-entity
   * @secure
   */
  removeEntityApiV1RemoveEntityPost = (
    query: {
      /** Entity Id */
      entity_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-entity`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name GetEntityIamUsersApiV1GetEntityIamUsersGet
   * @summary Get Entity Iam Users
   * @request GET:/get-entity-iam-users
   * @secure
   */
  getEntityIamUsersApiV1GetEntityIamUsersGet = (
    query: {
      /** Entity Id */
      entity_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<IamUser[], HTTPValidationError>({
      path: `/get-entity-iam-users`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name AssignEntityParentApiV1AssignEntityParentPost
   * @summary Assign Entity Parent
   * @request POST:/assign-entity-parent
   * @secure
   */
  assignEntityParentApiV1AssignEntityParentPost = (
    query: {
      /** Entity Id */
      entity_id: string;
      /** Parent Entity Name */
      parent_entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/assign-entity-parent`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name EditEntityDescriptionApiV1EditEntityDescriptionPost
   * @summary Edit Entity Description
   * @request POST:/edit-entity-description
   * @secure
   */
  editEntityDescriptionApiV1EditEntityDescriptionPost = (
    query: {
      /** Entity Id */
      entity_id: string;
      /** Description */
      description: string;
      /** Email */
      email?: string;
      /** Entity Name */
      entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/edit-entity-description`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name GetApiLogApiV1GetApiLogGet
   * @summary Get Api Log
   * @request GET:/get-api-log
   * @secure
   */
  getApiLogApiV1GetApiLogGet = (params: RequestParams = {}) =>
    this.request<ApiLog[], any>({
      path: `/get-api-log`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name MetroProductsApiV1MetroProductsGet
   * @summary Metro Products
   * @request GET:/metro-products
   */
  metroProductsApiV1MetroProductsGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/metro-products`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name MetroCcmIntervalApiV1MetroCcmIntervalGet
   * @summary Metro Ccm Interval
   * @request GET:/metro-ccm-interval
   */
  metroCcmIntervalApiV1MetroCcmIntervalGet = (params: RequestParams = {}) =>
    this.request<number[], any>({
      path: `/metro-ccm-interval`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * @description Create a Metro device with given parameters.
   *
   * @tags common, admin, logging, internal
   * @name CreateMetroApiV1CreateMetroPost
   * @summary Create Metro
   * @request POST:/create-metro
   * @secure
   */
  createMetroApiV1CreateMetroPost = (data: MetroCreate, params: RequestParams = {}) =>
    this.request<Metro, HTTPValidationError>({
      path: `/create-metro`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name GetMetroApiV1GetMetroGet
   * @summary Get Metro
   * @request GET:/get-metro
   * @secure
   */
  getMetroApiV1GetMetroGet = (
    query?: {
      /** Metro Name */
      metro_name?: string;
      /** Entity Name */
      entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro[], HTTPValidationError>({
      path: `/get-metro`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name GetMetroDetailApiV1GetMetroDetailGet
   * @summary Get Metro Detail
   * @request GET:/get-metro-detail
   * @secure
   */
  getMetroDetailApiV1GetMetroDetailGet = (
    query: {
      /** Metro Id */
      metro_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<MetroDetail, HTTPValidationError>({
      path: `/get-metro-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name RemoveMetroApiV1RemoveMetroPost
   * @summary Remove Metro
   * @request POST:/remove-metro
   * @secure
   */
  removeMetroApiV1RemoveMetroPost = (
    query: {
      /** Metro Id */
      metro_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-metro`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name UpdateMetroInfoApiV1UpdateMetroInfoPost
   * @summary Update Metro Info
   * @request POST:/update-metro-info
   * @secure
   */
  updateMetroInfoApiV1UpdateMetroInfoPost = (data: MetroInfoUpdate, params: RequestParams = {}) =>
    this.request<Metro, HTTPValidationError>({
      path: `/update-metro-info`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name ToggleMetroNetflowApiV1ToggleMetroNetflowPost
   * @summary Toggle Metro Netflow
   * @request POST:/toggle-metro-netflow
   * @secure
   */
  toggleMetroNetflowApiV1ToggleMetroNetflowPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-netflow`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name ToggleMetroMonitorInboundPubIpApiV1ToggleMetroMonitorInboundPubIpPost
   * @summary Toggle Metro Monitor Inbound Pub Ip
   * @request POST:/toggle-metro-monitor-inbound-pub-ip
   * @secure
   */
  toggleMetroMonitorInboundPubIpApiV1ToggleMetroMonitorInboundPubIpPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-monitor-inbound-pub-ip`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name ToggleMetroMonitorOutboundPubIpApiV1ToggleMetroMonitorOutboundPubIpPost
   * @summary Toggle Metro Monitor Outbound Pub Ip
   * @request POST:/toggle-metro-monitor-outbound-pub-ip
   * @secure
   */
  toggleMetroMonitorOutboundPubIpApiV1ToggleMetroMonitorOutboundPubIpPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-monitor-outbound-pub-ip`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name ToggleMetroGeoVisibilityApiV1ToggleMetroGeoVisibilityPost
   * @summary Toggle Metro Geo Visibility
   * @request POST:/toggle-metro-geo-visibility
   * @secure
   */
  toggleMetroGeoVisibilityApiV1ToggleMetroGeoVisibilityPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-geo-visibility`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name ToggleMetroDosApiV1ToggleMetroDenialOfServicePost
   * @summary Toggle Metro Dos
   * @request POST:/toggle-metro-denial-of-service
   * @secure
   */
  toggleMetroDosApiV1ToggleMetroDenialOfServicePost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-denial-of-service`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name ToggleMetroDosAlertApiV1ToggleMetroDenialOfServiceAlertPost
   * @summary Toggle Metro Dos Alert
   * @request POST:/toggle-metro-denial-of-service-alert
   * @secure
   */
  toggleMetroDosAlertApiV1ToggleMetroDenialOfServiceAlertPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-denial-of-service-alert`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name ToggleMetroMaliciousIpBlockApiV1ToggleMetroMaliciousIpBlockPost
   * @summary Toggle Metro Malicious Ip Block
   * @request POST:/toggle-metro-malicious-ip-block
   * @secure
   */
  toggleMetroMaliciousIpBlockApiV1ToggleMetroMaliciousIpBlockPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-malicious-ip-block`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name MetroAssignEntityApiV1MetroAssignEntityPost
   * @summary Metro Assign Entity
   * @request POST:/metro-assign-entity
   * @secure
   */
  metroAssignEntityApiV1MetroAssignEntityPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** New Entity Name */
      new_entity_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/metro-assign-entity`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name EditOamApiV1EditOamPost
   * @summary Edit Oam
   * @request POST:/edit-oam
   * @secure
   */
  editOamApiV1EditOamPost = (data: MetroOamEdit, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/edit-oam`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name LoopbackTestApiV1LoopbackTestPost
   * @summary Loopback Test
   * @request POST:/loopback-test
   * @secure
   */
  loopbackTestApiV1LoopbackTestPost = (data: MetroLoopbackTest, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/loopback-test`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name StartMetroTestApiV1StartMetroTestPost
   * @summary Start Metro Test
   * @request POST:/start-metro-test
   * @secure
   */
  startMetroTestApiV1StartMetroTestPost = (
    data: MetroPerformanceTest,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/start-metro-test`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name GetMetroTestReportApiV1GetMetroTestReportGet
   * @summary Get Metro Test Report
   * @request GET:/get-metro-test-report
   * @secure
   */
  getMetroTestReportApiV1GetMetroTestReportGet = (
    query: {
      /** Metro Id */
      metro_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/get-metro-test-report`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, internal
   * @name GetLanInterfacesApiV1GetMetroLanInterfacesGet
   * @summary Get Lan Interfaces
   * @request GET:/get-metro-lan-interfaces
   * @secure
   */
  getLanInterfacesApiV1GetMetroLanInterfacesGet = (
    query: {
      /** Metro Id */
      metro_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string[], HTTPValidationError>({
      path: `/get-metro-lan-interfaces`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name UpdateMetroShippingInfoApiV1UpdateMetroShippingInfoPost
   * @summary Update Metro Shipping Info
   * @request POST:/update-metro-shipping-info
   * @secure
   */
  updateMetroShippingInfoApiV1UpdateMetroShippingInfoPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Tracking Number */
      tracking_number: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/update-metro-shipping-info`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name MetroAddAnnouncementApiV1MetroAddAnnouncementPost
   * @summary Metro Add Announcement
   * @request POST:/metro-add-announcement
   * @secure
   */
  metroAddAnnouncementApiV1MetroAddAnnouncementPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Start Time */
      start_time: string;
      /** Duration */
      duration: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/metro-add-announcement`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Download a pcap file from the document store and run tshark to produce a structured summary: protocol hierarchy, top conversations, IP endpoints, expert anomalies, and DNS statistics. For IPsec/ESP-dominant captures the output switches automatically to IKE tunnel diagnostics. The pcap is cached locally so follow-up calls to /query-pcap are fast.
   *
   * @tags common, readonly, tool, public
   * @name AnalyzePcapApiV1AnalyzePcapGet
   * @summary Analyze Pcap
   * @request GET:/analyze-pcap
   * @secure
   */
  analyzePcapApiV1AnalyzePcapGet = (
    query: {
      /** Document Id */
      document_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AnalyzePcapResp, HTTPValidationError>({
      path: `/analyze-pcap`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, obsolete
   * @name AnalyzePcapApiV1AnalyzePcapPost
   * @summary Analyze Pcap
   * @request POST:/analyze-pcap
   * @secure
   */
  analyzePcapApiV1AnalyzePcapPost = (
    data: BodyAnalyzePcapApiV1AnalyzePcapPost,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/analyze-pcap`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    });

  /**
   * @description Decode a PCAP file stored in an S3 bucket on a PCAP worker instance. This endpoint is only accessible on instances with role="pcap-worker". :param pcap_file_key: Key of the PCAP file in S3. :param pcap_file_name: Name of the PCAP file being analyzed. :return: JSON response containing session analysis results. This function validates the role and file extension, then decodes the PCAP file on the worker and generates a report.
   *
   * @tags common, readonly, obsolete
   * @name DecodeS3PcapEndpointApiV1DecodeS3PcapGet
   * @summary Decode S3 Pcap Endpoint
   * @request GET:/decode-s3-pcap
   */
  decodeS3PcapEndpointApiV1DecodeS3PcapGet = (
    query: {
      /** Pcap File Key */
      pcap_file_key: string;
      /** Pcap File Name */
      pcap_file_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/decode-s3-pcap`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * @description Analyze a PCAP file stored in S3, using local processing or worker EC2 based on available memory. This endpoint intelligently decides whether to: 1. Process the PCAP file locally if sufficient memory is available 2. Launch a temporary worker EC2 instance if memory is insufficient Memory requirements: - < 5 MB: 100 MB + file size (≈150 MB total) - 5–10 MB: 150 MB + file size (≈200 MB total) - 10–500 MB: 700 MB total - 500 MB – 10 GB: 1 GB free RAM minimum - > 10 GB: 2 GB free RAM or use worker :param account_user: Authenticated user details (Account, IAM User). :param pcap_file_key: Key of the PCAP file in S3. :param pcap_file_name: Name of the PCAP file being analyzed. :return: JSON response containing session analysis results.
   *
   * @tags common, readonly, obsolete
   * @name AnalyzeS3PcapApiV1AnalyzeS3PcapGet
   * @summary Analyze S3 Pcap
   * @request GET:/analyze-s3-pcap
   * @secure
   */
  analyzeS3PcapApiV1AnalyzeS3PcapGet = (
    query: {
      /** Pcap File Key */
      pcap_file_key: string;
      /** Pcap File Name */
      pcap_file_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/analyze-s3-pcap`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Generate a pre-signed URL for uploading a PCAP file to S3. :param account_user: Authenticated user details (Account, IAM User). :param pcap_file_name: Name of the PCAP file to be uploaded. :return: JSON response containing the pre-signed upload URL and file key. This function first validates the user's access and file extension. If valid, it generates a pre-signed S3 upload URL and returns it to the client.
   *
   * @tags common, readonly, obsolete
   * @name GetS3UploadUrlApiV1GetS3UploadUrlGet
   * @summary Get S3 Upload Url
   * @request GET:/get-s3-upload-url
   * @secure
   */
  getS3UploadUrlApiV1GetS3UploadUrlGet = (
    query: {
      /** Pcap File Name */
      pcap_file_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<S3UploadUrl, HTTPValidationError>({
      path: `/get-s3-upload-url`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Health check endpoint for API readiness. Returns a simple status response to indicate the API is running.
   *
   * @tags common, readonly, obsolete
   * @name CheckHealthApiV1CheckHealthGet
   * @summary Check Health
   * @request GET:/check_health
   */
  checkHealthApiV1CheckHealthGet = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/check_health`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name CpeProductsApiV1DashboardGetAppTypesGet
   * @summary Cpe Products
   * @request GET:/dashboard-get-app-types
   */
  cpeProductsApiV1DashboardGetAppTypesGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/dashboard-get-app-types`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardGetSummaryApiV1DashboardGetSummaryGet
   * @summary Dashboard Get Summary
   * @request GET:/dashboard-get-summary
   * @secure
   */
  dashboardGetSummaryApiV1DashboardGetSummaryGet = (
    query?: {
      /** Entity Name */
      entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-summary`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardGetDeviceNamesApiV1DashboardGetDeviceNamesGet
   * @summary Dashboard Get Device Names
   * @request GET:/dashboard-get-device-names
   * @secure
   */
  dashboardGetDeviceNamesApiV1DashboardGetDeviceNamesGet = (
    query?: {
      /** Entity Name */
      entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-device-names`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description This API returns a series of samples of the WAN link utilization of a CPE within a time window. The maximum time window is 1 month, and the minimum time window is 1 hour
   *
   * @tags common, readonly, tool, sample, public
   * @name DashboardGetNodePeakAvgUtilIndividualApiV1DashboardGetNodePeakAvgUtilIndividualGet
   * @summary Dashboard Get Node Peak Avg Util Individual
   * @request GET:/dashboard-get-node-peak-avg-util-individual
   * @secure
   */
  dashboardGetNodePeakAvgUtilIndividualApiV1DashboardGetNodePeakAvgUtilIndividualGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/dashboard-get-node-peak-avg-util-individual`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description This API returns a series of samples of the WAN link health of a CPE within a time window. The maximum time window is 1 month, and the minimum time window is 1 hour Each sample contains rtt, jitter, packet loss, and a health score of the link.
   *
   * @tags common, readonly, tool, sample, public
   * @name DashboardGetNodeWanLinkHealthApiV1DashboardGetNodeWanLinkHealthGet
   * @summary Dashboard Get Node Wan Link Health
   * @request GET:/dashboard-get-node-wan-link-health
   * @secure
   */
  dashboardGetNodeWanLinkHealthApiV1DashboardGetNodeWanLinkHealthGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/dashboard-get-node-wan-link-health`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardGetNodeAppHighlightApiV1DashboardGetNodeAppHighlightGet
   * @summary Dashboard Get Node App Highlight
   * @request GET:/dashboard-get-node-app-highlight
   * @secure
   */
  dashboardGetNodeAppHighlightApiV1DashboardGetNodeAppHighlightGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-node-app-highlight`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardGetNodeWanUtilizationHistogramApiV1DashboardGetNodeWanUtilizationHistogramGet
   * @summary Dashboard Get Node Wan Utilization Histogram
   * @request GET:/dashboard-get-node-wan-utilization-histogram
   * @secure
   */
  dashboardGetNodeWanUtilizationHistogramApiV1DashboardGetNodeWanUtilizationHistogramGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-node-wan-utilization-histogram`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardGetNodeSessionsApiV1DashboardGetNodeSessionsGet
   * @summary Dashboard Get Node Sessions
   * @request GET:/dashboard-get-node-sessions
   * @secure
   */
  dashboardGetNodeSessionsApiV1DashboardGetNodeSessionsGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-node-sessions`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardAppVisibilityApiV1DashboardAppVisibilityGet
   * @summary Dashboard App Visibility
   * @request GET:/dashboard-app-visibility
   * @secure
   */
  dashboardAppVisibilityApiV1DashboardAppVisibilityGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-app-visibility`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardGetRouteApiV1DashboardGetRouteGet
   * @summary Dashboard Get Route
   * @request GET:/dashboard-get-route
   * @secure
   */
  dashboardGetRouteApiV1DashboardGetRouteGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time?: string;
      /** End Time */
      end_time?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-route`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardGetPeakHoursApiV1DashboardGetPeakHoursGet
   * @summary Dashboard Get Peak Hours
   * @request GET:/dashboard-get-peak-hours
   * @secure
   */
  dashboardGetPeakHoursApiV1DashboardGetPeakHoursGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-peak-hours`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardGetInboundSrcIpApiV1DashboardGetInboundSrcIpGet
   * @summary Dashboard Get Inbound Src Ip
   * @request GET:/dashboard-get-inbound-src-ip
   * @secure
   */
  dashboardGetInboundSrcIpApiV1DashboardGetInboundSrcIpGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time?: string;
      /** End Time */
      end_time?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-inbound-src-ip`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardGetOutboundDstIpApiV1DashboardGetOutboundDstIpGet
   * @summary Dashboard Get Outbound Dst Ip
   * @request GET:/dashboard-get-outbound-dst-ip
   * @secure
   */
  dashboardGetOutboundDstIpApiV1DashboardGetOutboundDstIpGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time?: string;
      /** End Time */
      end_time?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-outbound-dst-ip`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardGetLinkSpeedTestApiV1DashboardGetLinkSpeedTestGet
   * @summary Dashboard Get Link Speed Test
   * @request GET:/dashboard-get-link-speed-test
   * @secure
   */
  dashboardGetLinkSpeedTestApiV1DashboardGetLinkSpeedTestGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-link-speed-test`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardGetBlockedIpsApiV1DashboardGetBlockedIpsGet
   * @summary Dashboard Get Blocked Ips
   * @request GET:/dashboard-get-blocked-ips
   * @secure
   */
  dashboardGetBlockedIpsApiV1DashboardGetBlockedIpsGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time?: string;
      /** End Time */
      end_time?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-blocked-ips`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardGetBlockedIpsHistoryApiV1DashboardGetBlockedIpsHistoryGet
   * @summary Dashboard Get Blocked Ips History
   * @request GET:/dashboard-get-blocked-ips-history
   * @secure
   */
  dashboardGetBlockedIpsHistoryApiV1DashboardGetBlockedIpsHistoryGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time?: string;
      /** End Time */
      end_time?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-blocked-ips-history`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description The Web API to get the node connection up/down event post mortem analysis - node_id: cpe_id or metro_id - timestamp: The down event's detection time -- the `timestamp` field of the events.conn.status record, NOT its ingest `@timestamp`. The post-mortem lookup and down-event correlation both key on this value. - rec_type: "events.conn.status" - status: "down" or "up", usually "down" (deprecated) - gw_pingable: "Yes", "No", "NA"; "NA" means CPE has private IP (deprecated)
   *
   * @tags common, readonly, tool, public
   * @name GetNodeConnPostMortemApiV1GetNodeConnPostMortemGet
   * @summary Get Node Conn Post Mortem
   * @request GET:/get-node-conn-post-mortem
   * @secure
   */
  getNodeConnPostMortemApiV1GetNodeConnPostMortemGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Timestamp */
      timestamp: string;
      /** Rec Type */
      rec_type: string;
      /** Status */
      status: string;
      /** Gw Pingable */
      gw_pingable: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/get-node-conn-post-mortem`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DashboardAppAnalysisApiV1DashboardAppAnalysisGet
   * @summary Dashboard App Analysis
   * @request GET:/dashboard-app-analysis
   * @secure
   */
  dashboardAppAnalysisApiV1DashboardAppAnalysisGet = (
    query: {
      /** App Name */
      app_name: string;
      /** Protocol */
      protocol: string;
      /** Port */
      port: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/dashboard-app-analysis`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name SseApiV1SseGet
   * @summary Sse
   * @request GET:/sse
   */
  sseApiV1SseGet = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/sse`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name CheckCpeTestStatusApiV1CheckCpeTestStatusGet
   * @summary Check Cpe Test Status
   * @request GET:/check_cpe_test_status
   */
  checkCpeTestStatusApiV1CheckCpeTestStatusGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Sse Id */
      sse_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/check_cpe_test_status`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name CheckMetroTestStatusApiV1CheckMetroTestStatusGet
   * @summary Check Metro Test Status
   * @request GET:/check_metro_test_status
   */
  checkMetroTestStatusApiV1CheckMetroTestStatusGet = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Sse Id */
      sse_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/check_metro_test_status`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name GetTicketPriorityApiV1GetTicketPriorityGet
   * @summary Get Ticket Priority
   * @request GET:/get-ticket-priority
   */
  getTicketPriorityApiV1GetTicketPriorityGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/get-ticket-priority`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name GetTicketCategoryApiV1GetTicketCategoryGet
   * @summary Get Ticket Category
   * @request GET:/get-ticket-category
   */
  getTicketCategoryApiV1GetTicketCategoryGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/get-ticket-category`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * @description Generate a pre-signed S3 URL to upload an attachment for a new ticket or reply. Call this once per file before hitting create-ticket / add-correspondence.
   *
   * @tags common, admin, public
   * @name GetTicketUploadUrlApiV1GetTicketUploadUrlGet
   * @summary Get Ticket Upload Url
   * @request GET:/get-ticket-upload-url
   * @secure
   */
  getTicketUploadUrlApiV1GetTicketUploadUrlGet = (
    query: {
      /** Filename */
      filename: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<TicketUploadUrl, HTTPValidationError>({
      path: `/get-ticket-upload-url`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Delete an uploaded attachment before it has been submitted with a ticket or reply. Once a ticket/reply has been created with this attachment, deletion is no longer allowed.
   *
   * @tags common, admin, public
   * @name DeleteTicketUploadApiV1DeleteTicketUploadPost
   * @summary Delete Ticket Upload
   * @request POST:/delete-ticket-upload
   * @secure
   */
  deleteTicketUploadApiV1DeleteTicketUploadPost = (
    data: TicketDeleteUpload,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/delete-ticket-upload`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Create a Ticket with given parameters.
   *
   * @tags common, admin, logging, public
   * @name CreateTicketApiV1CreateTicketPost
   * @summary Create Ticket
   * @request POST:/create-ticket
   * @secure
   */
  createTicketApiV1CreateTicketPost = (data: TicketCreate, params: RequestParams = {}) =>
    this.request<Ticket, HTTPValidationError>({
      path: `/create-ticket`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name GetTicketApiV1GetTicketGet
   * @summary Get Ticket
   * @request GET:/get-ticket
   * @secure
   */
  getTicketApiV1GetTicketGet = (
    query?: {
      /** Ticket Id */
      ticket_id?: string;
      /** Device Id */
      device_id?: string;
      /** Entity Id */
      entity_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Ticket[], HTTPValidationError>({
      path: `/get-ticket`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name GetTicketDetailApiV1GetTicketDetailGet
   * @summary Get Ticket Detail
   * @request GET:/get-ticket-detail
   * @secure
   */
  getTicketDetailApiV1GetTicketDetailGet = (
    query?: {
      /** Ticket Id */
      ticket_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<TicketDetail, HTTPValidationError>({
      path: `/get-ticket-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, logging, public
   * @name CloseTicketApiV1CloseTicketPost
   * @summary Close Ticket
   * @request POST:/close-ticket
   * @secure
   */
  closeTicketApiV1CloseTicketPost = (
    query: {
      /** Ticket Id */
      ticket_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Ticket, HTTPValidationError>({
      path: `/close-ticket`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name AddCorrespondenceApiV1AddCorrespondencePost
   * @summary Add Correspondence
   * @request POST:/add-correspondence
   * @secure
   */
  addCorrespondenceApiV1AddCorrespondencePost = (
    data: CorrespondenceCreate,
    params: RequestParams = {},
  ) =>
    this.request<TicketDetail, HTTPValidationError>({
      path: `/add-correspondence`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name GetCorrespondenceApiV1GetCorrespondenceGet
   * @summary Get Correspondence
   * @request GET:/get-correspondence
   * @secure
   */
  getCorrespondenceApiV1GetCorrespondenceGet = (
    query: {
      /** Ticket Id */
      ticket_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Correspondence[], HTTPValidationError>({
      path: `/get-correspondence`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Return all network devices discovered on a specific node's diag-port LAN, with their active sessions.
   *
   * @tags common, readonly, public
   * @name GetAllNetworkDevicesApiV1GetAllNetworkDevicesGet
   * @summary Get All Network Devices
   * @request GET:/get-all-network-devices
   * @secure
   */
  getAllNetworkDevicesApiV1GetAllNetworkDevicesGet = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<NetworkDeviceOnDiagPortWithSessions[], HTTPValidationError>({
      path: `/get-all-network-devices`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Return all network devices discovered on a node's diag-port LAN, with their active sessions. Optionally filter by mac_addr.
   *
   * @tags common, readonly, public
   * @name GetNetworkDeviceApiV1GetNetworkDeviceGet
   * @summary Get Network Device
   * @request GET:/get-network-device
   * @secure
   */
  getNetworkDeviceApiV1GetNetworkDeviceGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Mac Addr */
      mac_addr?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<NetworkDeviceOnDiagPortWithSessions[], HTTPValidationError>({
      path: `/get-network-device`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Set up direct SSH access to a target reachable from the CPE. Unlike `/connect-network-remote-access`, this returns jump-box SSH details for native SSH/SCP usage instead of a browser URL. The optional interface selects the CPE uplink used by the reverse tunnel: "default", "wan0", "wan1", or "cellular".
   *
   * @tags common, admin, logging, public
   * @name ConnectRawSshAccessApiV1ConnectRawSshAccessPost
   * @summary Connect Raw Ssh Access
   * @request POST:/connect-raw-ssh-access
   * @secure
   */
  connectRawSshAccessApiV1ConnectRawSshAccessPost = (
    data: ConnectRawSshAccess,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/connect-raw-ssh-access`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Download a temporary jumpbox private key PEM for raw SSH access.
   *
   * @tags common, admin, logging, public
   * @name DownloadRawSshPrivateKeyApiV1DownloadRawSshPrivateKeyFileNameGet
   * @summary Download Raw Ssh Private Key
   * @request GET:/download-raw-ssh-private-key/{file_name}
   * @secure
   */
  downloadRawSshPrivateKeyApiV1DownloadRawSshPrivateKeyFileNameGet = (
    fileName: string,
    params: RequestParams = {},
  ) =>
    this.request<void, HTTPValidationError>({
      path: `/download-raw-ssh-private-key/${fileName}`,
      method: 'GET',
      secure: true,
      ...params,
    });

  /**
   * @description Tear down direct SSH access to a target reachable from the CPE.
   *
   * @tags common, admin, logging, public
   * @name DisconnectRawSshAccessApiV1DisconnectRawSshAccessPost
   * @summary Disconnect Raw Ssh Access
   * @request POST:/disconnect-raw-ssh-access
   * @secure
   */
  disconnectRawSshAccessApiV1DisconnectRawSshAccessPost = (
    data: DisconnectRawSshAccess,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/disconnect-raw-ssh-access`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Scan the node's dnsmasq lease table, resolve vendor names, ping each device, and persist new entries. Returns the updated list of known devices.
   *
   * @tags common, admin, public
   * @name DiscoverNetworkDeviceApiV1DiscoverNetworkDevicePost
   * @summary Discover Network Device
   * @request POST:/discover-network-device
   * @secure
   */
  discoverNetworkDeviceApiV1DiscoverNetworkDevicePost = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<NetworkDeviceOnDiagPort[], HTTPValidationError>({
      path: `/discover-network-device`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Set the human-readable device_name for a network device identified by (node_id, mac_addr).
   *
   * @tags common, admin, logging, public
   * @name EditNetworkDeviceNameApiV1EditNetworkDeviceNamePost
   * @summary Edit Network Device Name
   * @request POST:/edit-network-device-name
   * @secure
   */
  editNetworkDeviceNameApiV1EditNetworkDeviceNamePost = (
    data: NetworkDeviceOnDiagPortEditName,
    params: RequestParams = {},
  ) =>
    this.request<NetworkDeviceOnDiagPort, HTTPValidationError>({
      path: `/edit-network-device-name`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Remove a network device record identified by (node_id, mac_addr).
   *
   * @tags common, admin, logging, public
   * @name RemoveNetworkDeviceApiV1RemoveNetworkDevicePost
   * @summary Remove Network Device
   * @request POST:/remove-network-device
   * @secure
   */
  removeNetworkDeviceApiV1RemoveNetworkDevicePost = (
    query: {
      /** Node Id */
      node_id: string;
      /** Mac Addr */
      mac_addr: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-network-device`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Manually add a network device to a node's diag-port LAN. If mac_addr is not provided, a synthetic unique ID (e.g. mac-a1b2-c3d4-e5f6) is generated in its place. Synthetic MACs are skipped during OUI vendor lookup.
   *
   * @tags common, admin, logging, public
   * @name AddNetworkDeviceApiV1AddNetworkDevicePost
   * @summary Add Network Device
   * @request POST:/add-network-device
   * @secure
   */
  addNetworkDeviceApiV1AddNetworkDevicePost = (
    data: NetworkDeviceOnDiagPortAdd,
    params: RequestParams = {},
  ) =>
    this.request<NetworkDeviceOnDiagPort, HTTPValidationError>({
      path: `/add-network-device`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name GetPduVendorNamesApiV1GetPduVendorNamesGet
   * @summary Get Pdu Vendor Names
   * @request GET:/get-pdu-vendor-names
   */
  getPduVendorNamesApiV1GetPduVendorNamesGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/get-pdu-vendor-names`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * @description Create a PDU with given parameters.
   *
   * @tags common, admin, logging, public
   * @name CreatePduApiV1CreatePduPost
   * @summary Create Pdu
   * @request POST:/create-pdu
   * @secure
   */
  createPduApiV1CreatePduPost = (data: PduCreate, params: RequestParams = {}) =>
    this.request<Pdu, HTTPValidationError>({
      path: `/create-pdu`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description This API returns PDUs connected to the CPE. If PDU name is provided, a specific PDU will be returned
   *
   * @tags common, readonly, tool, public
   * @name GetPduApiV1GetPduGet
   * @summary Get Pdu
   * @request GET:/get-pdu
   * @secure
   */
  getPduApiV1GetPduGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Pdu Name */
      pdu_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Pdu[], HTTPValidationError>({
      path: `/get-pdu`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description This API returns the detailed information of a CPU such as each outlet's on/off status
   *
   * @tags common, readonly, public
   * @name GetPduDetailApiV1GetPduDetailGet
   * @summary Get Pdu Detail
   * @request GET:/get-pdu-detail
   * @secure
   */
  getPduDetailApiV1GetPduDetailGet = (
    query: {
      /** Pdu Id */
      pdu_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Pdu, HTTPValidationError>({
      path: `/get-pdu-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name RemovePduApiV1RemovePduPost
   * @summary Remove Pdu
   * @request POST:/remove-pdu
   * @secure
   */
  removePduApiV1RemovePduPost = (
    query: {
      /** Pdu Id */
      pdu_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-pdu`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name TogglePduOutletStateApiV1TogglePduOutletStatePost
   * @summary Toggle Pdu Outlet State
   * @request POST:/toggle-pdu-outlet-state
   * @secure
   */
  togglePduOutletStateApiV1TogglePduOutletStatePost = (
    query: {
      /** Pdu Id */
      pdu_id: string;
      /** Outlet Id */
      outlet_id: number;
      /** An enumeration. */
      new_state: PduOutletState;
    },
    params: RequestParams = {},
  ) =>
    this.request<Pdu, HTTPValidationError>({
      path: `/toggle-pdu-outlet-state`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name EditPduOutletDeviceNameApiV1EditPduOutletDeviceNamePost
   * @summary Edit Pdu Outlet Device Name
   * @request POST:/edit-pdu-outlet-device-name
   * @secure
   */
  editPduOutletDeviceNameApiV1EditPduOutletDeviceNamePost = (
    query: {
      /** Pdu Id */
      pdu_id: string;
      /** Outlet Id */
      outlet_id: number;
      /** Device Name */
      device_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Pdu, HTTPValidationError>({
      path: `/edit-pdu-outlet-device-name`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Update CPE Mode.
   *
   * @tags common, admin, logging, public
   * @name EditPduInfoApiV1EditPduInfoPost
   * @summary Edit Pdu Info
   * @request POST:/edit-pdu-info
   * @secure
   */
  editPduInfoApiV1EditPduInfoPost = (data: PduEditInfo, params: RequestParams = {}) =>
    this.request<Pdu, HTTPValidationError>({
      path: `/edit-pdu-info`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, public
   * @name RecoverPduIpApiV1RecoverPduIpPost
   * @summary Recover Pdu Ip
   * @request POST:/recover-pdu-ip
   * @secure
   */
  recoverPduIpApiV1RecoverPduIpPost = (
    query: {
      /** Pdu Id */
      pdu_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/recover-pdu-ip`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name DiscoverPduApiV1DiscoverPduPost
   * @summary Discover Pdu
   * @request POST:/discover-pdu
   * @secure
   */
  discoverPduApiV1DiscoverPduPost = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Pdu[], HTTPValidationError>({
      path: `/discover-pdu`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get cellular status information for a CPE (operator, signal, IMEI, ICCID, modem, RAT, roaming).
   *
   * @tags common, readonly, tool, public
   * @name GetCellularStatusApiV1GetCellularStatusGet
   * @summary Get Cellular Status
   * @request GET:/get-cellular-status
   * @secure
   */
  getCellularStatusApiV1GetCellularStatusGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CellularStatusResponse, HTTPValidationError>({
      path: `/get-cellular-status`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get current cellular configuration (failover, apn, static_ip) for a CPE.
   *
   * @tags common, readonly, public
   * @name GetCellularConfigApiV1GetCellularConfigGet
   * @summary Get Cellular Config
   * @request GET:/get-cellular-config
   * @secure
   */
  getCellularConfigApiV1GetCellularConfigGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CellularConfigResponse, HTTPValidationError>({
      path: `/get-cellular-config`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Configure cellular settings (allow_data_failover, apn, static_ip) on a CPE.
   *
   * @tags common, logging, public
   * @name ConfigureCellularEndpointApiV1ConfigureCellularPost
   * @summary Configure Cellular Endpoint
   * @request POST:/configure-cellular
   * @secure
   */
  configureCellularEndpointApiV1ConfigureCellularPost = (
    data: CellularConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-cellular`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Get current cellular stats for a CPE.
   *
   * @tags common, readonly, public
   * @name GetCellularStatsApiV1GetCellularStatsGet
   * @summary Get Cellular Stats
   * @request GET:/get-cellular-stats
   * @secure
   */
  getCellularStatsApiV1GetCellularStatsGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-cellular-stats`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get number of cellular failover count for a CPE within a time window.
   *
   * @tags common, readonly, tool, public
   * @name GetCellularFailoverCountApiV1GetCellularFailoverCountGet
   * @summary Get Cellular Failover Count
   * @request GET:/get-cellular-failover-count
   * @secure
   */
  getCellularFailoverCountApiV1GetCellularFailoverCountGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/get-cellular-failover-count`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get raw mmcli diagnostics (modem, each SIM, each bearer, and signal metrics) from a CPE's cellular modem, plus qmicli NAS queries (active band, serving and neighbour cells, signal) for QMI modems. The response mirrors what running those commands on the device would print.
   *
   * @tags common, readonly, tool, public
   * @name GetCellularDiagApiV1GetCellularDiagGet
   * @summary Get Cellular Diag
   * @request GET:/get-cellular-diag
   * @secure
   */
  getCellularDiagApiV1GetCellularDiagGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/get-cellular-diag`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Add a regional WireGuard concentrator to the directory. The EC2 instance is launched separately (launch-concentrator); on boot it self-registers its endpoint/public key/egress IP. The one-time register_token is not returned (it is seeded into the instance's user-data by the launcher).
   *
   * @tags internal, accountmaster, logging
   * @name AddConcentratorApiV1AddConcentratorPost
   * @summary Add Concentrator
   * @request POST:/add-concentrator
   * @secure
   */
  addConcentratorApiV1AddConcentratorPost = (
    data: ConcentratorCreate,
    params: RequestParams = {},
  ) =>
    this.request<ConcentratorResponse, HTTPValidationError>({
      path: `/add-concentrator`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Launch a concentrator EC2 instance in the given region: creates the directory entry, launches a stock instance with a user-data bootstrap, gives it the shared egress (Elastic) IP, and disables the ENI src/dest check. The instance self-registers its public key on boot. ami_id overrides the region config's AMI; key_name attaches an SSH key pair (opening tcp/22).
   *
   * @tags internal, accountmaster, logging
   * @name LaunchConcentratorApiV1LaunchConcentratorPost
   * @summary Launch Concentrator
   * @request POST:/launch-concentrator
   * @secure
   */
  launchConcentratorApiV1LaunchConcentratorPost = (
    data: ConcentratorLaunch,
    params: RequestParams = {},
  ) =>
    this.request<ConcentratorResponse, HTTPValidationError>({
      path: `/launch-concentrator`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description List concentrators, optionally filtered by region and/or enabled status. With include_peers=true each entry also carries the per-CPE tunnel status the concentrator last reported (the server-side silent-tunnel view), so `list` surfaces which CPE tunnels are dark. Off by default so a plain listing stays a single query.
   *
   * @tags internal, accountmaster
   * @name GetConcentratorsApiV1GetConcentratorsGet
   * @summary Get Concentrators
   * @request GET:/get-concentrators
   * @secure
   */
  getConcentratorsApiV1GetConcentratorsGet = (
    query?: {
      /** Region */
      region?: string;
      /**
       * Enabled Only
       * @default false
       */
      enabled_only?: boolean;
      /**
       * Include Peers
       * @default false
       */
      include_peers?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<ConcentratorResponse[], HTTPValidationError>({
      path: `/get-concentrators`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Enable or disable a concentrator. Only enabled concentrators are selectable for CPEs.
   *
   * @tags internal, accountmaster, logging
   * @name SetConcentratorEnabledApiV1SetConcentratorEnabledPost
   * @summary Set Concentrator Enabled
   * @request POST:/set-concentrator-enabled
   * @secure
   */
  setConcentratorEnabledApiV1SetConcentratorEnabledPost = (
    data: ConcentratorSetEnabled,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-concentrator-enabled`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Decommission a concentrator: mark it for teardown (op_state 'decommissioning', token cleared so a surviving instance can't re-register). The reconciler then terminates the EC2 instance and soft-deletes the directory row on its next pass. The region's Elastic IP + DNS record are NOT released — they stay reserved (see ConcentratorRegionEip) so the region's egress IP is preserved for a future concentrator.
   *
   * @tags internal, accountmaster, logging
   * @name RemoveConcentratorApiV1RemoveConcentratorDelete
   * @summary Remove Concentrator
   * @request DELETE:/remove-concentrator
   * @secure
   */
  removeConcentratorApiV1RemoveConcentratorDelete = (
    query: {
      /** Concentrator Id */
      concentrator_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-concentrator`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Force-replace a concentrator MAKE-BEFORE-BREAK, REUSING its Elastic IP so the egress IP (and the DNS name CPEs dial) stays stable across the swap. Stages a fresh (dark) instance alongside the still-serving incumbent; once it registers, the reconciler moves the reserved EIP onto it and retires the incumbent, so downtime is just the EIP move + WireGuard re-handshake, not a full boot (CPEs re-register on the new key automatically). Runs regardless of the concentrator's health — use it to roll a new AMI or recover a wedged box. Returns the staging concentrator entry (the cutover completes asynchronously on the next reconcile sweeps).
   *
   * @tags internal, accountmaster, logging
   * @name ReplaceConcentratorApiV1ReplaceConcentratorPost
   * @summary Replace Concentrator
   * @request POST:/replace-concentrator
   * @secure
   */
  replaceConcentratorApiV1ReplaceConcentratorPost = (
    data: ConcentratorReplace,
    params: RequestParams = {},
  ) =>
    this.request<ConcentratorResponse, HTTPValidationError>({
      path: `/replace-concentrator`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Idempotent check-in called by a concentrator instance on boot and then periodically (heartbeat). The instance authenticates with the durable register_token seeded into its user-data (X-Register-Token header) and reports its WireGuard public key. The first call registers; later calls keep last_seen fresh and flip the row back to RUNNING after a transient down. endpoint/egress_ip/ec2_instance_id in the body are ignored (the Elastic IP and instance id recorded at launch are authoritative). Returns the tunnel config the instance needs.
   *
   * @tags common, public
   * @name RegisterConcentratorApiV1RegisterConcentratorPost
   * @summary Register Concentrator
   * @request POST:/register-concentrator
   */
  registerConcentratorApiV1RegisterConcentratorPost = (
    data: ConcentratorSelfRegister,
    params: RequestParams = {},
  ) =>
    this.request<ConcentratorSelfRegisterResponse, HTTPValidationError>({
      path: `/register-concentrator`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly
   * @name DocumentGetOwnerTypeApiV1DocumentGetOwnerTypeGet
   * @summary Document Get Owner Type
   * @request GET:/document-get-owner-type
   */
  documentGetOwnerTypeApiV1DocumentGetOwnerTypeGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/document-get-owner-type`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, public
   * @name GetDocumentS3UploadUrlApiV1GetDocumentS3UploadUrlGet
   * @summary Get Document S3 Upload Url
   * @request GET:/get-document-s3-upload-url
   * @secure
   */
  getDocumentS3UploadUrlApiV1GetDocumentS3UploadUrlGet = (
    query: {
      /** Filename */
      filename: string;
      /** Node Id */
      node_id?: string;
      /** Entity Id */
      entity_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<DocumentUploadUrl, HTTPValidationError>({
      path: `/get-document-s3-upload-url`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get pre-signed S3 upload URLs for several files in one call, so the UI can attach multiple documents without a round trip per file. The owner (node/entity) is resolved once and applies to every file in the batch. Returns one entry per requested file, in the order they were supplied.
   *
   * @tags common, admin, public
   * @name GetDocumentS3UploadUrlsApiV1GetDocumentS3UploadUrlsPost
   * @summary Get Document S3 Upload Urls
   * @request POST:/get-document-s3-upload-urls
   * @secure
   */
  getDocumentS3UploadUrlsApiV1GetDocumentS3UploadUrlsPost = (
    data: DocumentUploadUrlsRequest,
    params: RequestParams = {},
  ) =>
    this.request<DocumentUploadUrlItem[], HTTPValidationError>({
      path: `/get-document-s3-upload-urls`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, public
   * @name DocumentUploadedApiV1DocumentUploadedPost
   * @summary Document Uploaded
   * @request POST:/document-uploaded
   * @secure
   */
  documentUploadedApiV1DocumentUploadedPost = (
    query: {
      /** Document Id */
      document_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/document-uploaded`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Report several documents as uploaded in one call, the companion to get-document-s3-upload-urls. Every document is checked against the logged-in user, so an unknown or unauthorized id fails the whole request rather than being silently skipped.
   *
   * @tags common, admin, public
   * @name DocumentsUploadedApiV1DocumentsUploadedPost
   * @summary Documents Uploaded
   * @request POST:/documents-uploaded
   * @secure
   */
  documentsUploadedApiV1DocumentsUploadedPost = (
    data: DocumentsUploadedRequest,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/documents-uploaded`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, tool, public
   * @name GetDocumentsApiV1GetDocumentsGet
   * @summary Get Documents
   * @request GET:/get-documents
   * @secure
   */
  getDocumentsApiV1GetDocumentsGet = (
    query?: {
      /** Entity Id */
      entity_id?: string;
      /** Node Id */
      node_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Document[], HTTPValidationError>({
      path: `/get-documents`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, public
   * @name RemoveDocumentApiV1RemoveDocumentPost
   * @summary Remove Document
   * @request POST:/remove-document
   * @secure
   */
  removeDocumentApiV1RemoveDocumentPost = (
    query: {
      /** Document Id */
      document_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-document`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, public
   * @name UpdateDocumentApiV1UpdateDocumentPost
   * @summary Update Document
   * @request POST:/update-document
   * @secure
   */
  updateDocumentApiV1UpdateDocumentPost = (data: DocumentUpdate, params: RequestParams = {}) =>
    this.request<Document, HTTPValidationError>({
      path: `/update-document`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly
   * @name DocumentGetEntityNameIdPairApiV1DocumentGetEntityNameIdPairGet
   * @summary Document Get Entity Name Id Pair
   * @request GET:/document-get-entity-name-id-pair
   * @secure
   */
  documentGetEntityNameIdPairApiV1DocumentGetEntityNameIdPairGet = (params: RequestParams = {}) =>
    this.request<object[], any>({
      path: `/document-get-entity-name-id-pair`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly
   * @name DocumentGetDeviceNameIdPairApiV1DocumentGetDeviceNameIdPairGet
   * @summary Document Get Device Name Id Pair
   * @request GET:/document-get-device-name-id-pair
   * @secure
   */
  documentGetDeviceNameIdPairApiV1DocumentGetDeviceNameIdPairGet = (params: RequestParams = {}) =>
    this.request<object[], any>({
      path: `/document-get-device-name-id-pair`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name CellularCarrierApiV1CellularCarrierGet
   * @summary Cellular Carrier
   * @request GET:/cellular-carrier
   */
  cellularCarrierApiV1CellularCarrierGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/cellular-carrier`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  /**
   * @description Create a new data pool.
   *
   * @tags common, admin, logging, public
   * @name CreateDataPoolApiV1CreateDataPoolPost
   * @summary Create Data Pool
   * @request POST:/create-data-pool
   * @secure
   */
  createDataPoolApiV1CreateDataPoolPost = (data: DataPoolCreate, params: RequestParams = {}) =>
    this.request<DataPool, HTTPValidationError>({
      path: `/create-data-pool`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Get data pools scoped to the logged-in user. entity_id provided: - Master user: return pools for that entity. - Account owner / IAM user without entity: entity must belong to the account. - IAM user with entity: entity must be the user's own entity or a direct child of it. - Otherwise: 400 error. entity_id not provided: - Master user: return all data pools. - Account owner / IAM user without entity: return pools for all account entities. - IAM user with entity: return pools for their entity and its children.
   *
   * @tags common, readonly, public
   * @name GetDataPoolApiV1GetDataPoolGet
   * @summary Get Data Pool
   * @request GET:/get-data-pool
   * @secure
   */
  getDataPoolApiV1GetDataPoolGet = (
    query?: {
      /** Entity Id */
      entity_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<DataPool[], HTTPValidationError>({
      path: `/get-data-pool`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Get the member CPEs assigned to a data pool. The caller must be able to access the data pool (master accounts are unrestricted). Returns the CPEs currently assigned to the pool.
   *
   * @tags common, readonly, public
   * @name GetDataPoolCpesApiV1GetDataPoolCpesGet
   * @summary Get Data Pool Cpes
   * @request GET:/get-data-pool-cpes
   * @secure
   */
  getDataPoolCpesApiV1GetDataPoolCpesGet = (
    query: {
      /** Data Pool Id */
      data_pool_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe[], HTTPValidationError>({
      path: `/get-data-pool-cpes`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Remove a data pool. Fails if any CPEs are still assigned to it.
   *
   * @tags common, admin, logging, public
   * @name RemoveDataPoolApiV1RemoveDataPoolPost
   * @summary Remove Data Pool
   * @request POST:/remove-data-pool
   * @secure
   */
  removeDataPoolApiV1RemoveDataPoolPost = (
    query: {
      /** Data Pool Id */
      data_pool_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-data-pool`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Edit data pool name, description, carrier, data allowance, alert, and throttle settings.
   *
   * @tags common, admin, logging, public
   * @name EditDataPoolInfoApiV1EditDataPoolInfoPost
   * @summary Edit Data Pool Info
   * @request POST:/edit-data-pool-info
   * @secure
   */
  editDataPoolInfoApiV1EditDataPoolInfoPost = (data: DataPoolEdit, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/edit-data-pool-info`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Assign a CPE to a data pool.
   *
   * @tags common, admin, logging, public
   * @name AddCpeToDataPoolApiV1AddCpeToDataPoolPost
   * @summary Add Cpe To Data Pool
   * @request POST:/add-cpe-to-data-pool
   * @secure
   */
  addCpeToDataPoolApiV1AddCpeToDataPoolPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Data Pool Id */
      data_pool_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/add-cpe-to-data-pool`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Remove a CPE from its data pool.
   *
   * @tags common, admin, logging, public
   * @name RemoveCpeFromDataPoolApiV1RemoveCpeFromDataPoolPost
   * @summary Remove Cpe From Data Pool
   * @request POST:/remove-cpe-from-data-pool
   * @secure
   */
  removeCpeFromDataPoolApiV1RemoveCpeFromDataPoolPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-cpe-from-data-pool`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Set the day of the month on which a cellular CPE's data usage resets while it is not in a data pool (metered individually). reset_day uses the same convention as a data pool's: positive N = Nth day of the month, negative N = Nth day from the end, non-zero and within [-28, 28]. While the CPE is in a pool the pool's reset_day governs; this value takes effect once it has none.
   *
   * @tags common, admin, logging, public
   * @name SetCpeDataUsageResetDayApiV1SetCpeDataUsageResetDayPost
   * @summary Set Cpe Data Usage Reset Day
   * @request POST:/set-cpe-data-usage-reset-day
   * @secure
   */
  setCpeDataUsageResetDayApiV1SetCpeDataUsageResetDayPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Reset Day */
      reset_day: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-cpe-data-usage-reset-day`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Push a CPE's cellular traffic limit on demand. ``enabled`` comes from this API request. If omitted, it falls back to the assigned data pool's throttle_enable. Throughput is read from the assigned data pool. If the CPE is not assigned to a data pool, push disabled/0 Mbps. If ``interface`` is omitted, the node uses its configured cellular interface.
   *
   * @tags common, admin, logging, public
   * @name ConfigureCellularTrafficLimitEndpointApiV1ConfigureCellularTrafficLimitPost
   * @summary Configure Cellular Traffic Limit Endpoint
   * @request POST:/configure-cellular-traffic-limit
   * @secure
   */
  configureCellularTrafficLimitEndpointApiV1ConfigureCellularTrafficLimitPost = (
    data: CellularTrafficLimitRequest,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-cellular-traffic-limit`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @description Return the live tc traffic-limit state from a cellular CPE.
   *
   * @tags common, readonly, tool, public
   * @name GetCellularTrafficLimitStatusApiV1GetCellularTrafficLimitStatusGet
   * @summary Get Cellular Traffic Limit Status
   * @request GET:/get-cellular-traffic-limit-status
   * @secure
   */
  getCellularTrafficLimitStatusApiV1GetCellularTrafficLimitStatusGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Interface */
      interface?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CellularTrafficLimitStatus, HTTPValidationError>({
      path: `/get-cellular-traffic-limit-status`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name NecpHealthApiV1NecpHealthGet
   * @summary Necp Health
   * @request GET:/necp-health
   * @secure
   */
  necpHealthApiV1NecpHealthGet = (params: RequestParams = {}) =>
    this.request<HealthResponse, any>({
      path: `/necp-health`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name NecpToolsApiV1NecpToolsGet
   * @summary Necp Tools
   * @request GET:/necp-tools
   * @secure
   */
  necpToolsApiV1NecpToolsGet = (params: RequestParams = {}) =>
    this.request<ToolsResponse, any>({
      path: `/necp-tools`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name NecpSkillsApiV1NecpSkillsGet
   * @summary Necp Skills
   * @request GET:/necp-skills
   * @secure
   */
  necpSkillsApiV1NecpSkillsGet = (params: RequestParams = {}) =>
    this.request<SkillsResponse, any>({
      path: `/necp-skills`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name NecpCreateSessionApiV1NecpCreateSessionPost
   * @summary Necp Create Session
   * @request POST:/necp-create-session
   * @secure
   */
  necpCreateSessionApiV1NecpCreateSessionPost = (params: RequestParams = {}) =>
    this.request<SessionInfo, any>({
      path: `/necp-create-session`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name NecpListSessionsApiV1NecpListSessionsGet
   * @summary Necp List Sessions
   * @request GET:/necp-list-sessions
   * @secure
   */
  necpListSessionsApiV1NecpListSessionsGet = (params: RequestParams = {}) =>
    this.request<SessionsResponse, any>({
      path: `/necp-list-sessions`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name NecpDeleteSessionApiV1NecpDeleteSessionPost
   * @summary Necp Delete Session
   * @request POST:/necp-delete-session
   * @secure
   */
  necpDeleteSessionApiV1NecpDeleteSessionPost = (
    query: {
      /** Session Id */
      session_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<DeletedResponse, HTTPValidationError>({
      path: `/necp-delete-session`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name NecpGetSessionHistoryApiV1NecpGetSessionHistoryGet
   * @summary Necp Get Session History
   * @request GET:/necp-get-session-history
   * @secure
   */
  necpGetSessionHistoryApiV1NecpGetSessionHistoryGet = (
    query: {
      /** Session Id */
      session_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<HistoryResponse, HTTPValidationError>({
      path: `/necp-get-session-history`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, public
   * @name NecpDiagnoseApiV1NecpDiagnosePost
   * @summary Necp Diagnose
   * @request POST:/necp-diagnose
   * @secure
   */
  necpDiagnoseApiV1NecpDiagnosePost = (data: DiagnoseRequest, params: RequestParams = {}) =>
    this.request<void, HTTPValidationError>({
      path: `/necp-diagnose`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, tool, public
   * @name StartCaptureApiV1StartCapturePost
   * @summary Start Capture
   * @request POST:/start-capture
   * @secure
   */
  startCaptureApiV1StartCapturePost = (data: PacketCapture, params: RequestParams = {}) =>
    this.request<StartCaptureResp, HTTPValidationError>({
      path: `/start-capture`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, tool, public
   * @name StopCaptureApiV1StopCapturePost
   * @summary Stop Capture
   * @request POST:/stop-capture
   * @secure
   */
  stopCaptureApiV1StopCapturePost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<StopCaptureResp, HTTPValidationError>({
      path: `/stop-capture`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, tool, public
   * @name CancelCaptureApiV1CancelCapturePost
   * @summary Cancel Capture
   * @request POST:/cancel-capture
   * @secure
   */
  cancelCaptureApiV1CancelCapturePost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CancelCaptureResp, HTTPValidationError>({
      path: `/cancel-capture`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, tool, public
   * @name GetCaptureStatusApiV1GetCaptureStatusGet
   * @summary Get Capture Status
   * @request GET:/get-capture-status
   * @secure
   */
  getCaptureStatusApiV1GetCaptureStatusGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<GetCaptureStatusResp, HTTPValidationError>({
      path: `/get-capture-status`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @description Return merged version, source checksum, and binary checksum metadata.
   *
   * @tags common, internal
   * @name UpgradeProvisioningExeMetadataApiV1UpgradeProvisioningExeMetadataGet
   * @summary Upgrade Provisioning Exe Metadata
   * @request GET:/upgrade-provisioning-exe-metadata
   */
  upgradeProvisioningExeMetadataApiV1UpgradeProvisioningExeMetadataGet = (
    query: {
      /**
       * Hardware Model
       * DMI product name of the hardware
       */
      hardware_model: string;
      /**
       * Interfaces
       * Comma-separated list of all network interfaces
       * @default ""
       */
      interfaces?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/upgrade-provisioning-exe-metadata`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });

  /**
   * @description Run a targeted tshark query against a pcap that was previously analyzed with /analyze-pcap (must be called first to download the file). Provide one or more of: display_filter (tshark -Y expression), statistics (whitelisted -z module such as 'conv,tcp' or 'dns,tree'), or fields (comma-separated tshark field names such as 'ip.src,tcp.dstport'). display_filter may be combined with either statistics or fields.
   *
   * @tags common, readonly, tool, public
   * @name QueryPcapApiV1QueryPcapGet
   * @summary Query Pcap
   * @request GET:/query-pcap
   * @secure
   */
  queryPcapApiV1QueryPcapGet = (
    query: {
      /** Document Id */
      document_id: string;
      /** Display Filter */
      display_filter?: string;
      /** Statistics */
      statistics?: string;
      /** Fields */
      fields?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<QueryPcapResp, HTTPValidationError>({
      path: `/query-pcap`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name Get3RdpartyIntegrationApiV1Get3RdpartyIntegrationGet
   * @summary Get 3Rdparty Integration
   * @request GET:/get-3rdparty-integration
   * @secure
   */
  get3RdpartyIntegrationApiV1Get3RdpartyIntegrationGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ThirdPartyIntegrationVendor[], HTTPValidationError>({
      path: `/get-3rdparty-integration`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name Configure3RdpartyIntegrationApiV1Configure3RdpartyIntegrationPost
   * @summary Configure 3Rdparty Integration
   * @request POST:/configure-3rdparty-integration
   * @secure
   */
  configure3RdpartyIntegrationApiV1Configure3RdpartyIntegrationPost = (
    data: ThirdPartyIntegrationConfigure,
    params: RequestParams = {},
  ) =>
    this.request<ThirdPartyIntegrationVendor[], HTTPValidationError>({
      path: `/configure-3rdparty-integration`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, readonly, internal
   * @name Get3RdpartyVendorConfigApiV1Get3RdpartyVendorConfigGet
   * @summary Get 3Rdparty Vendor Config
   * @request GET:/get-3rdparty-vendor-config
   * @secure
   */
  get3RdpartyVendorConfigApiV1Get3RdpartyVendorConfigGet = (
    query: {
      /** Entity Id */
      entity_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ThirdPartyIntegrationVendor[], HTTPValidationError>({
      path: `/get-3rdparty-vendor-config`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * No description
   *
   * @tags common, admin, logging, internal
   * @name Configure3RdpartyVendorConfigApiV1Configure3RdpartyVendorConfigPost
   * @summary Configure 3Rdparty Vendor Config
   * @request POST:/configure-3rdparty-vendor-config
   * @secure
   */
  configure3RdpartyVendorConfigApiV1Configure3RdpartyVendorConfigPost = (
    data: ThirdPartyVendorConfigConfigure,
    params: RequestParams = {},
  ) =>
    this.request<ThirdPartyIntegrationVendor[], HTTPValidationError>({
      path: `/configure-3rdparty-vendor-config`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}